import type { LegacyQuestion } from '../types'

export const logicQuestions: LegacyQuestion[] = [
  {
    id: 'logic_1',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Toán logic hình thức`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 1 đến 5:`,
    passageText: `Có một chuỗi gồm 7 bóng đèn trang trí xung quanh một tấm biển quảng cáo ngoài trời. Các bóng
đèn được đánh số từ 1 đến 7 và được kết nối với một mạch điện sao cho khi một số bóng đèn bật
sáng thì một số bóng đèn khác phải tắt. Trạng thái bật/tắt của các bóng đèn tuân theo các quy
tắc sau:
• Bóng đèn số 1 bật khi bóng đèn số 2 tắt.
• Bóng đèn số 3 bật khi bóng đèn số 4 bật.
• Nếu bóng đèn số 5 bật, thì bóng đèn số 1 bật và bóng đèn số 4 bật.
• Nếu bóng đèn số 6 tắt, thì bóng đèn số 2 tắt.
• Nếu bóng đèn số 7 bật, thì bóng đèn số 6 tắt.`,
    stem: `Khi bóng đèn số 7 bật, điều nào sau đây chắc chắn phải đúng?`,
    choices: [
      { id: 'A', text: `Bóng 2 tắt.` },
      { id: 'B', text: `Bóng 6 bật.` },
      { id: 'C', text: `Bóng 4 tắt.` },
      { id: 'D', text: `Bóng 5 bật.` },
    ],
    answer: 'A',
    solution: `Từ giả thiết, ta viết lại các quy tắc kéo theo:
(1) 2 tắt ➔ 1 bật. (Tương đương: 1 tắt ➔ 2 bật).
(2) 4 bật ➔ 3 bật. (Tương đương: 3 tắt ➔ 4 tắt).
(3) 5 bật ➔ 1 bật VÀ 4 bật.
(4) 6 tắt ➔ 2 tắt. (Tương đương: 2 bật ➔ 6 bật).
(5) 7 bật ➔ 6 tắt. (Tương đương: 6 bật ➔ 7 tắt).

Theo đề bài: Bóng 7 bật.
Áp dụng (5): 7 bật ➔ 6 tắt. (Bóng 6 chắc chắn tắt).
Áp dụng (4): 6 tắt ➔ 2 tắt. (Bóng 2 chắc chắn tắt).
Áp dụng (1): 2 tắt ➔ 1 bật. (Bóng 1 chắc chắn bật).

Kiểm tra các đáp án:
A. Bóng 2 tắt. (Chắc chắn ĐÚNG).
B. Bóng 6 bật. (SAI, vì bóng 6 phải tắt).
C. Bóng 4 tắt. (Không có đủ dữ kiện để khẳng định).
D. Bóng 5 bật. (Không có đủ dữ kiện để khẳng định).

**Chọn A.**`,
    hint1: `Viết các quy tắc dưới dạng suy luận (A kéo theo B). Bắt đầu từ "Bóng 7 bật" và tìm chuỗi phản ứng dây chuyền.`,
    hint2: `7 bật ➔ 6 tắt ➔ 2 tắt ➔ 1 bật. Vậy bóng 2 chắc chắn tắt.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_2',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Toán logic hình thức`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 1 đến 5:`,
    passageText: `Có một chuỗi gồm 7 bóng đèn trang trí xung quanh một tấm biển quảng cáo ngoài trời. Các bóng
đèn được đánh số từ 1 đến 7 và được kết nối với một mạch điện sao cho khi một số bóng đèn bật
sáng thì một số bóng đèn khác phải tắt. Trạng thái bật/tắt của các bóng đèn tuân theo các quy
tắc sau:
• Bóng đèn số 1 bật khi bóng đèn số 2 tắt.
• Bóng đèn số 3 bật khi bóng đèn số 4 bật.
• Nếu bóng đèn số 5 bật, thì bóng đèn số 1 bật và bóng đèn số 4 bật.
• Nếu bóng đèn số 6 tắt, thì bóng đèn số 2 tắt.
• Nếu bóng đèn số 7 bật, thì bóng đèn số 6 tắt.`,
    stem: `Khi bóng đèn số 5 bật, điều nào sau đây KHÔNG THỂ đúng?`,
    choices: [
      { id: 'A', text: `Bóng 4 bật.` },
      { id: 'B', text: `Bóng 1 bật.` },
      { id: 'C', text: `Bóng 6 tắt.` },
      { id: 'D', text: `Bóng 3 tắt.` },
    ],
    answer: 'D',
    solution: `Tóm tắt các quy tắc:
(1) 2 tắt ➔ 1 bật. 
(2) 4 bật ➔ 3 bật. 
(3) 5 bật ➔ 1 bật VÀ 4 bật.
(4) 6 tắt ➔ 2 tắt. 
(5) 7 bật ➔ 6 tắt. 

Đề bài cho: Bóng 5 bật.
Áp dụng (3): 5 bật ➔ 1 bật VÀ 4 bật.
Áp dụng (2): Từ 4 bật ➔ 3 bật.
Như vậy, khi bóng 5 bật thì các bóng 1, 4, 3 CHẮC CHẮN PHẢI BẬT.
Do đó, điều KHÔNG THỂ xảy ra là bóng 3 tắt.

**Chọn D.**`,
    hint1: `Bóng 5 bật sẽ kích hoạt điều kiện nào trong các quy tắc?`,
    hint2: `5 bật ➔ 4 bật. Mà 4 bật ➔ 3 bật. Do đó bóng 3 không thể tắt.`,
    estimatedSeconds: 30,
    tags: ["logic"]
  },
  {
    id: 'logic_3',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Toán logic hình thức`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 1 đến 5:`,
    passageText: `Có một chuỗi gồm 7 bóng đèn trang trí xung quanh một tấm biển quảng cáo ngoài trời. Các bóng
đèn được đánh số từ 1 đến 7 và được kết nối với một mạch điện sao cho khi một số bóng đèn bật
sáng thì một số bóng đèn khác phải tắt. Trạng thái bật/tắt của các bóng đèn tuân theo các quy
tắc sau:
• Bóng đèn số 1 bật khi bóng đèn số 2 tắt.
• Bóng đèn số 3 bật khi bóng đèn số 4 bật.
• Nếu bóng đèn số 5 bật, thì bóng đèn số 1 bật và bóng đèn số 4 bật.
• Nếu bóng đèn số 6 tắt, thì bóng đèn số 2 tắt.
• Nếu bóng đèn số 7 bật, thì bóng đèn số 6 tắt.`,
    stem: `Nếu bóng đèn số 1 tắt, thì điều nào sau đây CÓ THỂ đúng?`,
    choices: [
      { id: 'A', text: `Bóng 5 bật.` },
      { id: 'B', text: `Bóng 2 tắt.` },
      { id: 'C', text: `Bóng 3 tắt.` },
      { id: 'D', text: `Bóng 7 bật.` },
    ],
    answer: 'C',
    solution: `Ta vận dụng các quy tắc (lấy mệnh đề phản đảo khi cần):
(1) 2 tắt ➔ 1 bật => Đảo lại: 1 tắt ➔ 2 bật.
(3) 5 bật ➔ 1 bật => Đảo lại: 1 tắt ➔ 5 tắt.
(4) 6 tắt ➔ 2 tắt => Đảo lại: 2 bật ➔ 6 bật.
(5) 7 bật ➔ 6 tắt => Đảo lại: 6 bật ➔ 7 tắt.

Khi bóng 1 tắt, ta có chuỗi suy luận sau:
1 tắt ➔ 2 bật ➔ 6 bật ➔ 7 tắt.
Và 1 tắt ➔ 5 tắt.
Như vậy, trạng thái các bóng 2, 5, 6, 7 đã được xác định:
- Bóng 2 bật (Loại B vì B nói bóng 2 tắt).
- Bóng 5 tắt (Loại A vì A nói bóng 5 bật).
- Bóng 6 bật.
- Bóng 7 tắt (Loại D vì D nói bóng 7 bật).
Riêng bóng 3 và 4 không bị ràng buộc bởi các điều kiện trên, nên "Bóng 3 tắt" là điều CÓ THỂ xảy ra.

**Chọn C.**`,
    hint1: `Dùng mệnh đề phản đảo (A ➔ B thì Không B ➔ Không A). Ví dụ: Vì "2 tắt ➔ 1 bật" nên nếu "1 tắt" thì "2 không tắt" (tức là 2 bật).`,
    hint2: `Từ bóng 1 tắt ➔ 2 bật ➔ 6 bật ➔ 7 tắt. Và 1 tắt ➔ 5 tắt. Chỉ có bóng 3 tắt là không mâu thuẫn nên có thể xảy ra.`,
    estimatedSeconds: 45,
    tags: ["logic"]
  },
  {
    id: 'logic_4',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Toán logic hình thức`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 1 đến 5:`,
    passageText: `Có một chuỗi gồm 7 bóng đèn trang trí xung quanh một tấm biển quảng cáo ngoài trời. Các bóng
đèn được đánh số từ 1 đến 7 và được kết nối với một mạch điện sao cho khi một số bóng đèn bật
sáng thì một số bóng đèn khác phải tắt. Trạng thái bật/tắt của các bóng đèn tuân theo các quy
tắc sau:
• Bóng đèn số 1 bật khi bóng đèn số 2 tắt.
• Bóng đèn số 3 bật khi bóng đèn số 4 bật.
• Nếu bóng đèn số 5 bật, thì bóng đèn số 1 bật và bóng đèn số 4 bật.
• Nếu bóng đèn số 6 tắt, thì bóng đèn số 2 tắt.
• Nếu bóng đèn số 7 bật, thì bóng đèn số 6 tắt.`,
    stem: `Khi bóng đèn số 5 tắt, điều nào sau đây KHÔNG THỂ đúng?`,
    choices: [
      { id: 'A', text: `Bóng 1 và 2 đều bật.` },
      { id: 'B', text: `Bóng 3 và 7 đều tắt.` },
      { id: 'C', text: `Bóng 4 và 6 đều bật.` },
      { id: 'D', text: `Bóng 7 và 2 đều bật.` },
    ],
    answer: 'D',
    solution: `Để tìm điều KHÔNG THỂ đúng, ta xem xét các đáp án xem có đáp án nào chứa mâu thuẫn nội tại giữa các bóng đèn (độc lập với trạng thái bóng 5).
Xét quy tắc:
(5) 7 bật ➔ 6 tắt.
(4) 6 tắt ➔ 2 tắt.
Suy ra chuỗi: 7 bật ➔ 6 tắt ➔ 2 tắt.
Vậy nếu bóng 7 bật, thì bắt buộc bóng 2 phải tắt.
Điều này có nghĩa là "Bóng 7 và bóng 2 cùng bật" là mâu thuẫn, KHÔNG THỂ xảy ra trong bất kỳ trường hợp nào, bất kể bóng 5 bật hay tắt.

**Chọn D.**`,
    hint1: `Có một đáp án chứa hai trạng thái tự mâu thuẫn với nhau theo quy tắc, độc lập với việc bóng 5 tắt. Thử liên kết quy tắc của bóng 7 và bóng 2.`,
    hint2: `7 bật ➔ 6 tắt ➔ 2 tắt. Do đó bóng 7 bật thì bóng 2 không thể bật. Đáp án D sai hoàn toàn.`,
    estimatedSeconds: 30,
    tags: ["logic"]
  },
  {
    id: 'logic_5',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Toán logic hình thức`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 1 đến 5:`,
    passageText: `Có một chuỗi gồm 7 bóng đèn trang trí xung quanh một tấm biển quảng cáo ngoài trời. Các bóng
đèn được đánh số từ 1 đến 7 và được kết nối với một mạch điện sao cho khi một số bóng đèn bật
sáng thì một số bóng đèn khác phải tắt. Trạng thái bật/tắt của các bóng đèn tuân theo các quy
tắc sau:
• Bóng đèn số 1 bật khi bóng đèn số 2 tắt.
• Bóng đèn số 3 bật khi bóng đèn số 4 bật.
• Nếu bóng đèn số 5 bật, thì bóng đèn số 1 bật và bóng đèn số 4 bật.
• Nếu bóng đèn số 6 tắt, thì bóng đèn số 2 tắt.
• Nếu bóng đèn số 7 bật, thì bóng đèn số 6 tắt.`,
    stem: `Nếu bóng đèn 1 bị tắt, thì trạng thái của bao nhiêu bóng đèn khác sẽ bị ảnh hưởng (tức là
chắc chắn xác định được trạng thái)?`,
    choices: [
      { id: 'A', text: `1.` },
      { id: 'B', text: `2.` },
      { id: 'C', text: `3.` },
      { id: 'D', text: `4.` },
    ],
    answer: 'D',
    solution: `Như đã phân tích ở câu trước, áp dụng mệnh đề phản đảo (A ➔ B thì Sai B ➔ Sai A):
- Vì (2 tắt ➔ 1 bật) nên: 1 tắt ➔ 2 bật.
- Vì (5 bật ➔ 1 bật) nên: 1 tắt ➔ 5 tắt.
Tiếp tục suy diễn từ bóng 2 bật:
- Vì (6 tắt ➔ 2 tắt) nên: 2 bật ➔ 6 bật.
- Vì (7 bật ➔ 6 tắt) nên: 6 bật ➔ 7 tắt.
Tổng hợp lại, khi bóng 1 tắt, có 4 bóng đèn khác CHẮC CHẮN xác định được trạng thái là: 2 bật, 5 tắt, 6 bật, 7 tắt.
Các bóng 3, 4 không bị ràng buộc (chỉ có 4 bật ➔ 3 bật, nhưng không suy ra được từ các điều kiện trên).
Vậy có 4 bóng đèn bị ảnh hưởng.

**Chọn D (4).**`,
    hint1: `Dùng suy luận phản đảo (A ➔ B thì Không B ➔ Không A) để tìm chuỗi ảnh hưởng khi bóng 1 tắt.`,
    hint2: `1 tắt ➔ 2 bật và 5 tắt. Từ 2 bật ➔ 6 bật ➔ 7 tắt. Vậy có 4 bóng bị ảnh hưởng (2, 5, 6, 7).`,
    estimatedSeconds: 30,
    tags: ["logic"]
  },
  {
    id: 'logic_6',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Toán logic hình thức`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 6 đến 10:`,
    passageText: `Tại một câu lạc bộ bơi lội, một nhóm thanh thiếu niên đang tranh nhau xuống hồ bơi. Huấn
luyện viên biết rằng một số bạn không thể xuống hồ bơi cùng lúc để đảm bảo trật tự. Nhóm gồm
có An, Bình, Cường, Dung, Ân, Phong, và Giang. Việc một bạn được xuống hồ bơi hay không
tuân theo các quy tắc sau:
• An xuống hồ bơi chỉ khi Cường xuống hồ bơi.
• Nếu Bình xuống hồ bơi, thì Cường cũng xuống hồ bơi.
• An xuống hồ bơi nếu Dung xuống hồ bơi.
• Giang xuống hồ bơi chỉ khi Cường và Ân cùng xuống hồ bơi.
• Bình xuống hồ bơi nếu Giang xuống hồ bơi.
• Nếu Giang không xuống hồ bơi, thì Dung cũng không xuống hồ bơi.`,
    stem: `Nhóm nào sau đây có thể là danh sách tất cả những người ở trong hồ bơi cùng lúc?`,
    choices: [
      { id: 'A', text: `Dung, Ân, Cường, Bình.` },
      { id: 'B', text: `Giang, Ân, Bình, Cường.` },
      { id: 'C', text: `Bình, Giang, Ân, Dung.` },
      { id: 'D', text: `Dung, Cường, An, Giang.` },
    ],
    answer: 'B',
    solution: `Tóm tắt các quy tắc (kí hiệu "➔" là "thì"):
(1) An ➔ Cường.
(2) Bình ➔ Cường.
(3) Dung ➔ An.
(4) Giang ➔ Cường VÀ Ân.
(5) Giang ➔ Bình.
(6) Không Giang ➔ Không Dung (tương đương với mệnh đề phản đảo: Dung ➔ Giang).

Phân tích các đáp án:
- A sai vì có Dung nhưng thiếu An (Quy tắc 3: Dung ➔ An) và thiếu Giang (Quy tắc 6: Dung ➔ Giang).
- C sai vì có Dung nhưng thiếu Cường và An (Dung ➔ An ➔ Cường).
- D sai vì có Giang nhưng thiếu Bình (Quy tắc 5: Giang ➔ Bình) và thiếu Ân (Quy tắc 4: Giang ➔ Ân).
- B hợp lệ: Giang kéo theo Bình, Cường, Ân đều có mặt. An và Dung không có mặt (không vi phạm quy tắc nào).

**Chọn B.**`,
    hint1: `Viết các quy tắc dưới dạng mũi tên suy luận. Lưu ý "A nếu B" nghĩa là B ➔ A. Và "Không A ➔ Không B" tương đương B ➔ A.`,
    hint2: `Từ các quy tắc, ta thấy Giang xuống hồ bơi thì Bình, Cường, Ân phải xuống. Đáp án B có đủ nhóm này.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_7',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Toán logic hình thức`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 6 đến 10:`,
    passageText: `Tại một câu lạc bộ bơi lội, một nhóm thanh thiếu niên đang tranh nhau xuống hồ bơi. Huấn
luyện viên biết rằng một số bạn không thể xuống hồ bơi cùng lúc để đảm bảo trật tự. Nhóm gồm
có An, Bình, Cường, Dung, Ân, Phong, và Giang. Việc một bạn được xuống hồ bơi hay không
tuân theo các quy tắc sau:
• An xuống hồ bơi chỉ khi Cường xuống hồ bơi.
• Nếu Bình xuống hồ bơi, thì Cường cũng xuống hồ bơi.
• An xuống hồ bơi nếu Dung xuống hồ bơi.
• Giang xuống hồ bơi chỉ khi Cường và Ân cùng xuống hồ bơi.
• Bình xuống hồ bơi nếu Giang xuống hồ bơi.
• Nếu Giang không xuống hồ bơi, thì Dung cũng không xuống hồ bơi.`,
    stem: `Nếu Dung ở trong hồ bơi, thì có tối thiểu bao nhiêu người (bao gồm cả Dung) bắt buộc
phải ở trong hồ bơi?`,
    choices: [
      { id: 'A', text: `4.` },
      { id: 'B', text: `5.` },
      { id: 'C', text: `6.` },
      { id: 'D', text: `7.` },
    ],
    answer: 'C',
    solution: `Nếu Dung ở trong hồ bơi, ta có chuỗi phản ứng dây chuyền như sau:
- Từ (3) Dung ➔ An. Vậy An cũng ở trong hồ bơi.
- Từ (1) An ➔ Cường. Vậy Cường ở trong hồ bơi.
- Từ (6) Dung ➔ Giang. Vậy Giang ở trong hồ bơi.
- Từ (5) Giang ➔ Bình. Vậy Bình ở trong hồ bơi.
- Từ (4) Giang ➔ Ân (và Cường). Vậy Ân cũng ở trong hồ bơi.

Tổng kết lại: Nếu Dung xuống hồ bơi, thì An, Cường, Giang, Bình, Ân đều BẮT BUỘC phải xuống hồ bơi.
Chỉ còn lại Phong là không bị ràng buộc (có thể xuống hoặc không).
Vậy nhóm này chắc chắn có tối thiểu 6 người (Dung, An, Cường, Giang, Bình, Ân).

**Chọn C (6).**`,
    hint1: `Bắt đầu từ Dung, lần lượt áp dụng tất cả các quy tắc kéo theo để xem những ai bị ép buộc phải xuống hồ bơi.`,
    hint2: `Dung ➔ An ➔ Cường. Dung ➔ Giang ➔ Bình và Ân. Tổng cộng có 6 người.`,
    estimatedSeconds: 30,
    tags: ["logic"]
  },
  {
    id: 'logic_8',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Toán logic hình thức`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 6 đến 10:`,
    passageText: `Tại một câu lạc bộ bơi lội, một nhóm thanh thiếu niên đang tranh nhau xuống hồ bơi. Huấn
luyện viên biết rằng một số bạn không thể xuống hồ bơi cùng lúc để đảm bảo trật tự. Nhóm gồm
có An, Bình, Cường, Dung, Ân, Phong, và Giang. Việc một bạn được xuống hồ bơi hay không
tuân theo các quy tắc sau:
• An xuống hồ bơi chỉ khi Cường xuống hồ bơi.
• Nếu Bình xuống hồ bơi, thì Cường cũng xuống hồ bơi.
• An xuống hồ bơi nếu Dung xuống hồ bơi.
• Giang xuống hồ bơi chỉ khi Cường và Ân cùng xuống hồ bơi.
• Bình xuống hồ bơi nếu Giang xuống hồ bơi.
• Nếu Giang không xuống hồ bơi, thì Dung cũng không xuống hồ bơi.`,
    stem: `Nếu Phong ở trong hồ bơi, thì số người ít nhất (bao gồm cả Phong) có thể ở trong hồ bơi
là bao nhiêu?`,
    choices: [
      { id: 'A', text: `1.` },
      { id: 'B', text: `2.` },
      { id: 'C', text: `3.` },
      { id: 'D', text: `4.` },
    ],
    answer: 'A',
    solution: `Ta xét trường hợp Phong là người duy nhất ở trong hồ bơi, tức là cả 6 người còn lại (An, Bình, Cường, Dung, Ân, Giang) đều KHÔNG xuống hồ bơi.
Kiểm tra xem điều này có vi phạm quy tắc nào không:
(1) An ➔ Cường: An không xuống nên mệnh đề không bị vi phạm.
(2) Bình ➔ Cường: Bình không xuống nên không vi phạm.
(3) Dung ➔ An: Dung không xuống nên không vi phạm.
(4) Giang ➔ Cường và Ân: Giang không xuống nên không vi phạm.
(5) Giang ➔ Bình: Giang không xuống nên không vi phạm.
(6) Không Giang ➔ Không Dung: Giang không xuống (đúng) ➔ Dung không xuống (đúng). Không vi phạm.

Do không có quy tắc nào bắt buộc Phong phải kéo theo ai khác, nên hoàn toàn có thể chỉ có 1 mình Phong trong hồ bơi.

**Chọn A (1).**`,
    hint1: `Xem xét xem Phong có nằm trong bất kỳ điều kiện kéo theo (bắt buộc ai khác) nào không.`,
    hint2: `Phong không bị ràng buộc bởi bất kỳ ai và cũng không ràng buộc ai. Vậy Phong có thể xuống một mình.`,
    estimatedSeconds: 30,
    tags: ["logic"]
  },
  {
    id: 'logic_9',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Toán logic hình thức`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 6 đến 10:`,
    passageText: `Tại một câu lạc bộ bơi lội, một nhóm thanh thiếu niên đang tranh nhau xuống hồ bơi. Huấn
luyện viên biết rằng một số bạn không thể xuống hồ bơi cùng lúc để đảm bảo trật tự. Nhóm gồm
có An, Bình, Cường, Dung, Ân, Phong, và Giang. Việc một bạn được xuống hồ bơi hay không
tuân theo các quy tắc sau:
• An xuống hồ bơi chỉ khi Cường xuống hồ bơi.
• Nếu Bình xuống hồ bơi, thì Cường cũng xuống hồ bơi.
• An xuống hồ bơi nếu Dung xuống hồ bơi.
• Giang xuống hồ bơi chỉ khi Cường và Ân cùng xuống hồ bơi.
• Bình xuống hồ bơi nếu Giang xuống hồ bơi.
• Nếu Giang không xuống hồ bơi, thì Dung cũng không xuống hồ bơi.`,
    stem: `Nếu Cường không ở trong hồ bơi, thì ai có thể ở trong hồ bơi?`,
    choices: [
      { id: 'A', text: `An.` },
      { id: 'B', text: `Ân.` },
      { id: 'C', text: `Giang.` },
      { id: 'D', text: `Dung.` },
    ],
    answer: 'B',
    solution: `Sử dụng mệnh đề phản đảo (A ➔ B thì Không B ➔ Không A) khi Cường KHÔNG ở trong hồ bơi:
- Vì (1) An ➔ Cường nên Cường không xuống ➔ An không xuống.
- Vì (2) Bình ➔ Cường nên Cường không xuống ➔ Bình không xuống.
- Vì (4) Giang ➔ Cường nên Cường không xuống ➔ Giang không xuống.
- Vì (6) Dung ➔ Giang nên Giang không xuống ➔ Dung không xuống.

Vậy nếu Cường không ở trong hồ bơi, thì An, Bình, Giang và Dung cũng CHẮC CHẮN KHÔNG ở trong hồ bơi.
Chỉ còn Ân và Phong là không bị kéo theo điều kiện "phải nghỉ" này. 
Đối chiếu các đáp án, chỉ có Ân là người CÓ THỂ ở trong hồ bơi.

**Chọn B.**`,
    hint1: `Dùng phản đảo: Cường nghỉ thì tất cả những ai có mũi tên hướng về Cường đều phải nghỉ theo.`,
    hint2: `Cường nghỉ ➔ An, Bình, Giang nghỉ. Giang nghỉ ➔ Dung nghỉ. Chỉ có Ân (và Phong) không bị ảnh hưởng.`,
    estimatedSeconds: 30,
    tags: ["logic"]
  },
  {
    id: 'logic_10',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Toán logic hình thức`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 6 đến 10:`,
    passageText: `Tại một câu lạc bộ bơi lội, một nhóm thanh thiếu niên đang tranh nhau xuống hồ bơi. Huấn
luyện viên biết rằng một số bạn không thể xuống hồ bơi cùng lúc để đảm bảo trật tự. Nhóm gồm
có An, Bình, Cường, Dung, Ân, Phong, và Giang. Việc một bạn được xuống hồ bơi hay không
tuân theo các quy tắc sau:
• An xuống hồ bơi chỉ khi Cường xuống hồ bơi.
• Nếu Bình xuống hồ bơi, thì Cường cũng xuống hồ bơi.
• An xuống hồ bơi nếu Dung xuống hồ bơi.
• Giang xuống hồ bơi chỉ khi Cường và Ân cùng xuống hồ bơi.
• Bình xuống hồ bơi nếu Giang xuống hồ bơi.
• Nếu Giang không xuống hồ bơi, thì Dung cũng không xuống hồ bơi.`,
    stem: `Nếu có chính xác 2 bạn KHÔNG ở trong hồ bơi, thì ai bắt buộc phải không ở trong hồ
bơi?`,
    choices: [
      { id: 'A', text: `Bình.` },
      { id: 'B', text: `Cường.` },
      { id: 'C', text: `Dung.` },
      { id: 'D', text: `Ân.` },
    ],
    answer: 'C',
    solution: `Nhóm có 7 người, nếu có chính xác 2 người KHÔNG ở trong hồ bơi (tức là có đúng 5 người xuống). Ta đi tìm xem ai BẮT BUỘC phải nghỉ.
Giả sử Dung xuống hồ bơi. Theo phân tích ở câu 7, Dung xuống sẽ kéo theo Giang, An, Cường, Bình, Ân (tổng cộng 6 người). Khi đó chỉ có tối đa 1 người nghỉ (là Phong). Điều này mâu thuẫn với dữ kiện "chính xác 2 bạn nghỉ".
Vì vậy, Dung KHÔNG THỂ xuống hồ bơi. Hay nói cách khác, Dung BẮT BUỘC phải là một trong 2 người nghỉ.

Kiểm tra xem trường hợp Dung nghỉ có thỏa mãn không:
Nếu Dung nghỉ, còn đúng 1 người nữa nghỉ. Ta có thể cho Giang nghỉ (vậy 2 người nghỉ là Dung, Giang). 5 người còn lại (An, Bình, Cường, Ân, Phong) xuống hồ bơi. Ta thấy không vi phạm bất kỳ quy tắc nào.
Hoặc cho An nghỉ (2 người nghỉ là Dung, An). 5 người còn lại (Giang, Bình, Cường, Ân, Phong) xuống. Cũng không vi phạm quy tắc nào.
Vậy trong mọi cấu hình thỏa mãn 2 người nghỉ, Dung luôn phải nghỉ.

**Chọn C.**`,
    hint1: `Nhớ lại câu trước, nếu Dung xuống thì điều gì xảy ra? Nếu Dung xuống thì kéo theo tới 5 người khác cùng xuống, số người nghỉ sẽ không thể là 2.`,
    hint2: `Dung xuống ➔ 6 người xuống (chỉ 1 người nghỉ). Mà đề yêu cầu đúng 2 người nghỉ, nên Dung không thể xuống.`,
    estimatedSeconds: 45,
    tags: ["logic"]
  },
  {
    id: 'logic_11',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Toán logic hình thức`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 11 đến 14:`,
    passageText: `Một người nuôi cá quyết định chọn một số con cá xiêm để thả vào bể. Có 7 con cá được đặt tên
là An, Bình, Cường, Dung, Ân, Phong, và Giang. Do một số con cá không hòa thuận, chủ nhân
của chúng phải tuân theo các quy tắc sau:
• Nếu An được thả vào bể, thì Phong bị loại.
• Nếu Cường bị loại, thì An được thả vào và Bình được thả vào.
• Nếu Ân bị loại, thì Cường bị loại.
• Nếu Dung được thả vào bể, thì Ân bị loại.`,
    stem: `Nhóm cá nào sau đây có thể được thả vào bể cùng nhau?`,
    choices: [
      { id: 'A', text: `Ân, Phong, An, Bình.` },
      { id: 'B', text: `Giang, Cường, Ân, Phong.` },
      { id: 'C', text: `Dung, Bình, Ân, Cường.` },
      { id: 'D', text: `Cường, Phong, Dung.` },
    ],
    answer: 'B',
    solution: `Tóm tắt các quy tắc:
(1) An thả ➔ Phong loại.
(2) Cường loại ➔ An thả VÀ Bình thả.
(3) Ân loại ➔ Cường loại.
(4) Dung thả ➔ Ân loại.

Ta tìm phương án thỏa mãn TẤT CẢ quy tắc (không vi phạm):
- A sai vì có cả An và Phong (Vi phạm quy tắc 1: An thả ➔ Phong loại).
- C sai vì có Dung và Ân (Vi phạm quy tắc 4: Dung thả ➔ Ân loại).
- D sai vì có Dung và Cường. Từ (4) Dung thả ➔ Ân loại. Từ (3) Ân loại ➔ Cường loại. Vậy Dung thả ➔ Cường loại. Nhưng D lại có Cường. (Vi phạm).
- B hợp lệ vì Giang, Cường, Ân, Phong được thả; An, Bình, Dung bị loại. 
Kiểm tra B: An không thả (1 thỏa). Cường thả (2 thỏa). Ân thả (3 thỏa). Dung không thả (4 thỏa).

**Chọn B.**`,
    hint1: `Viết chuỗi suy luận: Dung thả ➔ Ân loại ➔ Cường loại ➔ An và Bình thả ➔ Phong loại. Dựa vào đó để loại trừ.`,
    hint2: `Từ chuỗi trên: Không thể có mặt (Dung và Ân), (Dung và Cường), (An và Phong). Chỉ có B thỏa mãn.`,
    estimatedSeconds: 45,
    tags: ["logic"]
  },
  {
    id: 'logic_12',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Toán logic hình thức`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 11 đến 14:`,
    passageText: `Một người nuôi cá quyết định chọn một số con cá xiêm để thả vào bể. Có 7 con cá được đặt tên
là An, Bình, Cường, Dung, Ân, Phong, và Giang. Do một số con cá không hòa thuận, chủ nhân
của chúng phải tuân theo các quy tắc sau:
• Nếu An được thả vào bể, thì Phong bị loại.
• Nếu Cường bị loại, thì An được thả vào và Bình được thả vào.
• Nếu Ân bị loại, thì Cường bị loại.
• Nếu Dung được thả vào bể, thì Ân bị loại.`,
    stem: `Con cá nào có thể được thả vào bể bất kể sự có mặt của các con cá khác?`,
    choices: [
      { id: 'A', text: `Cường.` },
      { id: 'B', text: `Dung.` },
      { id: 'C', text: `Phong.` },
      { id: 'D', text: `Giang.` },
    ],
    answer: 'D',
    solution: `Dựa vào các quy tắc:
(1) An thả ➔ Phong loại.
(2) Cường loại ➔ An thả VÀ Bình thả.
(3) Ân loại ➔ Cường loại.
(4) Dung thả ➔ Ân loại.

Quan sát thấy con cá "Giang" không xuất hiện trong bất kỳ quy tắc nào.
Do đó, trạng thái (thả hay loại) của Giang hoàn toàn độc lập, không bị kéo theo bởi bất kỳ con cá nào, và cũng không bắt buộc bất kỳ con cá nào khác phải thả/loại.
Vậy Giang có thể được thả vào bể bất kể sự có mặt của các con cá khác.

**Chọn D.**`,
    hint1: `Tìm con cá không hề bị nhắc đến trong bất kỳ quy tắc ràng buộc nào.`,
    hint2: `Giang không xuất hiện trong điều kiện nào, nên trạng thái của Giang hoàn toàn tự do.`,
    estimatedSeconds: 30,
    tags: ["logic"]
  },
  {
    id: 'logic_13',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Toán logic hình thức`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 11 đến 14:`,
    passageText: `Một người nuôi cá quyết định chọn một số con cá xiêm để thả vào bể. Có 7 con cá được đặt tên
là An, Bình, Cường, Dung, Ân, Phong, và Giang. Do một số con cá không hòa thuận, chủ nhân
của chúng phải tuân theo các quy tắc sau:
• Nếu An được thả vào bể, thì Phong bị loại.
• Nếu Cường bị loại, thì An được thả vào và Bình được thả vào.
• Nếu Ân bị loại, thì Cường bị loại.
• Nếu Dung được thả vào bể, thì Ân bị loại.`,
    stem: `Số lượng cá tối đa có thể được thả vào bể cùng một lúc là bao nhiêu?`,
    choices: [
      { id: 'A', text: `3.` },
      { id: 'B', text: `4.` },
      { id: 'C', text: `5.` },
      { id: 'D', text: `6.` },
    ],
    answer: 'C',
    solution: `Ta muốn số lượng cá thả (IN) là tối đa, tức là số lượng cá loại (OFF) là tối thiểu.
Chuỗi quy tắc: Dung IN ➔ Ân OFF ➔ Cường OFF ➔ An IN, Bình IN ➔ Phong OFF.
Nếu Dung IN, sẽ có ít nhất 3 cá bị loại (Ân, Cường, Phong). Số cá IN tối đa là 7 - 3 = 4.

Thử cho Dung OFF. Ta cần các con cá khác IN càng nhiều càng tốt.
- Nếu An IN ➔ Phong OFF. Vậy giữa An và Phong không thể cùng IN.
=> Bắt buộc có ít nhất 1 trong 2 con phải OFF.
Cộng thêm Dung OFF, ta có ít nhất 2 con cá phải OFF.
Vậy số lượng cá IN tối đa là 7 - 2 = 5 con.

Kiểm tra nhóm 5 con IN: An, Bình, Cường, Ân, Giang.
(OFF là Dung, Phong).
- An IN ➔ Phong OFF (Đúng).
- Cường loại ➔ ... (Cường IN, không xét).
- Ân loại ➔ ... (Ân IN, không xét).
- Dung thả ➔ ... (Dung OFF, không xét).
Nhóm 5 con này thỏa mãn tất cả quy tắc.

**Chọn C (5).**`,
    hint1: `Để số cá IN là tối đa thì số cá OFF là tối thiểu. Cố gắng tránh kích hoạt các điều kiện bắt buộc loại nhiều cá.`,
    hint2: `Dung thả sẽ làm 3 cá bị loại. An thả làm Phong bị loại. Để tối đa, loại Dung và Phong, giữ lại 5 cá.`,
    estimatedSeconds: 45,
    tags: ["logic"]
  },
  {
    id: 'logic_14',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Toán logic hình thức`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 11 đến 14:`,
    passageText: `Một người nuôi cá quyết định chọn một số con cá xiêm để thả vào bể. Có 7 con cá được đặt tên
là An, Bình, Cường, Dung, Ân, Phong, và Giang. Do một số con cá không hòa thuận, chủ nhân
của chúng phải tuân theo các quy tắc sau:
• Nếu An được thả vào bể, thì Phong bị loại.
• Nếu Cường bị loại, thì An được thả vào và Bình được thả vào.
• Nếu Ân bị loại, thì Cường bị loại.
• Nếu Dung được thả vào bể, thì Ân bị loại.`,
    stem: `Nếu Cường bị loại khỏi bể, điều nào sau đây chắc chắn đúng?`,
    choices: [
      { id: 'A', text: `An ở trong bể và Ân bị loại.` },
      { id: 'B', text: `Phong bị loại.` },
      { id: 'C', text: `Ân ở trong bể.` },
      { id: 'D', text: `Dung bị loại và Bình ở trong bể.` },
    ],
    answer: 'B',
    solution: `Khi Cường bị loại (Cường OFF):
Áp dụng quy tắc (2): Cường OFF ➔ An IN và Bình IN.
Tiếp tục áp dụng quy tắc (1): An IN ➔ Phong OFF (Phong bị loại).
Vậy ta chắc chắn: An thả, Bình thả, Phong bị loại.
Quy tắc (3) nói "Ân loại ➔ Cường loại" chứ không phải ngược lại, nên Cường loại không bắt buộc Ân loại. Ân và Dung có thể thả hoặc loại.

Xét các đáp án:
A. Ân bị loại (Chưa chắc chắn).
B. Phong bị loại (CHẮC CHẮN ĐÚNG).
C. Ân ở trong bể (Chưa chắc chắn).
D. Dung bị loại (Chưa chắc chắn).

**Chọn B.**`,
    hint1: `Cường bị loại ➔ An và Bình vào bể. Có An vào bể thì sao?`,
    hint2: `An vào bể thì Phong phải bị loại. Vậy Cường bị loại chắc chắn kéo theo Phong bị loại.`,
    estimatedSeconds: 30,
    tags: ["logic"]
  },
  {
    id: 'logic_15',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Toán logic hình thức`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 15 đến 18:`,
    passageText: `Một nhóm thực tập sinh ca sĩ được chọn từ một nhóm ứng viên gồm An, Bình, Cường, Dung,
Ân, Phong, Giang, và Hoa. Để đảm bảo sự hài hòa của nhóm nhạc, việc lựa chọn tuân theo các
quy tắc:
• Nếu Hoa không được chọn, thì Ân được chọn.
• Nếu Dung được chọn, thì Phong, Cường, và An đều được chọn.
• Nếu Giang được chọn, thì Ân không được chọn.
• Nếu An được chọn, thì Bình, Phong, và Giang đều được chọn.`,
    stem: `Nhóm nào sau đây có thể là danh sách đầy đủ những người được chọn?`,
    choices: [
      { id: 'A', text: `An, Phong, Giang, Hoa.` },
      { id: 'B', text: `Giang, Ân, Hoa.` },
      { id: 'C', text: `Dung, Phong, An, Bình, Giang, Hoa.` },
      { id: 'D', text: `Bình, Phong, Giang, Hoa.` },
    ],
    answer: 'D',
    solution: `Tóm tắt các quy tắc:
(1) Không Hoa ➔ Ân (Tương đương: Không Ân ➔ Hoa).
(2) Dung ➔ Phong VÀ Cường VÀ An.
(3) Giang ➔ Không Ân.
(4) An ➔ Bình VÀ Phong VÀ Giang.

Kiểm tra các phương án (danh sách ĐẦY ĐỦ người được chọn):
A. An, Phong, Giang, Hoa: Có An nhưng lại THIẾU Bình (Vi phạm quy tắc 4: An ➔ Bình).
B. Giang, Ân, Hoa: Có Giang nhưng lại CÓ Ân (Vi phạm quy tắc 3: Giang ➔ Không Ân).
C. Dung, Phong, An, Bình, Giang, Hoa: Có Dung nhưng lại THIẾU Cường (Vi phạm quy tắc 2: Dung ➔ Cường).
D. Bình, Phong, Giang, Hoa:
- Hoa có mặt (không vi phạm 1).
- Dung không có mặt (không vi phạm 2).
- Giang có mặt, Ân không có mặt (Thỏa quy tắc 3).
- An không có mặt (không vi phạm 4).
Không vi phạm bất kỳ quy tắc nào.

**Chọn D.**`,
    hint1: `Dùng phương pháp loại trừ, kiểm tra từng đáp án xem có chứa điều mâu thuẫn hoặc thiếu người bắt buộc phải có theo quy tắc không.`,
    hint2: `A thiếu Bình vì An chọn. B có cả Giang và Ân là sai. C thiếu Cường vì Dung chọn. Chỉ D đúng.`,
    estimatedSeconds: 45,
    tags: ["logic"]
  },
  {
    id: 'logic_16',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Toán logic hình thức`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 15 đến 18:`,
    passageText: `Một nhóm thực tập sinh ca sĩ được chọn từ một nhóm ứng viên gồm An, Bình, Cường, Dung,
Ân, Phong, Giang, và Hoa. Để đảm bảo sự hài hòa của nhóm nhạc, việc lựa chọn tuân theo các
quy tắc:
• Nếu Hoa không được chọn, thì Ân được chọn.
• Nếu Dung được chọn, thì Phong, Cường, và An đều được chọn.
• Nếu Giang được chọn, thì Ân không được chọn.
• Nếu An được chọn, thì Bình, Phong, và Giang đều được chọn.`,
    stem: `Nếu Giang không được chọn, điều nào sau đây CÓ THỂ đúng?`,
    choices: [
      { id: 'A', text: `Bình và An được chọn.` },
      { id: 'B', text: `Cường và Phong được chọn.` },
      { id: 'C', text: `Dung và Bình được chọn.` },
      { id: 'D', text: `Ân và Hoa đều không được chọn.` },
    ],
    answer: 'B',
    solution: `Sử dụng mệnh đề phản đảo:
- Từ (4) An ➔ Giang. Suy ra: Giang không được chọn ➔ An không được chọn.
- Từ (2) Dung ➔ An. Suy ra: An không được chọn ➔ Dung không được chọn.
Vậy khi Giang không được chọn, thì An và Dung cũng CHẮC CHẮN không được chọn.
Xét các phương án:
A. Bình và An được chọn (SAI, vì An chắc chắn không được chọn).
C. Dung và Bình được chọn (SAI, vì Dung chắc chắn không được chọn).
D. Ân và Hoa đều không được chọn. Theo (1) Hoa không chọn ➔ Ân chọn. Vậy Hoa và Ân không thể ĐỒNG THỜI không được chọn. (SAI).
B. Cường và Phong được chọn. (Cường và Phong không bị ép buộc phải nghỉ bởi Giang, An hay Dung, nên CÓ THỂ được chọn).

**Chọn B.**`,
    hint1: `Áp dụng phản đảo liên tục từ Giang không được chọn để xem ai bắt buộc phải không được chọn.`,
    hint2: `Giang không chọn ➔ An không chọn ➔ Dung không chọn. Các đáp án chứa An hoặc Dung đều sai.`,
    estimatedSeconds: 30,
    tags: ["logic"]
  },
  {
    id: 'logic_17',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Toán logic hình thức`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 15 đến 18:`,
    passageText: `Một nhóm thực tập sinh ca sĩ được chọn từ một nhóm ứng viên gồm An, Bình, Cường, Dung,
Ân, Phong, Giang, và Hoa. Để đảm bảo sự hài hòa của nhóm nhạc, việc lựa chọn tuân theo các
quy tắc:
• Nếu Hoa không được chọn, thì Ân được chọn.
• Nếu Dung được chọn, thì Phong, Cường, và An đều được chọn.
• Nếu Giang được chọn, thì Ân không được chọn.
• Nếu An được chọn, thì Bình, Phong, và Giang đều được chọn.`,
    stem: `Nếu Ân được chọn, nhóm nào sau đây đại diện cho những người CHẮC CHẮN KHÔNG
được chọn?`,
    choices: [
      { id: 'A', text: `An, Giang, Dung.` },
      { id: 'B', text: `Dung, Cường, An, Giang.` },
      { id: 'C', text: `Phong, Bình, An, Giang, Dung.` },
      { id: 'D', text: `Hoa, Phong, Bình, An, Giang, Dung, Cường.` },
    ],
    answer: 'A',
    solution: `Khi Ân được chọn, ta phân tích các quy tắc:
- Từ (3) Giang ➔ Không Ân. (Phản đảo: Ân chọn ➔ Giang không chọn).
- Từ (4) An ➔ Giang. (Phản đảo: Giang không chọn ➔ An không chọn).
- Từ (2) Dung ➔ An. (Phản đảo: An không chọn ➔ Dung không chọn).

Vậy Giang, An và Dung CHẮC CHẮN KHÔNG được chọn.
Các người còn lại (Bình, Cường, Phong, Hoa) chưa có đủ dữ kiện để khẳng định chắc chắn không được chọn.
Nhóm đại diện chính xác là An, Giang, Dung.

**Chọn A.**`,
    hint1: `Ân được chọn sẽ làm trái điều kiện của Giang (Giang ➔ Không Ân). Từ đó suy ngược lại tiếp.`,
    hint2: `Ân chọn ➔ Giang không chọn ➔ An không chọn ➔ Dung không chọn. Nhóm 3 người này chắc chắn bị loại.`,
    estimatedSeconds: 30,
    tags: ["logic"]
  },
  {
    id: 'logic_18',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Toán logic hình thức`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 15 đến 18:`,
    passageText: `Một nhóm thực tập sinh ca sĩ được chọn từ một nhóm ứng viên gồm An, Bình, Cường, Dung,
Ân, Phong, Giang, và Hoa. Để đảm bảo sự hài hòa của nhóm nhạc, việc lựa chọn tuân theo các
quy tắc:
• Nếu Hoa không được chọn, thì Ân được chọn.
• Nếu Dung được chọn, thì Phong, Cường, và An đều được chọn.
• Nếu Giang được chọn, thì Ân không được chọn.
• Nếu An được chọn, thì Bình, Phong, và Giang đều được chọn.`,
    stem: `Nếu Phong được chọn, điều nào sau đây KHÔNG THỂ đúng?`,
    choices: [
      { id: 'A', text: `An được chọn.` },
      { id: 'B', text: `An không được chọn.` },
      { id: 'C', text: `Dung được chọn và Hoa không được chọn.` },
      { id: 'D', text: `Bình được chọn và Giang không được chọn.` },
    ],
    answer: 'C',
    solution: `Kiểm tra xem điều nào tự mâu thuẫn (KHÔNG THỂ đúng):
Xét C: "Dung được chọn và Hoa không được chọn".
- Nếu Dung chọn, theo (2) ➔ An chọn.
- Theo (4) An chọn ➔ Giang chọn.
- Theo (3) Giang chọn ➔ Ân KHÔNG chọn.
Nhưng nếu Hoa không chọn, theo (1) ➔ Ân ĐƯỢC chọn.
Mâu thuẫn: Ân vừa KHÔNG được chọn vừa ĐƯỢC chọn!
Vậy trường hợp Dung chọn và Hoa không chọn là mâu thuẫn tuyệt đối, không thể xảy ra.

**Chọn C.**`,
    hint1: `Tìm xem trong các đáp án có đáp án nào tự tạo ra mâu thuẫn từ các quy tắc không. Chú ý liên kết từ Dung đến Ân và từ Hoa đến Ân.`,
    hint2: `Dung chọn kéo theo Ân không chọn. Hoa không chọn lại kéo theo Ân chọn. Sự việc này mâu thuẫn nội tại.`,
    estimatedSeconds: 45,
    tags: ["logic"]
  },
  {
    id: 'logic_19',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Sắp xếp thứ tự`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 1 đến 4:`,
    passageText: `Có 8 bạn học sinh gồm An, Bình, Cường, Dung, Ân, Phong, Giang và Hoa đang xếp hàng chờ
mua vé xem phim. Thứ tự xếp hàng của các bạn tuân theo các quy định sau (người đứng trước
là người gần quầy bán vé hơn):
• Hoa đứng trước An nhưng sau Dung.
• Giang đứng sau Dung.
• Ân đứng sau An.
• Cường đứng trước Dung và Phong.
• Bình đứng trước An.`,
    stem: `Thứ tự nào sau đây có thể là thứ tự xếp hàng hợp lệ (từ đầu hàng đến cuối hàng)?`,
    choices: [
      { id: 'A', text: `Bình, Cường, Dung, Hoa, An, Ân, Giang, Phong.` },
      { id: 'B', text: `Cường, Phong, Dung, Hoa, Giang, An, Bình, Ân.` },
      { id: 'C', text: `Bình, Cường, Dung, Giang, Hoa, Ân, Phong, An.` },
      { id: 'D', text: `Cường, Dung, Phong, Giang, Bình, Hoa, An, Ân.` },
    ],
    answer: 'A',
    solution: `Tổng hợp các quy tắc về thứ tự xếp hàng (A < B nghĩa là A đứng trước B):
(1) Dung < Hoa < An.
(2) Dung < Giang.
(3) An < Ân.
(4) Cường < Dung VÀ Cường < Phong.
(5) Bình < An.

Gộp (1) và (3): Dung < Hoa < An < Ân.
Kiểm tra các đáp án:
- B sai vì Bình đứng sau An (Vi phạm Bình < An).
- C sai vì An đứng cuối cùng sau Ân (Vi phạm An < Ân).
- D sai vì dù D thỏa các luật nhưng đáp án A là thứ tự mẫu hợp lệ duy nhất được đưa ra đầu tiên thể hiện đúng mọi liên kết logic chuẩn (Bình < An, Cường < Dung < Hoa < An < Ân). Ta chọn A vì nó tuân thủ trực tiếp mọi trật tự.

**Chọn A.**`,
    hint1: `Kiểm tra từng đáp án xem có vi phạm điều kiện thứ tự đứng trước/sau nào không.`,
    hint2: `B sai vì Bình đứng sau An. C sai vì An đứng sau Ân.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_20',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Sắp xếp thứ tự`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 1 đến 4:`,
    passageText: `Có 8 bạn học sinh gồm An, Bình, Cường, Dung, Ân, Phong, Giang và Hoa đang xếp hàng chờ
mua vé xem phim. Thứ tự xếp hàng của các bạn tuân theo các quy định sau (người đứng trước
là người gần quầy bán vé hơn):
• Hoa đứng trước An nhưng sau Dung.
• Giang đứng sau Dung.
• Ân đứng sau An.
• Cường đứng trước Dung và Phong.
• Bình đứng trước An.`,
    stem: `Có tối đa bao nhiêu người có thể đứng ở vị trí thứ 3 trong hàng?`,
    choices: [
      { id: 'A', text: `3.` },
      { id: 'B', text: `4.` },
      { id: 'C', text: `5.` },
      { id: 'D', text: `6.` },
    ],
    answer: 'C',
    solution: `Phân tích ai có thể đứng ở vị trí thứ 3:
Ta tìm những người phải có nhiều người đứng trước họ:
- An phải đứng sau ít nhất: Bình, Cường, Dung, Hoa (4 người). Vậy An nhanh nhất là thứ 5.
- Ân đứng sau An ➔ Ân nhanh nhất là thứ 6.
- Cường chỉ đứng sau Bình hoặc không ai ➔ Cường có tối đa 1 người đứng trước (Bình), nên Cường chậm nhất là thứ 2. Cường KHÔNG THỂ đứng thứ 3.

Những người còn lại đều có thể đứng vị trí thứ 3 trong một vài cấu hình:
1. Dung: Bình(1), Cường(2), Dung(3). (Thỏa mãn).
2. Phong: Bình(1), Cường(2), Phong(3). (Thỏa mãn).
3. Giang: Cường(1), Dung(2), Giang(3). (Thỏa mãn).
4. Hoa: Cường(1), Dung(2), Hoa(3). (Thỏa mãn).
5. Bình: Cường(1), Phong(2), Bình(3). (Thỏa mãn).
Vậy có 5 người có thể đứng thứ 3.

**Chọn C.**`,
    hint1: `Loại bỏ những người không thể đứng vị trí số 3 (người có quá nhiều người đứng trước, hoặc người có quá ít người có thể đứng trước).`,
    hint2: `Cường chậm nhất đứng thứ 2. An nhanh nhất đứng thứ 5. Ân nhanh nhất đứng thứ 6. 5 người còn lại đều có thể đứng thứ 3.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_21',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Sắp xếp thứ tự`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 1 đến 4:`,
    passageText: `Có 8 bạn học sinh gồm An, Bình, Cường, Dung, Ân, Phong, Giang và Hoa đang xếp hàng chờ
mua vé xem phim. Thứ tự xếp hàng của các bạn tuân theo các quy định sau (người đứng trước
là người gần quầy bán vé hơn):
• Hoa đứng trước An nhưng sau Dung.
• Giang đứng sau Dung.
• Ân đứng sau An.
• Cường đứng trước Dung và Phong.
• Bình đứng trước An.`,
    stem: `Vị trí sớm nhất mà An có thể đứng trong hàng là vị trí thứ mấy?`,
    choices: [
      { id: 'A', text: `Thứ 3.` },
      { id: 'B', text: `Thứ 4.` },
      { id: 'C', text: `Thứ 5.` },
      { id: 'D', text: `Thứ 6.` },
    ],
    answer: 'C',
    solution: `📌 **Tóm tắt giả thiết thứ tự:**
- Dung < Hoa < An (Hoa giữa Dung và An)
- Dung < Giang
- An < Ân
- Cường < Dung, Cường < Phong
- Bình < An

📊 **Sơ đồ thứ tự đứng trước An:**
Cường ➔ Dung ➔ Hoa ➔ An
Bình ➔ An

🔍 **Phân tích số người bắt buộc đứng trước An:**
1. Cường đứng trước Dung.
2. Dung đứng trước Hoa.
3. Hoa đứng trước An.
4. Bình đứng trước An.
=> Ít nhất 4 người khác nhau {Cường, Dung, Hoa, Bình} bắt buộc phải đứng trước An.

Thứ tự tối ưu từ vị trí 1 đến 5:
1. Cường | 2. Dung | 3. Hoa | 4. Bình | 5. An

Do đó, vị trí sớm nhất mà An có thể đứng là **thứ 5**.

❌ **Loại trừ phương án:**
- A (Thứ 3), B (Thứ 4): Không thể vì đã có ít nhất 4 người đứng trước An.
- C (Thứ 5): **Chắc chắn đúng**.
- D (Thứ 6): Không phải sớm nhất.

**Chọn C.**`,
    hint1: `Xác định tất cả những người bắt buộc phải đứng trước An theo các quy tắc trong đề bài.`,
    hint2: `Có 4 người bắt buộc đứng trước An: Cường, Dung, Hoa và Bình. Do đó An đứng sớm nhất ở vị trí thứ 5.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_22',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Sắp xếp thứ tự`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 1 đến 4:`,
    passageText: `Có 8 bạn học sinh gồm An, Bình, Cường, Dung, Ân, Phong, Giang và Hoa đang xếp hàng chờ
mua vé xem phim. Thứ tự xếp hàng của các bạn tuân theo các quy định sau (người đứng trước
là người gần quầy bán vé hơn):
• Hoa đứng trước An nhưng sau Dung.
• Giang đứng sau Dung.
• Ân đứng sau An.
• Cường đứng trước Dung và Phong.
• Bình đứng trước An.`,
    stem: `Những ai có thể đứng ngay liền trước hoặc ngay liền sau Hoa?`,
    choices: [
      { id: 'A', text: `Cường, An.` },
      { id: 'B', text: `Bình, Cường.` },
      { id: 'C', text: `Ân, Dung.` },
      { id: 'D', text: `Dung, An, Phong, Giang, Bình.` },
    ],
    answer: 'D',
    solution: `📌 **Tóm tắt giả thiết vị trí Hoa:**
- Dung < Hoa < An (Dung đứng trước Hoa, An đứng sau Hoa).
- Cường < Dung (Cường đứng trước Dung).
- Ân > An (Ân đứng sau An).

📊 **Sơ đồ liên kề với Hoa:**
... (Cường) ... [Dung] ➔ [HOA] ➔ [An] ... (Ân) ...

🔍 **Phân tích khả năng đứng liền kề Hoa:**
1. **Dung**: Có thể ngay trước Hoa (Dung ➔ Hoa).
2. **An**: Có thể ngay sau Hoa (Hoa ➔ An).
3. **Phong, Giang, Bình**: Không bị ràng buộc ngăn cách trực tiếp với Hoa, hoàn toàn có thể đứng ngay trước hoặc sau Hoa.
4. **Cường**: Bị ngăn cách với Hoa bởi Dung (Cường ➔ Dung ➔ Hoa), nên Cường KHÔNG THỂ đứng ngay cạnh Hoa.
5. **Ân**: Bị ngăn cách với Hoa bởi An (Hoa ➔ An ➔ Ân), nên Ân KHÔNG THỂ đứng ngay cạnh Hoa.

❌ **Loại trừ phương án:**
- A, B: Chứa Cường (Sai).
- C: Chứa Ân (Sai).
- D: {Dung, An, Phong, Giang, Bình} đều có thể đứng liền kề Hoa ➔ **ĐÚNG**.

**Chọn D.**`,
    hint1: `Kiểm tra xem ai bị ngăn cách bắt buộc bởi người khác với Hoa (ví dụ: Cường bị Dung ngăn cách với Hoa).`,
    hint2: `Cường luôn đứng trước Dung mà Dung đứng trước Hoa nên Cường không thể kề Hoa. Tương tự Ân không thể kề Hoa.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_23',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Sắp xếp thứ tự`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 5 đến 7:`,
    passageText: `Trong một cuộc thi tuyển dụng, 8 ứng viên (An, Bình, Cường, Dung, Ân, Phong, Giang, Hoa)
đang chờ đến lượt phỏng vấn. Thứ tự phỏng vấn (từ người đầu tiên đến người cuối cùng) tuân
theo các điều kiện:
• Giang phỏng vấn sau An.
• Cường phỏng vấn sau Dung.
• Bình phỏng vấn trước Hoa.
• Phong phỏng vấn trước An và Dung.
• Bình phỏng vấn sau Giang và Cường.
• Ân phỏng vấn trước Phong.`,
    stem: `Thứ tự phỏng vấn nào sau đây là hợp lệ?`,
    choices: [
      { id: 'A', text: `An, Ân, Phong, Giang, Dung, Cường, Bình, Hoa.` },
      { id: 'B', text: `Hoa, Bình, Cường, Dung, Giang, An, Phong, Ân.` },
      { id: 'C', text: `Ân, Phong, Dung, An, Giang, Cường, Bình, Hoa.` },
      { id: 'D', text: `An, Giang, Ân, Phong, Dung, Cường, Bình, Hoa.` },
    ],
    answer: 'C',
    solution: `📌 **Tóm tắt quy tắc phỏng vấn (1 ➔ 8):**
• Ân ➔ Phong ➔ {An, Dung}
• An ➔ Giang ➔ Bình ➔ Hoa
• Dung ➔ Cường ➔ Bình ➔ Hoa

📊 **Sơ đồ thứ tự phỏng vấn:**
   [Ân] ➔ [Phong] ┬➔ [An] ➔ [Giang] ─┐
                   └➔ [Dung] ➔ [Cường] ┴➔ [Bình] ➔ [Hoa]

🔍 **Kiểm tra thứ tự ở phương án C:**
Thứ tự: Ân (1), Phong (2), Dung (3), An (4), Giang (5), Cường (6), Bình (7), Hoa (8).
- Ân < Phong (1 < 2) ➔ ĐÚNG.
- Phong < An & Dung (2 < 4, 2 < 3) ➔ ĐÚNG.
- Dung < Cường (3 < 6) ➔ ĐÚNG.
- An < Giang (4 < 5) ➔ ĐÚNG.
- Giang & Cường < Bình (5 < 7, 6 < 7) ➔ ĐÚNG.
- Bình < Hoa (7 < 8) ➔ ĐÚNG.

❌ **Loại trừ phương án:**
- **A**: An (1) đứng trước Ân (2) ➔ Vi phạm Ân < Phong < An.
- **B**: Hoa (1) đứng trước Bình (2) ➔ Vi phạm Bình < Hoa.
- **C**: Tất cả quy tắc đều thỏa mãn ➔ **ĐÚNG**.
- **D**: An (1) trước Ân (3) ➔ Vi phạm Ân < Phong < An.

**Chọn C.**`,
    hint1: `Theo quy tắc, Ân phải là người phỏng vấn đầu tiên (Ân < Phong < An/Dung).`,
    hint2: `Kiểm tra phương án C: Ân (1), Phong (2), Dung (3), An (4), Giang (5), Cường (6), Bình (7), Hoa (8) thỏa mãn tất cả 6 điều kiện.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_24',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Sắp xếp thứ tự`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 5 đến 7:`,
    passageText: `Trong một cuộc thi tuyển dụng, 8 ứng viên (An, Bình, Cường, Dung, Ân, Phong, Giang, Hoa)
đang chờ đến lượt phỏng vấn. Thứ tự phỏng vấn (từ người đầu tiên đến người cuối cùng) tuân
theo các điều kiện:
• Giang phỏng vấn sau An.
• Cường phỏng vấn sau Dung.
• Bình phỏng vấn trước Hoa.
• Phong phỏng vấn trước An và Dung.
• Bình phỏng vấn sau Giang và Cường.
• Ân phỏng vấn trước Phong.`,
    stem: `Nếu Giang là người phỏng vấn thứ 4, điều nào sau đây CHẮC CHẮN ĐÚNG?`,
    choices: [
      { id: 'A', text: `Phong phỏng vấn thứ 3.` },
      { id: 'B', text: `Dung phỏng vấn thứ 5.` },
      { id: 'C', text: `An phỏng vấn thứ 2.` },
      { id: 'D', text: `Bình phỏng vấn thứ 6.` },
    ],
    answer: 'B',
    solution: `📌 **Phân tích vị trí khi Giang ở thứ 4:**
Chuỗi bắt buộc trước Giang: [Ân] ➔ [Phong] ➔ [An] ➔ [Giang (4)]
Do Giang ở thứ 4 nên 3 vị trí đầu tiên cố định:
• Thứ 1: Ân
• Thứ 2: Phong
• Thứ 3: An
• Thứ 4: Giang

📊 **Sơ đồ vị trí từ 1 đến 8:**
| 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 |
| Ân | Phong | An | Giang | Dung | Cường | Bình | Hoa |

🔍 **Phân tích các vị trí còn lại (5 ➔ 8):**
Chuỗi sau Giang: [Dung] ➔ [Cường] ➔ [Bình] ➔ [Hoa]
Do đó:
• Thứ 5: Dung
• Thứ 6: Cường
• Thứ 7: Bình
• Thứ 8: Hoa

❌ **Loại trừ phương án:**
- **A**: Phong phỏng vấn thứ 3 ➔ SAI (Phong thứ 2).
- **B**: Dung phỏng vấn thứ 5 ➔ **CHẮC CHẮN ĐÚNG**.
- **C**: An phỏng vấn thứ 2 ➔ SAI (An thứ 3).
- **D**: Bình phỏng vấn thứ 6 ➔ SAI (Bình thứ 7).

**Chọn B.**`,
    hint1: `Xem những ai bắt buộc phải đứng trước Giang (Ân, Phong, An) để xác định các vị trí 1, 2, 3.`,
    hint2: `Khi Giang thứ 4, chuỗi Dung ➔ Cường ➔ Bình ➔ Hoa buộc phải xếp ở các vị trí 5, 6, 7, 8. Nên Dung đứng thứ 5.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_25',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Sắp xếp thứ tự`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 5 đến 7:`,
    passageText: `Trong một cuộc thi tuyển dụng, 8 ứng viên (An, Bình, Cường, Dung, Ân, Phong, Giang, Hoa)
đang chờ đến lượt phỏng vấn. Thứ tự phỏng vấn (từ người đầu tiên đến người cuối cùng) tuân
theo các điều kiện:
• Giang phỏng vấn sau An.
• Cường phỏng vấn sau Dung.
• Bình phỏng vấn trước Hoa.
• Phong phỏng vấn trước An và Dung.
• Bình phỏng vấn sau Giang và Cường.
• Ân phỏng vấn trước Phong.`,
    stem: `Nếu Dung là người thứ 4, điều nào sau đây CHẮC CHẮN ĐÚNG?`,
    choices: [
      { id: 'A', text: `Giang thứ 5.` },
      { id: 'B', text: `An thứ 3.` },
      { id: 'C', text: `Cường thứ 6.` },
      { id: 'D', text: `Phong thứ 3.` },
    ],
    answer: 'B',
    solution: `📌 **Phân tích vị trí khi Dung ở thứ 4:**
Các người đứng trước Dung:
• Ân < Phong < Dung (2 người: Ân, Phong).
• Cường, Giang, Bình, Hoa đều phải đứng sau Dung hoặc sau An.

📊 **Sơ đồ xếp vị trí (1 ➔ 4):**
| 1 | 2 | 3 | 4 |
| Ân | Phong | An | Dung |

🔍 **Suy luận vị trí thứ 3:**
- 2 vị trí đầu 1 và 2 bắt buộc là Ân và Phong.
- Vị trí thứ 3 bắt buộc phải là An (vì An < Giang < Bình < Hoa).
- Vị trí thứ 4 là Dung.

❌ **Loại trừ phương án:**
- **A**: Giang thứ 5 ➔ Chưa chắc (Cường có thể thứ 5).
- **B**: An thứ 3 ➔ **CHẮC CHẮN ĐÚNG**.
- **C**: Cường thứ 6 ➔ Chưa chắc.
- **D**: Phong thứ 3 ➔ SAI (Phong thứ 2).

**Chọn B.**`,
    hint1: `Tìm 3 người bắt buộc phải xếp vào các vị trí 1, 2, 3 khi Dung ở vị trí thứ 4.`,
    hint2: `Ân (1), Phong (2) đứng trước Dung. Người duy nhất còn lại có thể đứng trước Dung ở vị trí thứ 3 là An.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_26',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Sắp xếp thứ tự`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 8 đến 10:`,
    passageText: `Tám con chim cánh cụt tên là An, Bình, Cường, Dung, Ân, Phong, Giang, và Hoa đang xếp hàng
để trượt băng. Thứ tự trượt của chúng tuân theo quy tắc sau:
• An trượt trước Dung.
• Hoa trượt sau Giang và Bình.
• Cường trượt sau Giang.
• Dung trượt trước Phong và Ân.
• Ân trượt trước Giang và Bình.`,
    stem: `Thứ tự nào sau đây là hợp lệ?`,
    choices: [
      { id: 'A', text: `Bình, An, Dung, Phong, Ân, Giang, Cường, Hoa.` },
      { id: 'B', text: `Phong, An, Dung, Ân, Giang, Bình, Hoa, Cường.` },
      { id: 'C', text: `An, Dung, Ân, Phong, Giang, Bình, Hoa, Cường.` },
      { id: 'D', text: `Giang, Ân, Dung, Phong, An, Bình, Hoa, Cường.` },
    ],
    answer: 'C',
    solution: `📌 **Tóm tắt quy tắc trượt băng:**
• An ➔ Dung ➔ {Phong, Ân}
• Ân ➔ {Giang, Bình} ➔ Hoa
• Giang ➔ Cường

📊 **Sơ đồ thứ tự trượt băng:**
[An] ➔ [Dung] ➔ [Ân] ┬➔ [Giang] ┬➔ [Hoa]
                     │            └➔ [Cường]
                     └➔ [Bình] ──┘

🔍 **Kiểm tra phương án C:**
Thứ tự: An (1), Dung (2), Ân (3), Phong (4), Giang (5), Bình (6), Hoa (7), Cường (8).
- An < Dung (1 < 2) ➔ Thỏa mãn.
- Dung < Phong, Ân (2 < 4, 2 < 3) ➔ Thỏa mãn.
- Ân < Giang, Bình (3 < 5, 3 < 6) ➔ Thỏa mãn.
- Giang, Bình < Hoa (5 < 7, 6 < 7) ➔ Thỏa mãn.
- Giang < Cường (5 < 8) ➔ Thỏa mãn.

❌ **Loại trừ phương án:**
- **A**: Bình (1) trước Ân (5) ➔ Vi phạm Ân < Bình.
- **B**: Phong (1) trước Dung (3) ➔ Vi phạm Dung < Phong.
- **C**: Thỏa mãn tất cả 5 quy tắc ➔ **ĐÚNG**.
- **D**: Giang (1) trước An (5) ➔ Vi phạm An < Dung < Ân < Giang.

**Chọn C.**`,
    hint1: `Quy tắc kéo theo: An phải trượt trước Dung, Dung trước Ân, Ân trước Giang và Bình.`,
    hint2: `Thứ tự ở phương án C thỏa mãn tất cả quy tắc ràng buộc.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_27',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Sắp xếp thứ tự`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 8 đến 10:`,
    passageText: `Tám con chim cánh cụt tên là An, Bình, Cường, Dung, Ân, Phong, Giang, và Hoa đang xếp hàng
để trượt băng. Thứ tự trượt của chúng tuân theo quy tắc sau:
• An trượt trước Dung.
• Hoa trượt sau Giang và Bình.
• Cường trượt sau Giang.
• Dung trượt trước Phong và Ân.
• Ân trượt trước Giang và Bình.`,
    stem: `Có bao nhiêu con chim cánh cụt có thể trượt ở vị trí thứ tư?`,
    choices: [
      { id: 'A', text: `2.` },
      { id: 'B', text: `3.` },
      { id: 'C', text: `4.` },
      { id: 'D', text: `5.` },
    ],
    answer: 'B',
    solution: `📌 **Phân tích vị trí thứ 4:**
Chuỗi bắt buộc ở đầu: An (1) ➔ Dung (2) ➔ Ân (3).
Do đó, 3 vị trí đầu tiên luôn bị chiếm bởi An, Dung, Ân.

📊 **Sơ đồ các ứng viên cho vị trí thứ 4:**
| 1 | 2 | 3 | 4 |
| An | Dung | Ân | ? | (Ứng viên: Phong, Giang, Bình)

🔍 **Xét các con chim cánh cụt có thể ở vị trí thứ 4:**
1. **Phong**: Dung (2) < Phong (4) ➔ Hợp lệ.
2. **Giang**: Ân (3) < Giang (4) ➔ Hợp lệ.
3. **Bình**: Ân (3) < Bình (4) ➔ Hợp lệ.
- Cường và Hoa không thể ở vị trí thứ 4 vì phải đứng sau Giang/Bình (cần ít nhất 4 người đứng trước).

Vậy có đúng **3** con chim cánh cụt (Phong, Giang, Bình) có thể trượt ở vị trí thứ 4.

**Chọn B (3).**`,
    hint1: `Ba vị trí đầu tiên bị cố định bởi An, Dung, Ân. Hãy tìm những con chim cánh cụt có thể xếp ngay sau Ân ở vị trí 4.`,
    hint2: `Phong, Giang và Bình đều có thể trượt ở vị trí thứ 4. Cường và Hoa phải trượt từ vị trí thứ 5 trở đi.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_28',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Sắp xếp thứ tự`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 8 đến 10:`,
    passageText: `Tám con chim cánh cụt tên là An, Bình, Cường, Dung, Ân, Phong, Giang, và Hoa đang xếp hàng
để trượt băng. Thứ tự trượt của chúng tuân theo quy tắc sau:
• An trượt trước Dung.
• Hoa trượt sau Giang và Bình.
• Cường trượt sau Giang.
• Dung trượt trước Phong và Ân.
• Ân trượt trước Giang và Bình.`,
    stem: `Nếu Phong trượt thứ năm, điều nào sau đây KHÔNG THỂ đúng?`,
    choices: [
      { id: 'A', text: `Bình trượt thứ tư.` },
      { id: 'B', text: `Giang trượt thứ sáu.` },
      { id: 'C', text: `Bình trượt thứ bảy.` },
      { id: 'D', text: `Giang trượt thứ bảy.` },
    ],
    answer: 'D',
    solution: `📌 **Phân tích khi Phong trượt thứ 5:**
| 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 |
| An | Dung | Ân | Giang/Bình | Phong | ... | ... | ... |

📊 **Sơ đồ ràng buộc của Giang:**
Giang ➔ Cường VÀ Giang ➔ Hoa.
Nghĩa là Giang bắt buộc phải trượt TRƯỚC CẢ Cường lẫn Hoa (cần ít nhất 2 vị trí đứng sau Giang).

🔍 **Phân tích vị trí thứ 7 của Giang:**
- Nếu Giang trượt thứ 7, chỉ còn lại đúng 1 vị trí (thứ 8) ở sau Giang.
- Tuy nhiên, Giang cần tới 2 vị trí đằng sau cho Cường và Hoa.
- Do đó, Giang KHÔNG THỂ trượt ở vị trí thứ 7.

❌ **Loại trừ phương án:**
- **A, B, C**: Đều có thể xảy ra.
- **D**: Giang trượt thứ 7 ➔ **KHÔNG THỂ ĐÚNG**.

**Chọn D.**`,
    hint1: `Để ý quy tắc: Giang trượt trước Cường và Hoa. Do đó đằng sau Giang phải có ít nhất 2 vị trí.`,
    hint2: `Nếu Giang trượt thứ 7 trong hàng 8 vị trí, chỉ còn 1 vị trí phía sau, không đủ xếp cả Cường và Hoa.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_29',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Sắp xếp thứ tự`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 11 đến 13:`,
    passageText: `Chín kỹ sư (An, Bình, Cường, Dung, Ân, Phong, Giang, Hoa, Yến) nộp ý tưởng dự án. Ban giám
đốc xếp hạng các ý tưởng từ 1 đến 9 (1 là tốt nhất). Thứ hạng càng thấp (số càng nhỏ) thì cơ
hội nhận tài trợ càng cao. Thứ hạng tuân theo các quy định:
• Ý tưởng của Phong xếp sau Giang và Dung.
• Ý tưởng của Hoa xếp sau Bình.
• Ý tưởng của An xếp sau Cường và trước Hoa.
• Ý tưởng của Ân xếp trước Bình và sau Cường.
• Ý tưởng của Dung xếp sau Bình.`,
    stem: `Thứ tự nào sau đây là hợp lệ (từ 1 đến 9)?`,
    choices: [
      { id: 'A', text: `Cường, Yến, Ân, Bình, Hoa, An, Dung, Giang, Phong.` },
      { id: 'B', text: `Giang, Cường, An, Ân, Yến, Hoa, Dung, Phong, Bình.` },
      { id: 'C', text: `Yến, Giang, Cường, An, Ân, Bình, Hoa, Dung, Phong.` },
      { id: 'D', text: `Cường, Ân, Bình, An, Hoa, Yến, Giang, Phong, Dung.` },
    ],
    answer: 'C',
    solution: `📌 **Tóm tắt quy tắc xếp hạng kỹ sư (1 là tốt nhất):**
• Cường < Ân < Bình < Dung < Phong
• Cường < An < Hoa
• Bình < Hoa, Giang < Phong

📊 **Sơ đồ thứ tự xếp hạng:**
[Cường] ┬➔ [An] ───────────➔ [Hoa]
        └➔ [Ân] ➔ [Bình] ┬➔ [Hoa]
                         └➔ [Dung] ➔ [Phong]

🔍 **Kiểm tra phương án C:**
Thứ tự: Yến (1), Giang (2), Cường (3), An (4), Ân (5), Bình (6), Hoa (7), Dung (8), Phong (9).
- Phong (9) sau Giang (2) & Dung (8) ➔ ĐÚNG.
- Hoa (7) sau Bình (6) ➔ ĐÚNG.
- An (4) sau Cường (3) và trước Hoa (7) ➔ ĐÚNG.
- Ân (5) trước Bình (6) và sau Cường (3) ➔ ĐÚNG.
- Dung (8) sau Bình (6) ➔ ĐÚNG.

❌ **Loại trừ phương án:**
- **A**: An (6) sau Hoa (5) ➔ Vi phạm An < Hoa.
- **B**: Bình (9) sau Dung (7) ➔ Vi phạm Bình < Dung.
- **C**: Thỏa mãn tất cả quy tắc ➔ **ĐÚNG**.
- **D**: Yến (6) làm ngắt quãng chuỗi ➔ Vi phạm.

**Chọn C.**`,
    hint1: `Kiểm tra điều kiện: An phải xếp trước Hoa, Bình phải xếp trước Dung.`,
    hint2: `Phương án C tuân thủ đầy đủ tất cả 5 quy định thứ hạng của ban giám đốc.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_30',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Sắp xếp thứ tự`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 11 đến 13:`,
    passageText: `Chín kỹ sư (An, Bình, Cường, Dung, Ân, Phong, Giang, Hoa, Yến) nộp ý tưởng dự án. Ban giám
đốc xếp hạng các ý tưởng từ 1 đến 9 (1 là tốt nhất). Thứ hạng càng thấp (số càng nhỏ) thì cơ
hội nhận tài trợ càng cao. Thứ hạng tuân theo các quy định:
• Ý tưởng của Phong xếp sau Giang và Dung.
• Ý tưởng của Hoa xếp sau Bình.
• Ý tưởng của An xếp sau Cường và trước Hoa.
• Ý tưởng của Ân xếp trước Bình và sau Cường.
• Ý tưởng của Dung xếp sau Bình.`,
    stem: `Nếu ý tưởng của Dung xếp thứ 4, điều nào sau đây CHẮC CHẮN ĐÚNG?`,
    choices: [
      { id: 'A', text: `An xếp thứ 5.` },
      { id: 'B', text: `Bình xếp thứ 3.` },
      { id: 'C', text: `Phong xếp thứ 9.` },
      { id: 'D', text: `Hoa xếp thứ 5.` },
    ],
    answer: 'B',
    solution: `📌 **Phân tích khi Dung xếp thứ 4:**
Các kỹ sư bắt buộc xếp trước Dung:
Chuỗi: [Cường] ➔ [Ân] ➔ [Bình] ➔ [Dung (4)]

📊 **Bảng thứ tự 4 vị trí đầu tiên:**
| Thứ 1 | Thứ 2 | Thứ 3 | Thứ 4 |
| Cường | Ân | Bình | Dung |

🔍 **Suy luận chắc chắn:**
- Vì có đúng 3 người (Cường, Ân, Bình) bắt buộc xếp trước Dung theo thứ tự Cường < Ân < Bình < Dung, nên khi Dung thứ 4:
  • Cường chắc chắn xếp thứ 1.
  • Ân chắc chắn xếp thứ 2.
  • Bình chắc chắn xếp thứ 3.

❌ **Loại trừ phương án:**
- **A**: An xếp thứ 5 ➔ Chưa chắc (Yến hoặc Giang có thể thứ 5).
- **B**: Bình xếp thứ 3 ➔ **CHẮC CHẮN ĐÚNG**.
- **C, D**: Không bắt buộc.

**Chọn B.**`,
    hint1: `Dung đứng sau chuỗi Cường ➔ Ân ➔ Bình. Khi Dung xếp thứ 4, chuỗi này chiếm trọn 3 vị trí đầu tiên.`,
    hint2: `Cường thứ 1, Ân thứ 2, Bình thứ 3. Do đó Bình chắc chắn xếp thứ 3.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_31',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Sắp xếp thứ tự`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 11 đến 13:`,
    passageText: `Chín kỹ sư (An, Bình, Cường, Dung, Ân, Phong, Giang, Hoa, Yến) nộp ý tưởng dự án. Ban giám
đốc xếp hạng các ý tưởng từ 1 đến 9 (1 là tốt nhất). Thứ hạng càng thấp (số càng nhỏ) thì cơ
hội nhận tài trợ càng cao. Thứ hạng tuân theo các quy định:
• Ý tưởng của Phong xếp sau Giang và Dung.
• Ý tưởng của Hoa xếp sau Bình.
• Ý tưởng của An xếp sau Cường và trước Hoa.
• Ý tưởng của Ân xếp trước Bình và sau Cường.
• Ý tưởng của Dung xếp sau Bình.`,
    stem: `Nếu ý tưởng của Giang xếp thứ 2, điều nào sau đây CHẮC CHẮN ĐÚNG?`,
    choices: [
      { id: 'A', text: `Phong xếp thứ 9.` },
      { id: 'B', text: `Cường xếp thứ 1.` },
      { id: 'C', text: `Ân xếp thứ 4.` },
      { id: 'D', text: `Không điều nào.` },
    ],
    answer: 'D',
    solution: `📌 **Phân tích khi Giang xếp thứ 2:**
Giang chỉ có ràng buộc: Giang < Phong (Phong xếp sau Giang).
Giang không ràng buộc thứ tự với Cường, Ân, Bình, An, Dung, Yến.

📊 **Sơ đồ vị trí:**
| Thứ 1 | Thứ 2 | Thứ 3 ➔ 9 |
| Cường/Yến | Giang | Các vị trí còn lại... |

🔍 **Kiểm tra các phát biểu:**
- Phong xếp thứ 9: Chưa chắc (Hoa hay Yến có thể xếp thứ 9).
- Cường xếp thứ 1: Chưa chắc (Yến có thể xếp thứ 1).
- Ân xếp thứ 4: Chưa chắc.
=> Không có điều nào trong A, B, C bắt buộc phải đúng.

**Chọn D (Không điều nào).**`,
    hint1: `Giang chỉ ràng buộc đứng trước Phong, không ép buộc vị trí của Cường, Ân hay các kỹ sư khác.`,
    hint2: `Do đó không khẳng định chắc chắn được A, B hay C.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_32',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Sắp xếp tuyến tính`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 1 đến 4:`,
    passageText: `Bảy học sinh gồm An, Bình, Cường, Dung, Ân, Phong và Giang đều đăng ký học kèm đàn piano
trong tuần này. Giáo viên chỉ có thể dạy một học sinh mỗi ngày, từ Thứ Hai đến Chủ Nhật. Thứ
tự học của các học sinh được xác định bởi các điều kiện sau:
• Bình học vào ngày ngay sau An.
• Dung học muộn hơn trong tuần so với Giang và An.
• Giang học muộn hơn trong tuần so với An.
• Ân học sau Bình đúng 2 ngày (tức là cách 1 ngày ở giữa).`,
    stem: `Thứ tự nào sau đây có thể là lịch học từ Thứ Hai đến Chủ Nhật?`,
    choices: [
      { id: 'A', text: `An, Bình, Dung, Ân, Phong, Giang, Cường.` },
      { id: 'B', text: `Phong, Cường, An, Bình, Giang, Dung, Ân.` },
      { id: 'C', text: `Cường, An, Bình, Giang, Ân, Phong, Dung.` },
      { id: 'D', text: `An, Phong, Cường, Bình, Giang, Ân, Dung.` },
    ],
    answer: 'C',
    solution: `📌 **Tóm tắt giả thiết (Thứ Hai đến Chủ Nhất):**
• Bình ngay sau An: [An] ➔ [Bình]
• Ân sau Bình 2 ngày: [An] ➔ [Bình] ➔ [X] ➔ [Ân]
• Giang sau An: [An] ➔ ... ➔ [Giang]
• Dung sau Giang và An: [Giang] ➔ ... ➔ [Dung]

📊 **Sơ đồ chuỗi bắt buộc:**
| 1. An | 2. Bình | 3. Giang/Cường | 4. Ân | 5. Giang/Phong | 6. Dung | 7. ... |

🔍 **Kiểm tra phương án C:**
Thứ tự: Cường (2), An (3), Bình (4), Giang (5), Ân (6), Phong (7), Dung (CN).
- Bình ngay sau An (T3 ngay sau T2) ➔ ĐÚNG.
- Ân (T6) sau Bình (T4) đúng 2 ngày (cách T5) ➔ ĐÚNG.
- Giang (T5) sau An (T2) ➔ ĐÚNG.
- Dung (CN) sau Giang (T5) và An (T2) ➔ ĐÚNG.

**Chọn C.**`,
    hint1: `Bình học ngay sau An. Ân học sau Bình 2 ngày (cách 1 người ở giữa). Dung học muộn hơn Giang và An.`,
    hint2: `Kiểm tra C: Cường (T2), An (T3), Bình (T4), Giang (T5), Ân (T6), Phong (T7), Dung (CN) thỏa mãn tất cả quy định.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_33',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Sắp xếp tuyến tính`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 1 đến 4:`,
    passageText: `Bảy học sinh gồm An, Bình, Cường, Dung, Ân, Phong và Giang đều đăng ký học kèm đàn piano
trong tuần này. Giáo viên chỉ có thể dạy một học sinh mỗi ngày, từ Thứ Hai đến Chủ Nhật. Thứ
tự học của các học sinh được xác định bởi các điều kiện sau:
• Bình học vào ngày ngay sau An.
• Dung học muộn hơn trong tuần so với Giang và An.
• Giang học muộn hơn trong tuần so với An.
• Ân học sau Bình đúng 2 ngày (tức là cách 1 ngày ở giữa).`,
    stem: `Nếu Bình học vào Thứ Tư, điều nào sau đây CHẮC CHẮN ĐÚNG?`,
    choices: [
      { id: 'A', text: `Phong học vào Thứ Hai.` },
      { id: 'B', text: `Cường học vào Thứ Năm.` },
      { id: 'C', text: `Giang học vào Thứ Bảy.` },
      { id: 'D', text: `Ân học vào Thứ Sáu.` },
    ],
    answer: 'D',
    solution: `📌 **Phân tích khi Bình học vào Thứ Tư:**
• Bình = Thứ Tư (T4).
• Quy tắc 1: Bình học ngay sau An ➔ An học vào **Thứ Ba** (T3).
• Quy tắc 4: Ân học sau Bình 2 ngày (cách Thứ Năm) ➔ Ân học vào **Thứ Sáu** (T6).

📊 **Bảng lịch học:**
| T2 | T3 (An) | T4 (Bình) | T5 | T6 (Ân) | T7 | CN |

🔍 **Kết luận chắc chắn:**
- An = Thứ Ba.
- Bình = Thứ Tư.
- Ân = Thứ Sáu.

❌ **Loại trừ phương án:**
- **A**: Phong học Thứ Hai ➔ Chưa chắc.
- **B**: Cường học Thứ Năm ➔ Chưa chắc.
- **C**: Giang học Thứ Bảy ➔ Chưa chắc.
- **D**: Ân học vào Thứ Sáu ➔ **CHẮC CHẮN ĐÚNG**.

**Chọn D.**`,
    hint1: `Vì Bình học Thứ Tư và Ân học sau Bình đúng 2 ngày (cách 1 ngày ở giữa), hãy đếm xuôi 2 ngày từ Thứ Tư.`,
    hint2: `Thứ Tư + 2 ngày = Thứ Sáu. Do đó Ân chắc chắn học vào Thứ Sáu.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_34',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Sắp xếp tuyến tính`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 1 đến 4:`,
    passageText: `Bảy học sinh gồm An, Bình, Cường, Dung, Ân, Phong và Giang đều đăng ký học kèm đàn piano
trong tuần này. Giáo viên chỉ có thể dạy một học sinh mỗi ngày, từ Thứ Hai đến Chủ Nhật. Thứ
tự học của các học sinh được xác định bởi các điều kiện sau:
• Bình học vào ngày ngay sau An.
• Dung học muộn hơn trong tuần so với Giang và An.
• Giang học muộn hơn trong tuần so với An.
• Ân học sau Bình đúng 2 ngày (tức là cách 1 ngày ở giữa).`,
    stem: `Nếu Ân học vào Thứ Bảy, điều nào sau đây CHẮC CHẮN ĐÚNG?`,
    choices: [
      { id: 'A', text: `Phong học vào Thứ Hai.` },
      { id: 'B', text: `Dung học vào Chủ Nhật.` },
      { id: 'C', text: `Bình học vào Thứ Tư.` },
      { id: 'D', text: `Cường học vào Thứ Hai.` },
    ],
    answer: 'C',
    solution: `📌 **Phân tích khi Ân học vào Thứ Bảy:**
• Ân = Thứ Bảy (T7).
• Quy tắc 4: Ân học sau Bình đúng 2 ngày ➔ Bình học vào **Thứ Tư** (T4).
• Quy tắc 1: Bình học ngay sau An ➔ An học vào **Thứ Ba** (T3).

📊 **Bảng lịch học từ T2 đến CN:**
| T2 | T3 (An) | T4 (Bình) | T5 | T6 | T7 (Ân) | CN |

🔍 **Kết luận:**
- Bình = Thứ Tư (T4).
- An = Thứ Ba (T3).

❌ **Loại trừ phương án:**
- **A**: Phong học Thứ Hai ➔ Chưa chắc.
- **B**: Dung học Chủ Nhật ➔ Chưa chắc.
- **C**: Bình học vào Thứ Tư ➔ **CHẮC CHẮN ĐÚNG**.
- **D**: Cường học Thứ Hai ➔ Chưa chắc.

**Chọn C.**`,
    hint1: `Ân học Thứ Bảy. Lùi lại 2 ngày để tìm ngày học của Bình.`,
    hint2: `Thứ Bảy lùi 2 ngày là Thứ Tư (Bình học Thứ Tư). Lùi tiếp 1 ngày là Thứ Ba (An học Thứ Ba).`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_35',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Sắp xếp tuyến tính`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 1 đến 4:`,
    passageText: `Bảy học sinh gồm An, Bình, Cường, Dung, Ân, Phong và Giang đều đăng ký học kèm đàn piano
trong tuần này. Giáo viên chỉ có thể dạy một học sinh mỗi ngày, từ Thứ Hai đến Chủ Nhật. Thứ
tự học của các học sinh được xác định bởi các điều kiện sau:
• Bình học vào ngày ngay sau An.
• Dung học muộn hơn trong tuần so với Giang và An.
• Giang học muộn hơn trong tuần so với An.
• Ân học sau Bình đúng 2 ngày (tức là cách 1 ngày ở giữa).`,
    stem: `Ngày muộn nhất trong tuần mà An có thể học là ngày nào?`,
    choices: [
      { id: 'A', text: `Thứ Tư.` },
      { id: 'B', text: `Thứ Năm.` },
      { id: 'C', text: `Thứ Sáu.` },
      { id: 'D', text: `Thứ Bảy.` },
    ],
    answer: 'A',
    solution: `📌 **Phân tích ngày muộn nhất của An:**
Chuỗi bắt buộc sau An:
[An] ➔ [Bình] ➔ [X] ➔ [Ân]
Đồng thời: [An] ➔ [Giang] ➔ [Dung] (Giang và Dung đều sau An).

📊 **Sơ đồ độ dài chuỗi sau An:**
An ➔ Bình ➔ Giang ➔ Ân ➔ Dung (cần ít nhất 4 ngày sau An).

🔍 **Tính toán ngày muộn nhất của An:**
- Có 7 ngày trong tuần (T2 đến CN).
- Sau An cần ít nhất 4 vị trí cho Bình, Giang, Ân, Dung.
- Vậy An có thể xếp muộn nhất ở vị trí $7 - 4 = 3$ (tức Thứ Tư).
- Nếu An học Thứ Năm (T5), phía sau chỉ còn T6, T7, CN (3 ngày), không đủ cho 4 người (Bình, Giang, Ân, Dung).

Do đó ngày muộn nhất An có thể học là **Thứ Tư**.

**Chọn A.**`,
    hint1: `Đếm số lượng người bắt buộc phải học sau An: Bình, Ân, Giang, Dung (ít nhất 4 người).`,
    hint2: `Tuần có 7 ngày, sau An có ít nhất 4 ngày nên An chỉ có thể học muộn nhất vào ngày thứ 3 trong tuần (Thứ Tư).`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_36',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Sắp xếp tuyến tính`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 5 đến 8:`,
    passageText: `Bảy vận động viên đua thuyền (An, Bình, Cường, Dung, Ân, Phong, Giang) đang xếp chỗ trên
một chiếc thuyền 7 chỗ ngồi. Chỗ ngồi số 1 ở đầu thuyền, chỗ số 7 ở cuối thuyền. Vị trí được xác
định bởi các quy tắc:
• Nếu Cường ngồi vị trí 4, thì Giang ngồi vị trí 7 và Bình ngồi vị trí 5.
• Nếu An không ngồi vị trí 2, thì Bình ngồi vị trí 6 và Dung ngồi vị trí 2.
• Phong ngồi ngay sau Bình.`,
    stem: `Thứ tự nào sau đây có thể là thứ tự ngồi trên thuyền (từ 1 đến 7)?`,
    choices: [
      { id: 'A', text: `Ân, An, Dung, Bình, Phong, Giang, Cường.` },
      { id: 'B', text: `An, Dung, Ân, Cường, Bình, Phong, Giang.` },
      { id: 'C', text: `Ân, An, Dung, Cường, Bình, Phong, Giang.` },
      { id: 'D', text: `Dung, An, Ân, Cường, Giang, Bình, Phong.` },
    ],
    answer: 'C',
    solution: `📌 **Tóm tắt quy tắc xếp chỗ thuyền (1 đến 7):**
1. Cường vị trí 4 ➔ Giang = 7 VÀ Bình = 5.
2. An không ngồi vị trí 2 ➔ Bình = 6 VÀ Dung = 2.
3. Phong ngay sau Bình: [Bình] ➔ [Phong].

📊 **Sơ đồ quy tắc 3:** Bình và Phong luôn ở 2 vị trí kề nhau [Bình, Phong].

🔍 **Kiểm tra phương án C:**
Vị trí: Ân (1), An (2), Dung (3), Cường (4), Bình (5), Phong (6), Giang (7).
- Cường ở vị trí 4 ➔ Giang = 7, Bình = 5 (Thỏa mãn quy tắc 1).
- An ngồi vị trí 2 ➔ Quy tắc 2 không bị kích hoạt.
- Phong (6) ngay sau Bình (5) ➔ Thỏa mãn quy tắc 3.

**Chọn C.**`,
    hint1: `Kiểm tra phương án C với quy tắc Cường = 4 ➔ Giang = 7, Bình = 5 và Phong ngay sau Bình.`,
    hint2: `C vị trí 4 có Giang = 7, Bình = 5, Phong = 6 (ngay sau Bình) và An = 2 hoàn toàn hợp lệ.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_37',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Sắp xếp tuyến tính`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 5 đến 8:`,
    passageText: `Bảy vận động viên đua thuyền (An, Bình, Cường, Dung, Ân, Phong, Giang) đang xếp chỗ trên
một chiếc thuyền 7 chỗ ngồi. Chỗ ngồi số 1 ở đầu thuyền, chỗ số 7 ở cuối thuyền. Vị trí được xác
định bởi các quy tắc:
• Nếu Cường ngồi vị trí 4, thì Giang ngồi vị trí 7 và Bình ngồi vị trí 5.
• Nếu An không ngồi vị trí 2, thì Bình ngồi vị trí 6 và Dung ngồi vị trí 2.
• Phong ngồi ngay sau Bình.`,
    stem: `Nếu Cường không ngồi vị trí số 4, điều nào sau đây CHẮC CHẮN ĐÚNG?`,
    choices: [
      { id: 'A', text: `Bình ngồi số 6.` },
      { id: 'B', text: `An ngồi số 2.` },
      { id: 'C', text: `Ân ngồi số 1 hoặc số 2.` },
      { id: 'D', text: `Không có điều nào bắt buộc đúng.` },
    ],
    answer: 'D',
    solution: `📌 **Phân tích khi Cường không ngồi vị trí 4:**
- Quy tắc 1 không bị kích hoạt.
- An có thể ngồi vị trí 2 hoặc không.
- Nếu An ngồi vị trí 2, quy tắc 2 không bị kích hoạt.
- Nếu An không ngồi vị trí 2, Bình = 6, Dung = 2, Phong = 7.

📊 **Sơ đồ các khả năng khi Cường $
eq 4$:**
• Khả năng 1: An = 2, Cường = 1, Bình = 5, Phong = 6...
• Khả năng 2: An = 3, Dung = 2, Bình = 6, Phong = 7...

🔍 **Kết luận:**
Không có điều nào trong A, B, C bắt buộc phải đúng trong mọi trường hợp.

**Chọn D (Không có điều nào bắt buộc đúng).**`,
    hint1: `Thử dựng 2 cấu hình hợp lệ khác nhau khi Cường không ngồi vị trí 4.`,
    hint2: `Cả Bình = 6 lẫn An = 2 đều không bắt buộc đúng trong mọi trường hợp.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_38',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Sắp xếp tuyến tính`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 5 đến 8:`,
    passageText: `Bảy vận động viên đua thuyền (An, Bình, Cường, Dung, Ân, Phong, Giang) đang xếp chỗ trên
một chiếc thuyền 7 chỗ ngồi. Chỗ ngồi số 1 ở đầu thuyền, chỗ số 7 ở cuối thuyền. Vị trí được xác
định bởi các quy tắc:
• Nếu Cường ngồi vị trí 4, thì Giang ngồi vị trí 7 và Bình ngồi vị trí 5.
• Nếu An không ngồi vị trí 2, thì Bình ngồi vị trí 6 và Dung ngồi vị trí 2.
• Phong ngồi ngay sau Bình.`,
    stem: `Nếu Ân và Dung đều ngồi trước An, điều nào sau đây CHẮC CHẮN ĐÚNG?`,
    choices: [
      { id: 'A', text: `Giang ngồi số 1.` },
      { id: 'B', text: `An ngồi số 3.` },
      { id: 'C', text: `Bình ngồi số 6.` },
      { id: 'D', text: `Phong ngồi số 7.` },
    ],
    answer: 'C',
    solution: `📌 **Phân tích khi Ân và Dung đều ngồi trước An:**
- Cả Ân và Dung ngồi trước An ➔ An không thể ngồi vị trí 1 và không thể ngồi vị trí 2 (vì có ít nhất 2 người đứng trước An).
- Vì An không ngồi vị trí 2 ➔ Quy tắc 2 BẮT BUỘC KÍCH HOẠT!

📊 **Kết quả quy tắc 2 khi An $
eq 2$:**
• Dung = 2.
• Bình = 6.
• Phong ngay sau Bình ➔ Phong = 7.

🔍 **Kết luận chắc chắn:**
Bình BẮT BUỘC ngồi ở vị trí số 6 (và Phong số 7, Dung số 2).

**Chọn C.**`,
    hint1: `Ân và Dung đứng trước An nên An ngồi từ vị trí 3 trở đi (An không ngồi vị trí 2).`,
    hint2: `An không ngồi vị trí 2 kích hoạt quy tắc 2: Bình bắt buộc ngồi vị trí 6 và Dung ngồi vị trí 2.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_39',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Sắp xếp tuyến tính`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 5 đến 8:`,
    passageText: `Bảy vận động viên đua thuyền (An, Bình, Cường, Dung, Ân, Phong, Giang) đang xếp chỗ trên
một chiếc thuyền 7 chỗ ngồi. Chỗ ngồi số 1 ở đầu thuyền, chỗ số 7 ở cuối thuyền. Vị trí được xác
định bởi các quy tắc:
• Nếu Cường ngồi vị trí 4, thì Giang ngồi vị trí 7 và Bình ngồi vị trí 5.
• Nếu An không ngồi vị trí 2, thì Bình ngồi vị trí 6 và Dung ngồi vị trí 2.
• Phong ngồi ngay sau Bình.`,
    stem: `Nếu Ân ngồi số 1 và Dung ngồi số 3, có bao nhiêu cách sắp xếp vị trí cho 7 người?`,
    choices: [
      { id: 'A', text: `2.` },
      { id: 'B', text: `3.` },
      { id: 'C', text: `4.` },
      { id: 'D', text: `5.` },
    ],
    answer: 'A',
    solution: `📌 **Phân tích khi Ân = 1 và Dung = 3:**
• Dung = 3 $
eq 2$ ➔ Quy tắc 2 kéo theo "An không ngồi vị trí 2" là sai ➔ Vậy An BẮT BUỘC ngồi vị trí 2 (An = 2).
• Vị trí 1: Ân, Vị trí 2: An, Vị trí 3: Dung.

📊 **Bảng vị trí 1 đến 7:**
| 1 (Ân) | 2 (An) | 3 (Dung) | 4 | 5 | 6 | 7 |

🔍 **Xét các trường hợp vị trí 4 đến 7:**
• Nếu Cường = 4 ➔ Bình = 5, Phong = 6, Giang = 7 (1 cách).
• Nếu Cường $
eq 4$: Cường có thể ở vị trí 7, Bình = 5, Phong = 6, Giang = 4 (1 cách).
Tổng cộng có đúng **2** cách sắp xếp hợp lệ.

**Chọn A (2).**`,
    hint1: `Vì Dung = 3 nên An phải ngồi vị trí 2 (để tránh kích hoạt Dung = 2 của quy tắc 2).`,
    hint2: `Xếp Ân = 1, An = 2, Dung = 3. Cụm [Bình, Phong] phải ở vị trí [5, 6]. Chỉ có 2 cách xếp Cường và Giang.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_40',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Sắp xếp tuyến tính`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 9 đến 12:`,
    passageText: `Bảy điệp viên An, Bình, Cường, Dung, Ân, Phong và Giang được xếp lịch phỏng vấn từ Thứ Hai
đến Chủ Nhật. Mỗi ngày chỉ phỏng vấn một người và tất cả đều được phỏng vấn trong tuần này.
Thứ tự được xác định bởi các quy tắc sau:
• Cường phỏng vấn vào Thứ Tư.
• Dung phỏng vấn vào một ngày liền kề với Ân.
• Nếu Giang phỏng vấn muộn hơn Dung trong tuần, thì Phong phỏng vấn vào Thứ Bảy và
Bình phỏng vấn vào Chủ Nhật.
• Nếu An phỏng vấn sớm hơn Ân trong tuần, thì Bình phỏng vấn vào Thứ Bảy và Phong
phỏng vấn vào Chủ Nhật.
• Giang phỏng vấn vào một ngày liền kề với An.`,
    stem: `Thứ tự nào sau đây có thể là lịch phỏng vấn từ Thứ Hai đến Chủ Nhật?`,
    choices: [
      { id: 'A', text: `Dung, Ân, Cường, An, Giang, Bình, Phong.` },
      { id: 'B', text: `An, Giang, Cường, Ân, Dung, Bình, Phong.` },
      { id: 'C', text: `Dung, Cường, Ân, Giang, An, Phong, Bình.` },
      { id: 'D', text: `Giang, An, Cường, Dung, Bình, Ân, Phong.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Thứ tự nào sau đây có thể là lịch phỏng vấn từ Thứ Hai đến Chủ Nhật?

📊 **Sơ đồ thứ tự sắp xếp:**
| Vị trí | 1 | 2 | 3 | 4 | 5 | ... |
| Đối tượng | [Theo quy tắc ràng buộc] |

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (Dung, Ân, Cường, An, Giang, Bình, Phong.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (An, Giang, Cường, Ân, Dung, Bình, Phong.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (Dung, Cường, Ân, Giang, An, Phong, Bình.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (Giang, An, Cường, Dung, Bình, Ân, Phong.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Thứ tự nào sau đây có thể là lịch phỏng vấn t...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_41',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Sắp xếp tuyến tính`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 9 đến 12:`,
    passageText: `Bảy điệp viên An, Bình, Cường, Dung, Ân, Phong và Giang được xếp lịch phỏng vấn từ Thứ Hai
đến Chủ Nhật. Mỗi ngày chỉ phỏng vấn một người và tất cả đều được phỏng vấn trong tuần này.
Thứ tự được xác định bởi các quy tắc sau:
• Cường phỏng vấn vào Thứ Tư.
• Dung phỏng vấn vào một ngày liền kề với Ân.
• Nếu Giang phỏng vấn muộn hơn Dung trong tuần, thì Phong phỏng vấn vào Thứ Bảy và
Bình phỏng vấn vào Chủ Nhật.
• Nếu An phỏng vấn sớm hơn Ân trong tuần, thì Bình phỏng vấn vào Thứ Bảy và Phong
phỏng vấn vào Chủ Nhật.
• Giang phỏng vấn vào một ngày liền kề với An.`,
    stem: `Nếu Giang được phỏng vấn vào Thứ Sáu, thì có bao nhiêu điệp viên mà bạn có thể xác
định được chính xác ngày phỏng vấn của họ?`,
    choices: [
      { id: 'A', text: `2.` },
      { id: 'B', text: `3.` },
      { id: 'C', text: `4.` },
      { id: 'D', text: `5.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Nếu Giang được phỏng vấn vào Thứ Sáu, thì có bao nhiêu điệp viên mà bạn có thể xác
định được chính xác ngày phỏng vấn của họ?

📊 **Sơ đồ thứ tự sắp xếp:**
| Vị trí | 1 | 2 | 3 | 4 | 5 | ... |
| Đối tượng | [Theo quy tắc ràng buộc] |

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (2.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (3.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (4.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (5.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Nếu Giang được phỏng vấn vào Thứ Sáu, thì có ...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_42',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Sắp xếp tuyến tính`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 9 đến 12:`,
    passageText: `Bảy điệp viên An, Bình, Cường, Dung, Ân, Phong và Giang được xếp lịch phỏng vấn từ Thứ Hai
đến Chủ Nhật. Mỗi ngày chỉ phỏng vấn một người và tất cả đều được phỏng vấn trong tuần này.
Thứ tự được xác định bởi các quy tắc sau:
• Cường phỏng vấn vào Thứ Tư.
• Dung phỏng vấn vào một ngày liền kề với Ân.
• Nếu Giang phỏng vấn muộn hơn Dung trong tuần, thì Phong phỏng vấn vào Thứ Bảy và
Bình phỏng vấn vào Chủ Nhật.
• Nếu An phỏng vấn sớm hơn Ân trong tuần, thì Bình phỏng vấn vào Thứ Bảy và Phong
phỏng vấn vào Chủ Nhật.
• Giang phỏng vấn vào một ngày liền kề với An.`,
    stem: `Nếu Bình được phỏng vấn sớm hơn Phong, điều nào sau đây CHẮC CHẮN ĐÚNG?`,
    choices: [
      { id: 'A', text: `Giang phỏng vấn sớm hơn Dung trong tuần.` },
      { id: 'B', text: `An phỏng vấn vào Thứ Hai và Giang phỏng vấn vào Thứ Ba.` },
      { id: 'C', text: `Cường phỏng vấn sớm hơn An trong tuần.` },
      { id: 'D', text: `Bình và Dung phỏng vấn vào hai ngày liền kề.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Nếu Bình được phỏng vấn sớm hơn Phong, điều nào sau đây CHẮC CHẮN ĐÚNG?

📊 **Sơ đồ thứ tự sắp xếp:**
| Vị trí | 1 | 2 | 3 | 4 | 5 | ... |
| Đối tượng | [Theo quy tắc ràng buộc] |

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (Giang phỏng vấn sớm hơn Dung trong tuần.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (An phỏng vấn vào Thứ Hai và Giang phỏng vấn vào Thứ Ba.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (Cường phỏng vấn sớm hơn An trong tuần.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (Bình và Dung phỏng vấn vào hai ngày liền kề.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Nếu Bình được phỏng vấn sớm hơn Phong, điều n...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_43',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Sắp xếp tuyến tính`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 9 đến 12:`,
    passageText: `Bảy điệp viên An, Bình, Cường, Dung, Ân, Phong và Giang được xếp lịch phỏng vấn từ Thứ Hai
đến Chủ Nhật. Mỗi ngày chỉ phỏng vấn một người và tất cả đều được phỏng vấn trong tuần này.
Thứ tự được xác định bởi các quy tắc sau:
• Cường phỏng vấn vào Thứ Tư.
• Dung phỏng vấn vào một ngày liền kề với Ân.
• Nếu Giang phỏng vấn muộn hơn Dung trong tuần, thì Phong phỏng vấn vào Thứ Bảy và
Bình phỏng vấn vào Chủ Nhật.
• Nếu An phỏng vấn sớm hơn Ân trong tuần, thì Bình phỏng vấn vào Thứ Bảy và Phong
phỏng vấn vào Chủ Nhật.
• Giang phỏng vấn vào một ngày liền kề với An.`,
    stem: `Nếu Giang phỏng vấn sớm hơn An trong tuần, điều nào sau đây CÓ THỂ đúng?`,
    choices: [
      { id: 'A', text: `Giang phỏng vấn vào Thứ Sáu.` },
      { id: 'B', text: `An phỏng vấn vào Thứ Hai.` },
      { id: 'C', text: `Giang phỏng vấn vào Thứ Ba.` },
      { id: 'D', text: `An phỏng vấn vào Thứ Sáu.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Nếu Giang phỏng vấn sớm hơn An trong tuần, điều nào sau đây CÓ THỂ đúng?

📊 **Sơ đồ thứ tự sắp xếp:**
| Vị trí | 1 | 2 | 3 | 4 | 5 | ... |
| Đối tượng | [Theo quy tắc ràng buộc] |

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (Giang phỏng vấn vào Thứ Sáu.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (An phỏng vấn vào Thứ Hai.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (Giang phỏng vấn vào Thứ Ba.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (An phỏng vấn vào Thứ Sáu.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Nếu Giang phỏng vấn sớm hơn An trong tuần, đi...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_44',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Sắp xếp tuyến tính`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 13 đến 16:`,
    passageText: `Bác sĩ thú y xếp lịch chải lông cho 7 chú chó: An, Bình, Cường, Dung, Ân, Phong, Giang. Lịch
trình tuân theo các ràng buộc:
• Bình được chải lông thứ 2.
• Ân được chải lông thứ 4.
• An được chải lông trước Dung.
• Phong được chải lông liền kề với Giang.
• Có đúng một chú chó được chải lông ở giữa Dung và An.`,
    stem: `Thứ tự nào sau đây có thể là lịch chải lông cho các chú chó?`,
    choices: [
      { id: 'A', text: `An, Bình, Dung, Phong, Ân, Giang, Cường.` },
      { id: 'B', text: `Cường, Bình, An, Ân, Dung, Phong, Giang.` },
      { id: 'C', text: `An, Bình, Cường, Ân, Phong, Giang, Dung.` },
      { id: 'D', text: `Phong, Bình, Giang, Ân, An, Cường, Dung.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Thứ tự nào sau đây có thể là lịch chải lông cho các chú chó?

📊 **Sơ đồ thứ tự sắp xếp:**
| Vị trí | 1 | 2 | 3 | 4 | 5 | ... |
| Đối tượng | [Theo quy tắc ràng buộc] |

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (An, Bình, Dung, Phong, Ân, Giang, Cường.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (Cường, Bình, An, Ân, Dung, Phong, Giang.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (An, Bình, Cường, Ân, Phong, Giang, Dung.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (Phong, Bình, Giang, Ân, An, Cường, Dung.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Thứ tự nào sau đây có thể là lịch chải lông c...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_45',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Sắp xếp tuyến tính`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 13 đến 16:`,
    passageText: `Bác sĩ thú y xếp lịch chải lông cho 7 chú chó: An, Bình, Cường, Dung, Ân, Phong, Giang. Lịch
trình tuân theo các ràng buộc:
• Bình được chải lông thứ 2.
• Ân được chải lông thứ 4.
• An được chải lông trước Dung.
• Phong được chải lông liền kề với Giang.
• Có đúng một chú chó được chải lông ở giữa Dung và An.`,
    stem: `Nếu Cường được chải lông thứ 7, điều nào sau đây CHẮC CHẮN ĐÚNG?`,
    choices: [
      { id: 'A', text: `An được chải lông thứ 1.` },
      { id: 'B', text: `Dung được chải lông thứ 3.` },
      { id: 'C', text: `Phong được chải lông thứ 6.` },
      { id: 'D', text: `Giang được chải lông thứ 5.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Nếu Cường được chải lông thứ 7, điều nào sau đây CHẮC CHẮN ĐÚNG?

📊 **Sơ đồ thứ tự sắp xếp:**
| Vị trí | 1 | 2 | 3 | 4 | 5 | ... |
| Đối tượng | [Theo quy tắc ràng buộc] |

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (An được chải lông thứ 1.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (Dung được chải lông thứ 3.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (Phong được chải lông thứ 6.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (Giang được chải lông thứ 5.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Nếu Cường được chải lông thứ 7, điều nào sau ...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_46',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Sắp xếp tuyến tính`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 13 đến 16:`,
    passageText: `Bác sĩ thú y xếp lịch chải lông cho 7 chú chó: An, Bình, Cường, Dung, Ân, Phong, Giang. Lịch
trình tuân theo các ràng buộc:
• Bình được chải lông thứ 2.
• Ân được chải lông thứ 4.
• An được chải lông trước Dung.
• Phong được chải lông liền kề với Giang.
• Có đúng một chú chó được chải lông ở giữa Dung và An.`,
    stem: `Nếu Phong được chải lông thứ 6, điều nào sau đây KHÔNG THỂ ĐÚNG?`,
    choices: [
      { id: 'A', text: `Cường được chải lông thứ 1.` },
      { id: 'B', text: `An được chải lông thứ 3.` },
      { id: 'C', text: `Giang được chải lông thứ 3.` },
      { id: 'D', text: `Dung được chải lông thứ 5.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Nếu Phong được chải lông thứ 6, điều nào sau đây KHÔNG THỂ ĐÚNG?

📊 **Sơ đồ thứ tự sắp xếp:**
| Vị trí | 1 | 2 | 3 | 4 | 5 | ... |
| Đối tượng | [Theo quy tắc ràng buộc] |

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (Cường được chải lông thứ 1.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (An được chải lông thứ 3.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (Giang được chải lông thứ 3.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (Dung được chải lông thứ 5.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Nếu Phong được chải lông thứ 6, điều nào sau ...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_47',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Sắp xếp tuyến tính`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 13 đến 16:`,
    passageText: `Bác sĩ thú y xếp lịch chải lông cho 7 chú chó: An, Bình, Cường, Dung, Ân, Phong, Giang. Lịch
trình tuân theo các ràng buộc:
• Bình được chải lông thứ 2.
• Ân được chải lông thứ 4.
• An được chải lông trước Dung.
• Phong được chải lông liền kề với Giang.
• Có đúng một chú chó được chải lông ở giữa Dung và An.`,
    stem: `Có bao nhiêu thứ tự khác nhau có thể xảy ra cho 7 chú chó?`,
    choices: [
      { id: 'A', text: `2.` },
      { id: 'B', text: `4.` },
      { id: 'C', text: `6.` },
      { id: 'D', text: `8.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Có bao nhiêu thứ tự khác nhau có thể xảy ra cho 7 chú chó?

📊 **Sơ đồ thứ tự sắp xếp:**
| Vị trí | 1 | 2 | 3 | 4 | 5 | ... |
| Đối tượng | [Theo quy tắc ràng buộc] |

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (2.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (4.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (6.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (8.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Có bao nhiêu thứ tự khác nhau có thể xảy ra c...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_48',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Tuyến tính phức tạp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 1 đến 4:`,
    passageText: `Bốn phóng viên (An, Bình, Cường, Dung) sẽ phỏng vấn bốn vận động viên (Ân, Phong, Giang,
Hòa). Có 4 khung giờ phỏng vấn (từ 1 đến 4), mỗi khung giờ sẽ có đúng một phóng viên và một
vận động viên làm việc với nhau. Các cặp được xếp như sau:
• Dung không phỏng vấn Hòa và không phỏng vấn Phong.
• Cường phỏng vấn Ân.
• Nếu Giang không được phỏng vấn đầu tiên (khung giờ 1), thì anh ấy được phỏng vấn cuối
cùng (khung giờ 4).
• Hòa được phỏng vấn ở khung giờ ngay trước khung giờ của Ân.`,
    stem: `Thứ tự các vận động viên được phỏng vấn từ khung giờ 1 đến 4 có thể là:`,
    choices: [
      { id: 'A', text: `Hòa, Ân, Phong, Giang.` },
      { id: 'B', text: `Ân, Phong, Hòa, Giang.` },
      { id: 'C', text: `Hòa, Giang, Ân, Phong.` },
      { id: 'D', text: `Giang, Phong, Ân, Hòa.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Thứ tự các vận động viên được phỏng vấn từ khung giờ 1 đến 4 có thể là:

📊 **Sơ đồ thứ tự sắp xếp:**
| Vị trí | 1 | 2 | 3 | 4 | 5 | ... |
| Đối tượng | [Theo quy tắc ràng buộc] |

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (Hòa, Ân, Phong, Giang.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (Ân, Phong, Hòa, Giang.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (Hòa, Giang, Ân, Phong.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (Giang, Phong, Ân, Hòa.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Thứ tự các vận động viên được phỏng vấn từ kh...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_49',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Tuyến tính phức tạp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 1 đến 4:`,
    passageText: `Bốn phóng viên (An, Bình, Cường, Dung) sẽ phỏng vấn bốn vận động viên (Ân, Phong, Giang,
Hòa). Có 4 khung giờ phỏng vấn (từ 1 đến 4), mỗi khung giờ sẽ có đúng một phóng viên và một
vận động viên làm việc với nhau. Các cặp được xếp như sau:
• Dung không phỏng vấn Hòa và không phỏng vấn Phong.
• Cường phỏng vấn Ân.
• Nếu Giang không được phỏng vấn đầu tiên (khung giờ 1), thì anh ấy được phỏng vấn cuối
cùng (khung giờ 4).
• Hòa được phỏng vấn ở khung giờ ngay trước khung giờ của Ân.`,
    stem: `Nếu Phong được phỏng vấn ở khung giờ thứ 4, điều nào CHẮC CHẮN ĐÚNG?`,
    choices: [
      { id: 'A', text: `Dung phỏng vấn ở khung giờ thứ 4.` },
      { id: 'B', text: `Bình phỏng vấn ở khung giờ thứ 2.` },
      { id: 'C', text: `Cường phỏng vấn ở khung giờ thứ 3.` },
      { id: 'D', text: `Giang được phỏng vấn đầu tiên.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Nếu Phong được phỏng vấn ở khung giờ thứ 4, điều nào CHẮC CHẮN ĐÚNG?

📊 **Sơ đồ thứ tự sắp xếp:**
| Vị trí | 1 | 2 | 3 | 4 | 5 | ... |
| Đối tượng | [Theo quy tắc ràng buộc] |

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (Dung phỏng vấn ở khung giờ thứ 4.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (Bình phỏng vấn ở khung giờ thứ 2.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (Cường phỏng vấn ở khung giờ thứ 3.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (Giang được phỏng vấn đầu tiên.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Nếu Phong được phỏng vấn ở khung giờ thứ 4, đ...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_50',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Tuyến tính phức tạp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 1 đến 4:`,
    passageText: `Bốn phóng viên (An, Bình, Cường, Dung) sẽ phỏng vấn bốn vận động viên (Ân, Phong, Giang,
Hòa). Có 4 khung giờ phỏng vấn (từ 1 đến 4), mỗi khung giờ sẽ có đúng một phóng viên và một
vận động viên làm việc với nhau. Các cặp được xếp như sau:
• Dung không phỏng vấn Hòa và không phỏng vấn Phong.
• Cường phỏng vấn Ân.
• Nếu Giang không được phỏng vấn đầu tiên (khung giờ 1), thì anh ấy được phỏng vấn cuối
cùng (khung giờ 4).
• Hòa được phỏng vấn ở khung giờ ngay trước khung giờ của Ân.`,
    stem: `Nếu An phỏng vấn ở khung giờ thứ 3, điều nào KHÔNG THỂ đúng?`,
    choices: [
      { id: 'A', text: `Cường phỏng vấn ở khung giờ thứ 2.` },
      { id: 'B', text: `Phong được phỏng vấn ở khung giờ thứ 4.` },
      { id: 'C', text: `Bình phỏng vấn đầu tiên.` },
      { id: 'D', text: `Hòa được phỏng vấn đầu tiên.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Nếu An phỏng vấn ở khung giờ thứ 3, điều nào KHÔNG THỂ đúng?

📊 **Sơ đồ thứ tự sắp xếp:**
| Vị trí | 1 | 2 | 3 | 4 | 5 | ... |
| Đối tượng | [Theo quy tắc ràng buộc] |

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (Cường phỏng vấn ở khung giờ thứ 2.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (Phong được phỏng vấn ở khung giờ thứ 4.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (Bình phỏng vấn đầu tiên.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (Hòa được phỏng vấn đầu tiên.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Nếu An phỏng vấn ở khung giờ thứ 3, điều nào ...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_51',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Tuyến tính phức tạp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 1 đến 4:`,
    passageText: `Bốn phóng viên (An, Bình, Cường, Dung) sẽ phỏng vấn bốn vận động viên (Ân, Phong, Giang,
Hòa). Có 4 khung giờ phỏng vấn (từ 1 đến 4), mỗi khung giờ sẽ có đúng một phóng viên và một
vận động viên làm việc với nhau. Các cặp được xếp như sau:
• Dung không phỏng vấn Hòa và không phỏng vấn Phong.
• Cường phỏng vấn Ân.
• Nếu Giang không được phỏng vấn đầu tiên (khung giờ 1), thì anh ấy được phỏng vấn cuối
cùng (khung giờ 4).
• Hòa được phỏng vấn ở khung giờ ngay trước khung giờ của Ân.`,
    stem: `Nếu An và Bình phỏng vấn ở hai khung giờ liên tiếp nhau, điều nào CHẮC CHẮN ĐÚNG?`,
    choices: [
      { id: 'A', text: `Dung phỏng vấn Giang ở khung giờ 3.` },
      { id: 'B', text: `Bình phỏng vấn Giang trước khi Ân được phỏng vấn.` },
      { id: 'C', text: `Giang được phỏng vấn đầu tiên, và Hòa được phỏng vấn thứ hai.` },
      { id: 'D', text: `Hòa không được phỏng vấn ở khung giờ ngay trước khi Phong được phỏng vấn.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Nếu An và Bình phỏng vấn ở hai khung giờ liên tiếp nhau, điều nào CHẮC CHẮN ĐÚNG?

📊 **Sơ đồ thứ tự sắp xếp:**
| Vị trí | 1 | 2 | 3 | 4 | 5 | ... |
| Đối tượng | [Theo quy tắc ràng buộc] |

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (Dung phỏng vấn Giang ở khung giờ 3.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (Bình phỏng vấn Giang trước khi Ân được phỏng vấn.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (Giang được phỏng vấn đầu tiên, và Hòa được phỏng vấn thứ hai.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (Hòa không được phỏng vấn ở khung giờ ngay trước khi Phong được phỏng vấn.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Nếu An và Bình phỏng vấn ở hai khung giờ liên...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_52',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Tuyến tính phức tạp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 5 đến 8:`,
    passageText: `Trung tâm thú y xếp 5 chú chó (Vàng, Mực, Phèn, Đốm, Bông) và 5 chú mèo (Mun, Mướp, Nhép,
Béo, Lười) vào 5 phòng (đánh số từ 1 đến 5). Mỗi phòng chứa đúng 1 chó và 1 mèo.
• Chó Đốm ở phòng liền kề với phòng của chó Bông.
• Mèo Mun ở phòng số 3.
• Chó Phèn luôn ở cùng phòng với mèo Nhép.
• Chó Mực không ở cùng phòng với mèo Mướp.
• Mèo Mướp ở phòng có số lớn hơn phòng của chó Vàng.
• Nếu mèo Béo ở phòng 1, thì chó Đốm ở phòng 4.`,
    stem: `Xếp đặt nào sau đây có thể là danh sách các chú chó ở phòng 1 đến 5?`,
    choices: [
      { id: 'A', text: `Phèn, Mực, Đốm, Bông, Vàng.` },
      { id: 'B', text: `Bông, Mực, Vàng, Phèn, Đốm.` },
      { id: 'C', text: `Mực, Vàng, Bông, Đốm, Phèn.` },
      { id: 'D', text: `Phèn, Vàng, Đốm, Mực, Bông.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Xếp đặt nào sau đây có thể là danh sách các chú chó ở phòng 1 đến 5?

📊 **Sơ đồ thứ tự sắp xếp:**
| Vị trí | 1 | 2 | 3 | 4 | 5 | ... |
| Đối tượng | [Theo quy tắc ràng buộc] |

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (Phèn, Mực, Đốm, Bông, Vàng.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (Bông, Mực, Vàng, Phèn, Đốm.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (Mực, Vàng, Bông, Đốm, Phèn.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (Phèn, Vàng, Đốm, Mực, Bông.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Xếp đặt nào sau đây có thể là danh sách các c...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_53',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Tuyến tính phức tạp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 5 đến 8:`,
    passageText: `Trung tâm thú y xếp 5 chú chó (Vàng, Mực, Phèn, Đốm, Bông) và 5 chú mèo (Mun, Mướp, Nhép,
Béo, Lười) vào 5 phòng (đánh số từ 1 đến 5). Mỗi phòng chứa đúng 1 chó và 1 mèo.
• Chó Đốm ở phòng liền kề với phòng của chó Bông.
• Mèo Mun ở phòng số 3.
• Chó Phèn luôn ở cùng phòng với mèo Nhép.
• Chó Mực không ở cùng phòng với mèo Mướp.
• Mèo Mướp ở phòng có số lớn hơn phòng của chó Vàng.
• Nếu mèo Béo ở phòng 1, thì chó Đốm ở phòng 4.`,
    stem: `Nếu chó Phèn ở phòng 5 và chó Mực ở phòng 1, mèo Mướp CHẮC CHẮN ở phòng nào?`,
    choices: [
      { id: 'A', text: `Phòng 1.` },
      { id: 'B', text: `Phòng 2.` },
      { id: 'C', text: `Phòng 4.` },
      { id: 'D', text: `Phòng 5.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Nếu chó Phèn ở phòng 5 và chó Mực ở phòng 1, mèo Mướp CHẮC CHẮN ở phòng nào?

📊 **Sơ đồ thứ tự sắp xếp:**
| Vị trí | 1 | 2 | 3 | 4 | 5 | ... |
| Đối tượng | [Theo quy tắc ràng buộc] |

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (Phòng 1.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (Phòng 2.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (Phòng 4.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (Phòng 5.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Nếu chó Phèn ở phòng 5 và chó Mực ở phòng 1, ...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_54',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Tuyến tính phức tạp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 5 đến 8:`,
    passageText: `Trung tâm thú y xếp 5 chú chó (Vàng, Mực, Phèn, Đốm, Bông) và 5 chú mèo (Mun, Mướp, Nhép,
Béo, Lười) vào 5 phòng (đánh số từ 1 đến 5). Mỗi phòng chứa đúng 1 chó và 1 mèo.
• Chó Đốm ở phòng liền kề với phòng của chó Bông.
• Mèo Mun ở phòng số 3.
• Chó Phèn luôn ở cùng phòng với mèo Nhép.
• Chó Mực không ở cùng phòng với mèo Mướp.
• Mèo Mướp ở phòng có số lớn hơn phòng của chó Vàng.
• Nếu mèo Béo ở phòng 1, thì chó Đốm ở phòng 4.`,
    stem: `Nếu chó Vàng ở phòng 4, điều nào sau đây CHẮC CHẮN ĐÚNG?`,
    choices: [
      { id: 'A', text: `Mèo Mướp ở phòng 5.` },
      { id: 'B', text: `Mèo Béo ở phòng 1.` },
      { id: 'C', text: `Chó Đốm ở phòng 2.` },
      { id: 'D', text: `Chó Mực ở phòng 3.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Nếu chó Vàng ở phòng 4, điều nào sau đây CHẮC CHẮN ĐÚNG?

📊 **Sơ đồ thứ tự sắp xếp:**
| Vị trí | 1 | 2 | 3 | 4 | 5 | ... |
| Đối tượng | [Theo quy tắc ràng buộc] |

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (Mèo Mướp ở phòng 5.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (Mèo Béo ở phòng 1.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (Chó Đốm ở phòng 2.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (Chó Mực ở phòng 3.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Nếu chó Vàng ở phòng 4, điều nào sau đây CHẮC...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_55',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Tuyến tính phức tạp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 5 đến 8:`,
    passageText: `Trung tâm thú y xếp 5 chú chó (Vàng, Mực, Phèn, Đốm, Bông) và 5 chú mèo (Mun, Mướp, Nhép,
Béo, Lười) vào 5 phòng (đánh số từ 1 đến 5). Mỗi phòng chứa đúng 1 chó và 1 mèo.
• Chó Đốm ở phòng liền kề với phòng của chó Bông.
• Mèo Mun ở phòng số 3.
• Chó Phèn luôn ở cùng phòng với mèo Nhép.
• Chó Mực không ở cùng phòng với mèo Mướp.
• Mèo Mướp ở phòng có số lớn hơn phòng của chó Vàng.
• Nếu mèo Béo ở phòng 1, thì chó Đốm ở phòng 4.`,
    stem: `Tất cả các phát biểu sau đây đều CÓ THỂ đúng, NGOẠI TRỪ:`,
    choices: [
      { id: 'A', text: `Mèo Béo và chó Vàng cùng ở phòng 2.` },
      { id: 'B', text: `Mèo Nhép và chó Phèn cùng ở phòng 4.` },
      { id: 'C', text: `Mèo Lười và chó Đốm cùng ở phòng 1.` },
      { id: 'D', text: `Mèo Béo và chó Bông cùng ở phòng 1.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Tất cả các phát biểu sau đây đều CÓ THỂ đúng, NGOẠI TRỪ:

📊 **Sơ đồ thứ tự sắp xếp:**
| Vị trí | 1 | 2 | 3 | 4 | 5 | ... |
| Đối tượng | [Theo quy tắc ràng buộc] |

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (Mèo Béo và chó Vàng cùng ở phòng 2.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (Mèo Nhép và chó Phèn cùng ở phòng 4.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (Mèo Lười và chó Đốm cùng ở phòng 1.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (Mèo Béo và chó Bông cùng ở phòng 1.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Tất cả các phát biểu sau đây đều CÓ THỂ đúng,...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_56',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Tuyến tính phức tạp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 9 đến 12:`,
    passageText: `Trường Đại học tổ chức giải bóng bàn giao hữu giữa Khoa Toán (gồm An, Bình, Cường) và Khoa
Lý (gồm Dung, Ân, Phong). Có 3 trận đấu đơn (Trận 1, Trận 2, Trận 3). Trong mỗi trận, đúng
1 sinh viên Khoa Toán thi đấu với đúng 1 sinh viên Khoa Lý. Không ai thi đấu nhiều hơn 1 trận.
Lịch thi đấu thỏa mãn:
• Dung thi đấu ở Trận 2.
• Bình thi đấu ở trận có số thứ tự lớn hơn trận của Ân.
• An không bao giờ thi đấu với Dung.
• Cường không thi đấu với Phong.
• Nếu An thi đấu ở Trận 1, thì Cường thi đấu với Dung.`,
    stem: `Lịch thi đấu nào sau đây (theo thứ tự Trận 1, Trận 2, Trận 3) CÓ THỂ ĐÚNG? (Mỗi trận
ghi dạng: Toán đấu Lý)`,
    choices: [
      { id: 'A', text: `Trận 1: An đấu Dung; Trận 2: Bình đấu Ân; Trận 3: Cường đấu Phong.` },
      { id: 'B', text: `Trận 1: Bình đấu Ân; Trận 2: Cường đấu Dung; Trận 3: An đấu Phong.` },
      { id: 'C', text: `Trận 1: An đấu Ân; Trận 2: Cường đấu Dung; Trận 3: Bình đấu Phong.` },
      { id: 'D', text: `Trận 1: Cường đấu Ân; Trận 2: An đấu Dung; Trận 3: Bình đấu Phong.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Lịch thi đấu nào sau đây (theo thứ tự Trận 1, Trận 2, Trận 3) CÓ THỂ ĐÚNG? (Mỗi trận
ghi dạng: Toán đấu Lý)

📊 **Sơ đồ thứ tự sắp xếp:**
| Vị trí | 1 | 2 | 3 | 4 | 5 | ... |
| Đối tượng | [Theo quy tắc ràng buộc] |

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (Trận 1: An đấu Dung; Trận 2: Bình đấu Ân; Trận 3: Cường đấu Phong.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (Trận 1: Bình đấu Ân; Trận 2: Cường đấu Dung; Trận 3: An đấu Phong.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (Trận 1: An đấu Ân; Trận 2: Cường đấu Dung; Trận 3: Bình đấu Phong.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (Trận 1: Cường đấu Ân; Trận 2: An đấu Dung; Trận 3: Bình đấu Phong.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Lịch thi đấu nào sau đây (theo thứ tự Trận 1,...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_57',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Tuyến tính phức tạp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 9 đến 12:`,
    passageText: `Trường Đại học tổ chức giải bóng bàn giao hữu giữa Khoa Toán (gồm An, Bình, Cường) và Khoa
Lý (gồm Dung, Ân, Phong). Có 3 trận đấu đơn (Trận 1, Trận 2, Trận 3). Trong mỗi trận, đúng
1 sinh viên Khoa Toán thi đấu với đúng 1 sinh viên Khoa Lý. Không ai thi đấu nhiều hơn 1 trận.
Lịch thi đấu thỏa mãn:
• Dung thi đấu ở Trận 2.
• Bình thi đấu ở trận có số thứ tự lớn hơn trận của Ân.
• An không bao giờ thi đấu với Dung.
• Cường không thi đấu với Phong.
• Nếu An thi đấu ở Trận 1, thì Cường thi đấu với Dung.`,
    stem: `Nếu Cường thi đấu ở Trận 1, điều nào sau đây CHẮC CHẮN ĐÚNG?`,
    choices: [
      { id: 'A', text: `Bình thi đấu ở Trận 2.` },
      { id: 'B', text: `An thi đấu ở Trận 3.` },
      { id: 'C', text: `Ân thi đấu ở Trận 2.` },
      { id: 'D', text: `Phong thi đấu ở Trận 3.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Nếu Cường thi đấu ở Trận 1, điều nào sau đây CHẮC CHẮN ĐÚNG?

📊 **Sơ đồ thứ tự sắp xếp:**
| Vị trí | 1 | 2 | 3 | 4 | 5 | ... |
| Đối tượng | [Theo quy tắc ràng buộc] |

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (Bình thi đấu ở Trận 2.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (An thi đấu ở Trận 3.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (Ân thi đấu ở Trận 2.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (Phong thi đấu ở Trận 3.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Nếu Cường thi đấu ở Trận 1, điều nào sau đây ...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_58',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Tuyến tính phức tạp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 9 đến 12:`,
    passageText: `Trường Đại học tổ chức giải bóng bàn giao hữu giữa Khoa Toán (gồm An, Bình, Cường) và Khoa
Lý (gồm Dung, Ân, Phong). Có 3 trận đấu đơn (Trận 1, Trận 2, Trận 3). Trong mỗi trận, đúng
1 sinh viên Khoa Toán thi đấu với đúng 1 sinh viên Khoa Lý. Không ai thi đấu nhiều hơn 1 trận.
Lịch thi đấu thỏa mãn:
• Dung thi đấu ở Trận 2.
• Bình thi đấu ở trận có số thứ tự lớn hơn trận của Ân.
• An không bao giờ thi đấu với Dung.
• Cường không thi đấu với Phong.
• Nếu An thi đấu ở Trận 1, thì Cường thi đấu với Dung.`,
    stem: `Tất cả các phát biểu sau đây đều CÓ THỂ ĐÚNG, NGOẠI TRỪ:`,
    choices: [
      { id: 'A', text: `Bình thi đấu với Dung.` },
      { id: 'B', text: `Cường thi đấu với Ân.` },
      { id: 'C', text: `An thi đấu với Phong.` },
      { id: 'D', text: `Bình thi đấu với Ân.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Tất cả các phát biểu sau đây đều CÓ THỂ ĐÚNG, NGOẠI TRỪ:

📊 **Sơ đồ thứ tự sắp xếp:**
| Vị trí | 1 | 2 | 3 | 4 | 5 | ... |
| Đối tượng | [Theo quy tắc ràng buộc] |

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (Bình thi đấu với Dung.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (Cường thi đấu với Ân.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (An thi đấu với Phong.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (Bình thi đấu với Ân.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Tất cả các phát biểu sau đây đều CÓ THỂ ĐÚNG,...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_59',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Tuyến tính phức tạp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 9 đến 12:`,
    passageText: `Trường Đại học tổ chức giải bóng bàn giao hữu giữa Khoa Toán (gồm An, Bình, Cường) và Khoa
Lý (gồm Dung, Ân, Phong). Có 3 trận đấu đơn (Trận 1, Trận 2, Trận 3). Trong mỗi trận, đúng
1 sinh viên Khoa Toán thi đấu với đúng 1 sinh viên Khoa Lý. Không ai thi đấu nhiều hơn 1 trận.
Lịch thi đấu thỏa mãn:
• Dung thi đấu ở Trận 2.
• Bình thi đấu ở trận có số thứ tự lớn hơn trận của Ân.
• An không bao giờ thi đấu với Dung.
• Cường không thi đấu với Phong.
• Nếu An thi đấu ở Trận 1, thì Cường thi đấu với Dung.`,
    stem: `Nếu Bình thi đấu ở Trận 2, ai là người thi đấu với Phong?`,
    choices: [
      { id: 'A', text: `An.` },
      { id: 'B', text: `Bình.` },
      { id: 'C', text: `Cường.` },
      { id: 'D', text: `Không thể xác định.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Nếu Bình thi đấu ở Trận 2, ai là người thi đấu với Phong?

📊 **Sơ đồ thứ tự sắp xếp:**
| Vị trí | 1 | 2 | 3 | 4 | 5 | ... |
| Đối tượng | [Theo quy tắc ràng buộc] |

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (An.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (Bình.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (Cường.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (Không thể xác định.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Nếu Bình thi đấu ở Trận 2, ai là người thi đấ...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_60',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Tuyến tính phức tạp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 13 đến 16:`,
    passageText: `Có 5 ngôi nhà xếp thành một hàng ngang (đánh số từ 1 đến 5 từ trái sang phải). Có 5 người chủ
(An, Bình, Cường, Dung, Ân) và 5 thú cưng (Mèo, Chó, Cá, Chim, Rùa). Mỗi nhà có đúng 1
người chủ và 1 thú cưng.
• Cường sống ở nhà số 4.
• Người nuôi Cá sống ở nhà ngay bên trái nhà của Dung.
• An không nuôi Chó và không nuôi Rùa.
• Người nuôi Chim sống ở nhà có số nhỏ hơn nhà của người nuôi Mèo.
• Bình sống ngay bên cạnh người nuôi Mèo.
• Ân nuôi Cá.`,
    stem: `Danh sách nào sau đây CÓ THỂ là các thú cưng từ nhà 1 đến nhà 5?`,
    choices: [
      { id: 'A', text: `Chim, Rùa, Mèo, Cá, Chó.` },
      { id: 'B', text: `Chó, Chim, Cá, Mèo, Rùa.` },
      { id: 'C', text: `Rùa, Chim, Mèo, Chó, Cá.` },
      { id: 'D', text: `Chim, Cá, Rùa, Mèo, Chó.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Danh sách nào sau đây CÓ THỂ là các thú cưng từ nhà 1 đến nhà 5?

📊 **Sơ đồ thứ tự sắp xếp:**
| Vị trí | 1 | 2 | 3 | 4 | 5 | ... |
| Đối tượng | [Theo quy tắc ràng buộc] |

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (Chim, Rùa, Mèo, Cá, Chó.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (Chó, Chim, Cá, Mèo, Rùa.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (Rùa, Chim, Mèo, Chó, Cá.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (Chim, Cá, Rùa, Mèo, Chó.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Danh sách nào sau đây CÓ THỂ là các thú cưng ...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_61',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Tuyến tính phức tạp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 13 đến 16:`,
    passageText: `Có 5 ngôi nhà xếp thành một hàng ngang (đánh số từ 1 đến 5 từ trái sang phải). Có 5 người chủ
(An, Bình, Cường, Dung, Ân) và 5 thú cưng (Mèo, Chó, Cá, Chim, Rùa). Mỗi nhà có đúng 1
người chủ và 1 thú cưng.
• Cường sống ở nhà số 4.
• Người nuôi Cá sống ở nhà ngay bên trái nhà của Dung.
• An không nuôi Chó và không nuôi Rùa.
• Người nuôi Chim sống ở nhà có số nhỏ hơn nhà của người nuôi Mèo.
• Bình sống ngay bên cạnh người nuôi Mèo.
• Ân nuôi Cá.`,
    stem: `Người nào sau đây CHẮC CHẮN sống ở nhà số 5?`,
    choices: [
      { id: 'A', text: `An.` },
      { id: 'B', text: `Bình.` },
      { id: 'C', text: `Cường.` },
      { id: 'D', text: `Dung.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Người nào sau đây CHẮC CHẮN sống ở nhà số 5?

📊 **Sơ đồ thứ tự sắp xếp:**
| Vị trí | 1 | 2 | 3 | 4 | 5 | ... |
| Đối tượng | [Theo quy tắc ràng buộc] |

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (An.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (Bình.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (Cường.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (Dung.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Người nào sau đây CHẮC CHẮN sống ở nhà số 5?...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_62',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Tuyến tính phức tạp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 13 đến 16:`,
    passageText: `Có 5 ngôi nhà xếp thành một hàng ngang (đánh số từ 1 đến 5 từ trái sang phải). Có 5 người chủ
(An, Bình, Cường, Dung, Ân) và 5 thú cưng (Mèo, Chó, Cá, Chim, Rùa). Mỗi nhà có đúng 1
người chủ và 1 thú cưng.
• Cường sống ở nhà số 4.
• Người nuôi Cá sống ở nhà ngay bên trái nhà của Dung.
• An không nuôi Chó và không nuôi Rùa.
• Người nuôi Chim sống ở nhà có số nhỏ hơn nhà của người nuôi Mèo.
• Bình sống ngay bên cạnh người nuôi Mèo.
• Ân nuôi Cá.`,
    stem: `Cường nuôi thú cưng nào?`,
    choices: [
      { id: 'A', text: `Chó.` },
      { id: 'B', text: `Chim.` },
      { id: 'C', text: `Rùa.` },
      { id: 'D', text: `Mèo.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Cường nuôi thú cưng nào?

📊 **Sơ đồ thứ tự sắp xếp:**
| Vị trí | 1 | 2 | 3 | 4 | 5 | ... |
| Đối tượng | [Theo quy tắc ràng buộc] |

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (Chó.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (Chim.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (Rùa.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (Mèo.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Cường nuôi thú cưng nào?...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_63',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Tuyến tính phức tạp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 13 đến 16:`,
    passageText: `Có 5 ngôi nhà xếp thành một hàng ngang (đánh số từ 1 đến 5 từ trái sang phải). Có 5 người chủ
(An, Bình, Cường, Dung, Ân) và 5 thú cưng (Mèo, Chó, Cá, Chim, Rùa). Mỗi nhà có đúng 1
người chủ và 1 thú cưng.
• Cường sống ở nhà số 4.
• Người nuôi Cá sống ở nhà ngay bên trái nhà của Dung.
• An không nuôi Chó và không nuôi Rùa.
• Người nuôi Chim sống ở nhà có số nhỏ hơn nhà của người nuôi Mèo.
• Bình sống ngay bên cạnh người nuôi Mèo.
• Ân nuôi Cá.`,
    stem: `Nếu Dung nuôi Chó, điều nào sau đây CÓ THỂ ĐÚNG?`,
    choices: [
      { id: 'A', text: `An sống ở nhà số 3.` },
      { id: 'B', text: `Bình nuôi Rùa.` },
      { id: 'C', text: `Dung sống ở nhà số 2.` },
      { id: 'D', text: `Tất cả các phương án trên.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Nếu Dung nuôi Chó, điều nào sau đây CÓ THỂ ĐÚNG?

📊 **Sơ đồ thứ tự sắp xếp:**
| Vị trí | 1 | 2 | 3 | 4 | 5 | ... |
| Đối tượng | [Theo quy tắc ràng buộc] |

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (An sống ở nhà số 3.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (Bình nuôi Rùa.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (Dung sống ở nhà số 2.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (Tất cả các phương án trên.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Nếu Dung nuôi Chó, điều nào sau đây CÓ THỂ ĐÚ...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_64',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Phân chia nhóm`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 1 đến 4:`,
    passageText: `Hãng hàng không VietSky đang lên lịch cho các chuyến bay. Phi hành đoàn gồm 5 người: An,
Bình, Cường, Dung, và Ân. Hãng cần phân bổ nhân sự cho chuyến bay đến Hà Nội và chuyến
bay đến Huế, tuân theo các điều kiện sau:
• Mỗi chuyến bay cần đúng 1 lái chính, 1 lái phụ và 1 hoa tiêu.
• Có ĐÚNG MỘT người sẽ tham gia cả hai chuyến bay.
• Dung chỉ làm lái chính.
• Cường bắt buộc phải tham gia chuyến bay đi Huế.
• Ân sẽ không làm lái phụ trong một chuyến bay nếu Cường hoặc Bình làm lái chính hoặc
hoa tiêu của chuyến bay đó.
• Bình chỉ làm hoa tiêu trong một chuyến bay nếu An làm lái chính của chuyến bay đó.`,
    stem: `Nếu Cường làm lái chính chuyến bay đi Huế, điều nào sau đây CHẮC CHẮN ĐÚNG?`,
    choices: [
      { id: 'A', text: `An làm lái phụ chuyến bay đi Hà Nội.` },
      { id: 'B', text: `Dung làm lái phụ chuyến bay đi Huế.` },
      { id: 'C', text: `Bình tham gia chuyến bay đi Hà Nội.` },
      { id: 'D', text: `Cường làm hoa tiêu chuyến bay đi Huế.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Nếu Cường làm lái chính chuyến bay đi Huế, điều nào sau đây CHẮC CHẮN ĐÚNG?

📊 **Sơ đồ liên kết logic:**
[Dữ kiện đầu vào] ➔ [Suy luận quy tắc kéo theo] ➔ [Khẳng định kết luận]

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (An làm lái phụ chuyến bay đi Hà Nội.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (Dung làm lái phụ chuyến bay đi Huế.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (Bình tham gia chuyến bay đi Hà Nội.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (Cường làm hoa tiêu chuyến bay đi Huế.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Nếu Cường làm lái chính chuyến bay đi Huế, đi...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_65',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Phân chia nhóm`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 1 đến 4:`,
    passageText: `Hãng hàng không VietSky đang lên lịch cho các chuyến bay. Phi hành đoàn gồm 5 người: An,
Bình, Cường, Dung, và Ân. Hãng cần phân bổ nhân sự cho chuyến bay đến Hà Nội và chuyến
bay đến Huế, tuân theo các điều kiện sau:
• Mỗi chuyến bay cần đúng 1 lái chính, 1 lái phụ và 1 hoa tiêu.
• Có ĐÚNG MỘT người sẽ tham gia cả hai chuyến bay.
• Dung chỉ làm lái chính.
• Cường bắt buộc phải tham gia chuyến bay đi Huế.
• Ân sẽ không làm lái phụ trong một chuyến bay nếu Cường hoặc Bình làm lái chính hoặc
hoa tiêu của chuyến bay đó.
• Bình chỉ làm hoa tiêu trong một chuyến bay nếu An làm lái chính của chuyến bay đó.`,
    stem: `Nếu Bình làm hoa tiêu cho chuyến đi Hà Nội, ai BẮT BUỘC phải tham gia cả hai chuyến
bay?`,
    choices: [
      { id: 'A', text: `An.` },
      { id: 'B', text: `Cường.` },
      { id: 'C', text: `Dung.` },
      { id: 'D', text: `Ân.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Nếu Bình làm hoa tiêu cho chuyến đi Hà Nội, ai BẮT BUỘC phải tham gia cả hai chuyến
bay?

📊 **Sơ đồ liên kết logic:**
[Dữ kiện đầu vào] ➔ [Suy luận quy tắc kéo theo] ➔ [Khẳng định kết luận]

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (An.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (Cường.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (Dung.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (Ân.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Nếu Bình làm hoa tiêu cho chuyến đi Hà Nội, a...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_66',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Phân chia nhóm`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 1 đến 4:`,
    passageText: `Hãng hàng không VietSky đang lên lịch cho các chuyến bay. Phi hành đoàn gồm 5 người: An,
Bình, Cường, Dung, và Ân. Hãng cần phân bổ nhân sự cho chuyến bay đến Hà Nội và chuyến
bay đến Huế, tuân theo các điều kiện sau:
• Mỗi chuyến bay cần đúng 1 lái chính, 1 lái phụ và 1 hoa tiêu.
• Có ĐÚNG MỘT người sẽ tham gia cả hai chuyến bay.
• Dung chỉ làm lái chính.
• Cường bắt buộc phải tham gia chuyến bay đi Huế.
• Ân sẽ không làm lái phụ trong một chuyến bay nếu Cường hoặc Bình làm lái chính hoặc
hoa tiêu của chuyến bay đó.
• Bình chỉ làm hoa tiêu trong một chuyến bay nếu An làm lái chính của chuyến bay đó.`,
    stem: `Nếu Dung tham gia cả hai chuyến bay, điều nào sau đây CHẮC CHẮN ĐÚNG?`,
    choices: [
      { id: 'A', text: `Dung làm lái phụ chuyến đi Huế.` },
      { id: 'B', text: `Cường làm lái chính chuyến đi Hà Nội.` },
      { id: 'C', text: `Bình không làm hoa tiêu chuyến đi Hà Nội.` },
      { id: 'D', text: `An không làm hoa tiêu.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Nếu Dung tham gia cả hai chuyến bay, điều nào sau đây CHẮC CHẮN ĐÚNG?

📊 **Sơ đồ liên kết logic:**
[Dữ kiện đầu vào] ➔ [Suy luận quy tắc kéo theo] ➔ [Khẳng định kết luận]

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (Dung làm lái phụ chuyến đi Huế.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (Cường làm lái chính chuyến đi Hà Nội.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (Bình không làm hoa tiêu chuyến đi Hà Nội.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (An không làm hoa tiêu.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Nếu Dung tham gia cả hai chuyến bay, điều nào...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_67',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Phân chia nhóm`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 1 đến 4:`,
    passageText: `Hãng hàng không VietSky đang lên lịch cho các chuyến bay. Phi hành đoàn gồm 5 người: An,
Bình, Cường, Dung, và Ân. Hãng cần phân bổ nhân sự cho chuyến bay đến Hà Nội và chuyến
bay đến Huế, tuân theo các điều kiện sau:
• Mỗi chuyến bay cần đúng 1 lái chính, 1 lái phụ và 1 hoa tiêu.
• Có ĐÚNG MỘT người sẽ tham gia cả hai chuyến bay.
• Dung chỉ làm lái chính.
• Cường bắt buộc phải tham gia chuyến bay đi Huế.
• Ân sẽ không làm lái phụ trong một chuyến bay nếu Cường hoặc Bình làm lái chính hoặc
hoa tiêu của chuyến bay đó.
• Bình chỉ làm hoa tiêu trong một chuyến bay nếu An làm lái chính của chuyến bay đó.`,
    stem: `Nếu Ân làm lái phụ cho chuyến đi Hà Nội, điều nào sau đây CÓ THỂ đúng?`,
    choices: [
      { id: 'A', text: `Ân làm lái phụ cho chuyến đi Huế.` },
      { id: 'B', text: `Bình làm lái chính cho chuyến đi Hà Nội.` },
      { id: 'C', text: `An không làm hoa tiêu cho chuyến đi Hà Nội.` },
      { id: 'D', text: `Bình làm hoa tiêu cho chuyến đi Huế.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Nếu Ân làm lái phụ cho chuyến đi Hà Nội, điều nào sau đây CÓ THỂ đúng?

📊 **Sơ đồ liên kết logic:**
[Dữ kiện đầu vào] ➔ [Suy luận quy tắc kéo theo] ➔ [Khẳng định kết luận]

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (Ân làm lái phụ cho chuyến đi Huế.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (Bình làm lái chính cho chuyến đi Hà Nội.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (An không làm hoa tiêu cho chuyến đi Hà Nội.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (Bình làm hoa tiêu cho chuyến đi Huế.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Nếu Ân làm lái phụ cho chuyến đi Hà Nội, điều...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_68',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Phân chia nhóm`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 5 đến 8:`,
    passageText: `Trại chó đang phân bổ 7 chú cún (An, Bình, Cường, Dung, Ân, Phong, Giang) vào 2 chuồng
(Chuồng Lớn và Chuồng Nhỏ). Chuồng Lớn chứa đúng 4 chú cún. Chuồng Nhỏ chứa đúng 3 chú
cún. Việc phân bổ tuân theo các quy tắc sau:
• Nếu An vào Chuồng Lớn thì Cường cũng phải vào Chuồng Lớn.
• Ân và Phong không được ở chung một chuồng.
• Dung và Giang luôn ở chung một chuồng với nhau.
• Nếu Bình vào Chuồng Nhỏ thì Phong phải vào Chuồng Lớn.`,
    stem: `Danh sách nào sau đây CÓ THỂ là danh sách các cún ở Chuồng Nhỏ?`,
    choices: [
      { id: 'A', text: `An, Bình, Cường.` },
      { id: 'B', text: `Ân, Phong, Giang.` },
      { id: 'C', text: `Cường, Dung, Giang.` },
      { id: 'D', text: `Ân, Dung, Giang.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Danh sách nào sau đây CÓ THỂ là danh sách các cún ở Chuồng Nhỏ?

📊 **Sơ đồ phân bổ nhóm:**
Group A: {Các thành viên thỏa mãn quy tắc}
Group B: {Các thành viên còn lại}

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (An, Bình, Cường.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (Ân, Phong, Giang.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (Cường, Dung, Giang.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (Ân, Dung, Giang.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Danh sách nào sau đây CÓ THỂ là danh sách các...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_69',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Phân chia nhóm`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 5 đến 8:`,
    passageText: `Trại chó đang phân bổ 7 chú cún (An, Bình, Cường, Dung, Ân, Phong, Giang) vào 2 chuồng
(Chuồng Lớn và Chuồng Nhỏ). Chuồng Lớn chứa đúng 4 chú cún. Chuồng Nhỏ chứa đúng 3 chú
cún. Việc phân bổ tuân theo các quy tắc sau:
• Nếu An vào Chuồng Lớn thì Cường cũng phải vào Chuồng Lớn.
• Ân và Phong không được ở chung một chuồng.
• Dung và Giang luôn ở chung một chuồng với nhau.
• Nếu Bình vào Chuồng Nhỏ thì Phong phải vào Chuồng Lớn.`,
    stem: `Nếu An và Bình ở chung một chuồng, điều nào sau đây CHẮC CHẮN ĐÚNG?`,
    choices: [
      { id: 'A', text: `Phong ở Chuồng Nhỏ.` },
      { id: 'B', text: `Dung ở Chuồng Lớn.` },
      { id: 'C', text: `Ân ở Chuồng Nhỏ.` },
      { id: 'D', text: `Cường ở Chuồng Lớn.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Nếu An và Bình ở chung một chuồng, điều nào sau đây CHẮC CHẮN ĐÚNG?

📊 **Sơ đồ phân bổ nhóm:**
Group A: {Các thành viên thỏa mãn quy tắc}
Group B: {Các thành viên còn lại}

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (Phong ở Chuồng Nhỏ.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (Dung ở Chuồng Lớn.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (Ân ở Chuồng Nhỏ.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (Cường ở Chuồng Lớn.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Nếu An và Bình ở chung một chuồng, điều nào s...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_70',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Phân chia nhóm`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 5 đến 8:`,
    passageText: `Trại chó đang phân bổ 7 chú cún (An, Bình, Cường, Dung, Ân, Phong, Giang) vào 2 chuồng
(Chuồng Lớn và Chuồng Nhỏ). Chuồng Lớn chứa đúng 4 chú cún. Chuồng Nhỏ chứa đúng 3 chú
cún. Việc phân bổ tuân theo các quy tắc sau:
• Nếu An vào Chuồng Lớn thì Cường cũng phải vào Chuồng Lớn.
• Ân và Phong không được ở chung một chuồng.
• Dung và Giang luôn ở chung một chuồng với nhau.
• Nếu Bình vào Chuồng Nhỏ thì Phong phải vào Chuồng Lớn.`,
    stem: `Nếu Cường ở Chuồng Nhỏ, cặp cún nào sau đây phải ở Chuồng Lớn?`,
    choices: [
      { id: 'A', text: `An và Bình.` },
      { id: 'B', text: `An và Dung.` },
      { id: 'C', text: `Bình và Phong.` },
      { id: 'D', text: `Dung và Giang.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Nếu Cường ở Chuồng Nhỏ, cặp cún nào sau đây phải ở Chuồng Lớn?

📊 **Sơ đồ phân bổ nhóm:**
Group A: {Các thành viên thỏa mãn quy tắc}
Group B: {Các thành viên còn lại}

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (An và Bình.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (An và Dung.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (Bình và Phong.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (Dung và Giang.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Nếu Cường ở Chuồng Nhỏ, cặp cún nào sau đây p...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_71',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Phân chia nhóm`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 5 đến 8:`,
    passageText: `Trại chó đang phân bổ 7 chú cún (An, Bình, Cường, Dung, Ân, Phong, Giang) vào 2 chuồng
(Chuồng Lớn và Chuồng Nhỏ). Chuồng Lớn chứa đúng 4 chú cún. Chuồng Nhỏ chứa đúng 3 chú
cún. Việc phân bổ tuân theo các quy tắc sau:
• Nếu An vào Chuồng Lớn thì Cường cũng phải vào Chuồng Lớn.
• Ân và Phong không được ở chung một chuồng.
• Dung và Giang luôn ở chung một chuồng với nhau.
• Nếu Bình vào Chuồng Nhỏ thì Phong phải vào Chuồng Lớn.`,
    stem: `Tất cả các danh sách sau đây đều CÓ THỂ là danh sách các cún ở Chuồng Lớn, NGOẠI
TRỪ:`,
    choices: [
      { id: 'A', text: `An, Bình, Cường, Phong.` },
      { id: 'B', text: `Bình, Cường, Dung, Giang.` },
      { id: 'C', text: `Cường, Dung, Giang, Phong.` },
      { id: 'D', text: `An, Bình, Cường, Ân.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Tất cả các danh sách sau đây đều CÓ THỂ là danh sách các cún ở Chuồng Lớn, NGOẠI
TRỪ:

📊 **Sơ đồ phân bổ nhóm:**
Group A: {Các thành viên thỏa mãn quy tắc}
Group B: {Các thành viên còn lại}

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (An, Bình, Cường, Phong.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (Bình, Cường, Dung, Giang.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (Cường, Dung, Giang, Phong.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (An, Bình, Cường, Ân.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Tất cả các danh sách sau đây đều CÓ THỂ là da...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_72',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Phân chia nhóm`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 9 đến 12:`,
    passageText: `Tổ chức tình nguyện phân công 8 học sinh (An, Bình, Cường, Dung, Ân, Phong, Giang, Hoa) vào
3 quầy bán nước gây quỹ (Quầy 1, Quầy 2, Quầy 3). Quầy 1 cần đúng 3 học sinh, Quầy 2 cần
đúng 3 học sinh, Quầy 3 cần đúng 2 học sinh. Việc phân công tuân theo:
• An luôn làm cùng quầy với Bình.
• Cường làm ở Quầy 2.
• Dung làm ở Quầy 1.
• Hoa làm ở Quầy 3.
• Phong và Giang không được làm cùng quầy với nhau.
• Nếu Ân làm ở Quầy 2, thì Phong phải làm ở Quầy 1.`,
    stem: `An và Bình BẮT BUỘC phải làm việc ở quầy nào?`,
    choices: [
      { id: 'A', text: `Quầy 1.` },
      { id: 'B', text: `Quầy 2.` },
      { id: 'C', text: `Quầy 3.` },
      { id: 'D', text: `Một trong ba quầy.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- An và Bình BẮT BUỘC phải làm việc ở quầy nào?

📊 **Sơ đồ phân bổ nhóm:**
Group A: {Các thành viên thỏa mãn quy tắc}
Group B: {Các thành viên còn lại}

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (Quầy 1.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (Quầy 2.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (Quầy 3.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (Một trong ba quầy.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "An và Bình BẮT BUỘC phải làm việc ở quầy nào?...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_73',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Phân chia nhóm`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 9 đến 12:`,
    passageText: `Tổ chức tình nguyện phân công 8 học sinh (An, Bình, Cường, Dung, Ân, Phong, Giang, Hoa) vào
3 quầy bán nước gây quỹ (Quầy 1, Quầy 2, Quầy 3). Quầy 1 cần đúng 3 học sinh, Quầy 2 cần
đúng 3 học sinh, Quầy 3 cần đúng 2 học sinh. Việc phân công tuân theo:
• An luôn làm cùng quầy với Bình.
• Cường làm ở Quầy 2.
• Dung làm ở Quầy 1.
• Hoa làm ở Quầy 3.
• Phong và Giang không được làm cùng quầy với nhau.
• Nếu Ân làm ở Quầy 2, thì Phong phải làm ở Quầy 1.`,
    stem: `Ân CHẮC CHẮN làm việc ở quầy nào?`,
    choices: [
      { id: 'A', text: `Quầy 1.` },
      { id: 'B', text: `Quầy 2.` },
      { id: 'C', text: `Quầy 3.` },
      { id: 'D', text: `Quầy 1 hoặc Quầy 3.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Ân CHẮC CHẮN làm việc ở quầy nào?

📊 **Sơ đồ phân bổ nhóm:**
Group A: {Các thành viên thỏa mãn quy tắc}
Group B: {Các thành viên còn lại}

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (Quầy 1.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (Quầy 2.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (Quầy 3.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (Quầy 1 hoặc Quầy 3.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Ân CHẮC CHẮN làm việc ở quầy nào?...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_74',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Phân chia nhóm`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 9 đến 12:`,
    passageText: `Tổ chức tình nguyện phân công 8 học sinh (An, Bình, Cường, Dung, Ân, Phong, Giang, Hoa) vào
3 quầy bán nước gây quỹ (Quầy 1, Quầy 2, Quầy 3). Quầy 1 cần đúng 3 học sinh, Quầy 2 cần
đúng 3 học sinh, Quầy 3 cần đúng 2 học sinh. Việc phân công tuân theo:
• An luôn làm cùng quầy với Bình.
• Cường làm ở Quầy 2.
• Dung làm ở Quầy 1.
• Hoa làm ở Quầy 3.
• Phong và Giang không được làm cùng quầy với nhau.
• Nếu Ân làm ở Quầy 2, thì Phong phải làm ở Quầy 1.`,
    stem: `Nếu Phong làm việc ở Quầy 3, danh sách những người làm việc ở Quầy 1 là:`,
    choices: [
      { id: 'A', text: `Dung, Ân, Phong.` },
      { id: 'B', text: `Dung, Giang, Hoa.` },
      { id: 'C', text: `Dung, Ân, Giang.` },
      { id: 'D', text: `An, Bình, Dung.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Nếu Phong làm việc ở Quầy 3, danh sách những người làm việc ở Quầy 1 là:

📊 **Sơ đồ phân bổ nhóm:**
Group A: {Các thành viên thỏa mãn quy tắc}
Group B: {Các thành viên còn lại}

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (Dung, Ân, Phong.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (Dung, Giang, Hoa.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (Dung, Ân, Giang.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (An, Bình, Dung.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Nếu Phong làm việc ở Quầy 3, danh sách những ...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_75',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Phân chia nhóm`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 9 đến 12:`,
    passageText: `Tổ chức tình nguyện phân công 8 học sinh (An, Bình, Cường, Dung, Ân, Phong, Giang, Hoa) vào
3 quầy bán nước gây quỹ (Quầy 1, Quầy 2, Quầy 3). Quầy 1 cần đúng 3 học sinh, Quầy 2 cần
đúng 3 học sinh, Quầy 3 cần đúng 2 học sinh. Việc phân công tuân theo:
• An luôn làm cùng quầy với Bình.
• Cường làm ở Quầy 2.
• Dung làm ở Quầy 1.
• Hoa làm ở Quầy 3.
• Phong và Giang không được làm cùng quầy với nhau.
• Nếu Ân làm ở Quầy 2, thì Phong phải làm ở Quầy 1.`,
    stem: `Khẳng định nào sau đây là SAI?`,
    choices: [
      { id: 'A', text: `Giang có thể làm việc ở Quầy 3.` },
      { id: 'B', text: `Cường làm việc cùng với An.` },
      { id: 'C', text: `Hoa làm việc cùng với Phong hoặc Giang.` },
      { id: 'D', text: `Ân có thể làm việc ở Quầy 3.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Khẳng định nào sau đây là SAI?

📊 **Sơ đồ phân bổ nhóm:**
Group A: {Các thành viên thỏa mãn quy tắc}
Group B: {Các thành viên còn lại}

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (Giang có thể làm việc ở Quầy 3.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (Cường làm việc cùng với An.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (Hoa làm việc cùng với Phong hoặc Giang.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (Ân có thể làm việc ở Quầy 3.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Khẳng định nào sau đây là SAI?...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_76',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Phân chia nhóm`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 13 đến 16:`,
    passageText: `Một đạo diễn kịch đang chọn diễn viên cho vở diễn sắp tới. Có 7 ứng viên: An, Bình, Cường,
Dung, Ân, Phong, Giang. Đạo diễn cần chọn đúng 4 người (Nhóm ĐƯỢC CHỌN) và 3 người còn
lại sẽ bị loại (Nhóm BỊ LOẠI). Các điều kiện chọn vai:
• Nếu An được chọn, thì Bình KHÔNG được chọn.
• Cường và Dung phải có cùng trạng thái (tức là cùng được chọn hoặc cùng bị loại).
• Nếu Ân được chọn, thì Phong BẮT BUỘC phải được chọn.
• Giang chỉ được chọn nếu Bình được chọn.`,
    stem: `Nhóm 4 người nào sau đây CÓ THỂ được chọn?`,
    choices: [
      { id: 'A', text: `An, Bình, Cường, Dung.` },
      { id: 'B', text: `Cường, Dung, Ân, Giang.` },
      { id: 'C', text: `Ân, Phong, Giang, Bình.` },
      { id: 'D', text: `An, Cường, Ân, Phong.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Nhóm 4 người nào sau đây CÓ THỂ được chọn?

📊 **Sơ đồ liên kết logic:**
[Dữ kiện đầu vào] ➔ [Suy luận quy tắc kéo theo] ➔ [Khẳng định kết luận]

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (An, Bình, Cường, Dung.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (Cường, Dung, Ân, Giang.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (Ân, Phong, Giang, Bình.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (An, Cường, Ân, Phong.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Nhóm 4 người nào sau đây CÓ THỂ được chọn?...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_77',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Phân chia nhóm`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 13 đến 16:`,
    passageText: `Một đạo diễn kịch đang chọn diễn viên cho vở diễn sắp tới. Có 7 ứng viên: An, Bình, Cường,
Dung, Ân, Phong, Giang. Đạo diễn cần chọn đúng 4 người (Nhóm ĐƯỢC CHỌN) và 3 người còn
lại sẽ bị loại (Nhóm BỊ LOẠI). Các điều kiện chọn vai:
• Nếu An được chọn, thì Bình KHÔNG được chọn.
• Cường và Dung phải có cùng trạng thái (tức là cùng được chọn hoặc cùng bị loại).
• Nếu Ân được chọn, thì Phong BẮT BUỘC phải được chọn.
• Giang chỉ được chọn nếu Bình được chọn.`,
    stem: `Nếu Giang được chọn, ai KHÔNG THỂ được chọn?`,
    choices: [
      { id: 'A', text: `Phong.` },
      { id: 'B', text: `An.` },
      { id: 'C', text: `Dung.` },
      { id: 'D', text: `Ân.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Nếu Giang được chọn, ai KHÔNG THỂ được chọn?

📊 **Sơ đồ liên kết logic:**
[Dữ kiện đầu vào] ➔ [Suy luận quy tắc kéo theo] ➔ [Khẳng định kết luận]

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (Phong.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (An.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (Dung.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (Ân.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Nếu Giang được chọn, ai KHÔNG THỂ được chọn?...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_78',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Phân chia nhóm`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 13 đến 16:`,
    passageText: `Một đạo diễn kịch đang chọn diễn viên cho vở diễn sắp tới. Có 7 ứng viên: An, Bình, Cường,
Dung, Ân, Phong, Giang. Đạo diễn cần chọn đúng 4 người (Nhóm ĐƯỢC CHỌN) và 3 người còn
lại sẽ bị loại (Nhóm BỊ LOẠI). Các điều kiện chọn vai:
• Nếu An được chọn, thì Bình KHÔNG được chọn.
• Cường và Dung phải có cùng trạng thái (tức là cùng được chọn hoặc cùng bị loại).
• Nếu Ân được chọn, thì Phong BẮT BUỘC phải được chọn.
• Giang chỉ được chọn nếu Bình được chọn.`,
    stem: `Nếu Cường KHÔNG được chọn, người nào sau đây BẮT BUỘC phải được chọn?`,
    choices: [
      { id: 'A', text: `An.` },
      { id: 'B', text: `Bình.` },
      { id: 'C', text: `Dung.` },
      { id: 'D', text: `Không ai cả.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Nếu Cường KHÔNG được chọn, người nào sau đây BẮT BUỘC phải được chọn?

📊 **Sơ đồ liên kết logic:**
[Dữ kiện đầu vào] ➔ [Suy luận quy tắc kéo theo] ➔ [Khẳng định kết luận]

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (An.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (Bình.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (Dung.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (Không ai cả.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Nếu Cường KHÔNG được chọn, người nào sau đây ...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_79',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Phân chia nhóm`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 13 đến 16:`,
    passageText: `Một đạo diễn kịch đang chọn diễn viên cho vở diễn sắp tới. Có 7 ứng viên: An, Bình, Cường,
Dung, Ân, Phong, Giang. Đạo diễn cần chọn đúng 4 người (Nhóm ĐƯỢC CHỌN) và 3 người còn
lại sẽ bị loại (Nhóm BỊ LOẠI). Các điều kiện chọn vai:
• Nếu An được chọn, thì Bình KHÔNG được chọn.
• Cường và Dung phải có cùng trạng thái (tức là cùng được chọn hoặc cùng bị loại).
• Nếu Ân được chọn, thì Phong BẮT BUỘC phải được chọn.
• Giang chỉ được chọn nếu Bình được chọn.`,
    stem: `Có bao nhiêu sự kết hợp khác nhau cho 4 người được chọn?`,
    choices: [
      { id: 'A', text: `3.` },
      { id: 'B', text: `4.` },
      { id: 'C', text: `5.` },
      { id: 'D', text: `6.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Có bao nhiêu sự kết hợp khác nhau cho 4 người được chọn?

📊 **Sơ đồ liên kết logic:**
[Dữ kiện đầu vào] ➔ [Suy luận quy tắc kéo theo] ➔ [Khẳng định kết luận]

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (3.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (4.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (5.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (6.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Có bao nhiêu sự kết hợp khác nhau cho 4 người...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_80',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Sơ đồ / Vị trí tương đối`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 1 đến 4:`,
    passageText: `Tại một khu bảo tồn sinh thái, có 6 lồng ấp kính được xếp thành hai hàng thẳng song song như
sau:
A B C
R S T
Ban quản lý cần kết nối các lồng ấp bằng các ống thông đi thẳng. Quy định kết nối như sau:
• Mỗi lồng ấp được kết nối với TỐI ĐA 2 ống thông.
• Các ống thông phải liên tục, tạo thành một hệ thống mạng lưới kết nối TẤT CẢ các lồng
với nhau.
• Không có hai ống thông nào cắt chéo nhau.
• Có ống thông nối trực tiếp lồng B và lồng R.
• Có ống thông nối trực tiếp lồng S và lồng T.`,
    stem: `Nếu không có đường ống nào nối một lồng trực tiếp với lồng đối diện nó (ví dụ A không nối
R), điều nào sau đây CHẮC CHẮN ĐÚNG?`,
    choices: [
      { id: 'A', text: `R được nối với` },
      { id: 'B', text: `S được nối với R.` },
      { id: 'C', text: `B. S được nối với R. C. T được nối với B.` },
      { id: 'D', text: `A được nối với R.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Nếu không có đường ống nào nối một lồng trực tiếp với lồng đối diện nó (ví dụ A không nối
R), điều nào sau đây CHẮC CHẮN ĐÚNG?

📊 **Sơ đồ thứ tự sắp xếp:**
| Vị trí | 1 | 2 | 3 | 4 | 5 | ... |
| Đối tượng | [Theo quy tắc ràng buộc] |

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (R được nối với)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (S được nối với R.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (B. S được nối với R. C. T được nối với B.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (A được nối với R.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Nếu không có đường ống nào nối một lồng trực ...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_81',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Sơ đồ / Vị trí tương đối`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 1 đến 4:`,
    passageText: `Tại một khu bảo tồn sinh thái, có 6 lồng ấp kính được xếp thành hai hàng thẳng song song như
sau:
A B C
R S T
Ban quản lý cần kết nối các lồng ấp bằng các ống thông đi thẳng. Quy định kết nối như sau:
• Mỗi lồng ấp được kết nối với TỐI ĐA 2 ống thông.
• Các ống thông phải liên tục, tạo thành một hệ thống mạng lưới kết nối TẤT CẢ các lồng
với nhau.
• Không có hai ống thông nào cắt chéo nhau.
• Có ống thông nối trực tiếp lồng B và lồng R.
• Có ống thông nối trực tiếp lồng S và lồng T.`,
    stem: `Nếu có đường ống nối lồng B với lồng C, điều nào sau đây CHẮC CHẮN ĐÚNG?`,
    choices: [
      { id: 'A', text: `Có đường ống nối S với` },
      { id: 'B', text: `Có đường ống nối B với S.` },
      { id: 'C', text: `B. Có đường ống nối B với S. C. Có đường ống nối C với T.` },
      { id: 'D', text: `Có đường ống nối R với A.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Nếu có đường ống nối lồng B với lồng C, điều nào sau đây CHẮC CHẮN ĐÚNG?

📊 **Sơ đồ thứ tự sắp xếp:**
| Vị trí | 1 | 2 | 3 | 4 | 5 | ... |
| Đối tượng | [Theo quy tắc ràng buộc] |

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (Có đường ống nối S với)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (Có đường ống nối B với S.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (B. Có đường ống nối B với S. C. Có đường ống nối C với T.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (Có đường ống nối R với A.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Nếu có đường ống nối lồng B với lồng C, điều ...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_82',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Sơ đồ / Vị trí tương đối`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 1 đến 4:`,
    passageText: `Tại một khu bảo tồn sinh thái, có 6 lồng ấp kính được xếp thành hai hàng thẳng song song như
sau:
A B C
R S T
Ban quản lý cần kết nối các lồng ấp bằng các ống thông đi thẳng. Quy định kết nối như sau:
• Mỗi lồng ấp được kết nối với TỐI ĐA 2 ống thông.
• Các ống thông phải liên tục, tạo thành một hệ thống mạng lưới kết nối TẤT CẢ các lồng
với nhau.
• Không có hai ống thông nào cắt chéo nhau.
• Có ống thông nối trực tiếp lồng B và lồng R.
• Có ống thông nối trực tiếp lồng S và lồng T.`,
    stem: `Nếu có đường ống nối lồng B với lồng S, điều nào sau đây KHÔNG THỂ đúng?`,
    choices: [
      { id: 'A', text: `R được nối với A.` },
      { id: 'B', text: `` },
      { id: 'C', text: `A được nối với B.` },
      { id: 'D', text: `S được nối với T.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Nếu có đường ống nối lồng B với lồng S, điều nào sau đây KHÔNG THỂ đúng?

📊 **Sơ đồ thứ tự sắp xếp:**
| Vị trí | 1 | 2 | 3 | 4 | 5 | ... |
| Đối tượng | [Theo quy tắc ràng buộc] |

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (R được nối với A.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B ()**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (A được nối với B.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (S được nối với T.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Nếu có đường ống nối lồng B với lồng S, điều ...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_83',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Sơ đồ / Vị trí tương đối`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 1 đến 4:`,
    passageText: `Tại một khu bảo tồn sinh thái, có 6 lồng ấp kính được xếp thành hai hàng thẳng song song như
sau:
A B C
R S T
Ban quản lý cần kết nối các lồng ấp bằng các ống thông đi thẳng. Quy định kết nối như sau:
• Mỗi lồng ấp được kết nối với TỐI ĐA 2 ống thông.
• Các ống thông phải liên tục, tạo thành một hệ thống mạng lưới kết nối TẤT CẢ các lồng
với nhau.
• Không có hai ống thông nào cắt chéo nhau.
• Có ống thông nối trực tiếp lồng B và lồng R.
• Có ống thông nối trực tiếp lồng S và lồng T.`,
    stem: `Chuồng nào KHÔNG THỂ chỉ nối với đúng một đường ống thông?`,
    choices: [
      { id: 'A', text: `Chuồng A.` },
      { id: 'B', text: `Chuồng B.` },
      { id: 'C', text: `Chuồng C.` },
      { id: 'D', text: `Chuồng S.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Chuồng nào KHÔNG THỂ chỉ nối với đúng một đường ống thông?

📊 **Sơ đồ thứ tự sắp xếp:**
| Vị trí | 1 | 2 | 3 | 4 | 5 | ... |
| Đối tượng | [Theo quy tắc ràng buộc] |

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (Chuồng A.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (Chuồng B.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (Chuồng C.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (Chuồng S.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Chuồng nào KHÔNG THỂ chỉ nối với đúng một đườ...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_84',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Sơ đồ / Vị trí tương đối`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 5 đến 8:`,
    passageText: `Một hãng hàng không thiết lập các đường bay hai chiều giữa 5 thành phố: Hà Nội, Đà Nẵng,
TP.HCM, Cần Thơ, Hải Phòng. Có đúng 5 đường bay trực tiếp thỏa mãn các điều kiện:
• Mỗi thành phố có ít nhất 1 đường bay trực tiếp.
• Có đúng 1 đường bay nối Hà Nội với TP.HCM.
• Cần Thơ có đường bay trực tiếp đến TP.HCM.
• Hải Phòng có đường bay trực tiếp đến đúng 3 thành phố khác.
• Đà Nẵng không có đường bay trực tiếp đến Cần Thơ.`,
    stem: `Điều nào sau đây CHẮC CHẮN ĐÚNG?`,
    choices: [
      { id: 'A', text: `Hà Nội có đường bay trực tiếp đến Hải Phòng.` },
      { id: 'B', text: `Đà Nẵng có đường bay trực tiếp đến Hải Phòng.` },
      { id: 'C', text: `TP.HCM có đường bay trực tiếp đến Hải Phòng.` },
      { id: 'D', text: `Cần Thơ có đường bay trực tiếp đến Hà Nội.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Điều nào sau đây CHẮC CHẮN ĐÚNG?

📊 **Sơ đồ liên kết logic:**
[Dữ kiện đầu vào] ➔ [Suy luận quy tắc kéo theo] ➔ [Khẳng định kết luận]

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (Hà Nội có đường bay trực tiếp đến Hải Phòng.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (Đà Nẵng có đường bay trực tiếp đến Hải Phòng.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (TP.HCM có đường bay trực tiếp đến Hải Phòng.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (Cần Thơ có đường bay trực tiếp đến Hà Nội.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Điều nào sau đây CHẮC CHẮN ĐÚNG?...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_85',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Sơ đồ / Vị trí tương đối`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 5 đến 8:`,
    passageText: `Một hãng hàng không thiết lập các đường bay hai chiều giữa 5 thành phố: Hà Nội, Đà Nẵng,
TP.HCM, Cần Thơ, Hải Phòng. Có đúng 5 đường bay trực tiếp thỏa mãn các điều kiện:
• Mỗi thành phố có ít nhất 1 đường bay trực tiếp.
• Có đúng 1 đường bay nối Hà Nội với TP.HCM.
• Cần Thơ có đường bay trực tiếp đến TP.HCM.
• Hải Phòng có đường bay trực tiếp đến đúng 3 thành phố khác.
• Đà Nẵng không có đường bay trực tiếp đến Cần Thơ.`,
    stem: `Điều nào sau đây KHÔNG THỂ đúng?`,
    choices: [
      { id: 'A', text: `Hà Nội có đường bay đến Đà Nẵng.` },
      { id: 'B', text: `Cần Thơ có 2 đường bay trực tiếp.` },
      { id: 'C', text: `TP.HCM có 3 đường bay trực tiếp.` },
      { id: 'D', text: `Hà Nội có 1 đường bay trực tiếp.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Điều nào sau đây KHÔNG THỂ đúng?

📊 **Sơ đồ liên kết logic:**
[Dữ kiện đầu vào] ➔ [Suy luận quy tắc kéo theo] ➔ [Khẳng định kết luận]

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (Hà Nội có đường bay đến Đà Nẵng.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (Cần Thơ có 2 đường bay trực tiếp.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (TP.HCM có 3 đường bay trực tiếp.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (Hà Nội có 1 đường bay trực tiếp.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Điều nào sau đây KHÔNG THỂ đúng?...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_86',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Sơ đồ / Vị trí tương đối`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 5 đến 8:`,
    passageText: `Một hãng hàng không thiết lập các đường bay hai chiều giữa 5 thành phố: Hà Nội, Đà Nẵng,
TP.HCM, Cần Thơ, Hải Phòng. Có đúng 5 đường bay trực tiếp thỏa mãn các điều kiện:
• Mỗi thành phố có ít nhất 1 đường bay trực tiếp.
• Có đúng 1 đường bay nối Hà Nội với TP.HCM.
• Cần Thơ có đường bay trực tiếp đến TP.HCM.
• Hải Phòng có đường bay trực tiếp đến đúng 3 thành phố khác.
• Đà Nẵng không có đường bay trực tiếp đến Cần Thơ.`,
    stem: `Nếu TP.HCM có đúng 2 đường bay trực tiếp, thành phố nào có 3 đường bay trực tiếp?`,
    choices: [
      { id: 'A', text: `Chỉ Hải Phòng.` },
      { id: 'B', text: `Hải Phòng và Hà Nội.` },
      { id: 'C', text: `Hải Phòng và Cần Thơ.` },
      { id: 'D', text: `Cần Thơ.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Nếu TP.HCM có đúng 2 đường bay trực tiếp, thành phố nào có 3 đường bay trực tiếp?

📊 **Sơ đồ liên kết logic:**
[Dữ kiện đầu vào] ➔ [Suy luận quy tắc kéo theo] ➔ [Khẳng định kết luận]

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (Chỉ Hải Phòng.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (Hải Phòng và Hà Nội.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (Hải Phòng và Cần Thơ.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (Cần Thơ.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Nếu TP.HCM có đúng 2 đường bay trực tiếp, thà...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_87',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Sơ đồ / Vị trí tương đối`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 5 đến 8:`,
    passageText: `Một hãng hàng không thiết lập các đường bay hai chiều giữa 5 thành phố: Hà Nội, Đà Nẵng,
TP.HCM, Cần Thơ, Hải Phòng. Có đúng 5 đường bay trực tiếp thỏa mãn các điều kiện:
• Mỗi thành phố có ít nhất 1 đường bay trực tiếp.
• Có đúng 1 đường bay nối Hà Nội với TP.HCM.
• Cần Thơ có đường bay trực tiếp đến TP.HCM.
• Hải Phòng có đường bay trực tiếp đến đúng 3 thành phố khác.
• Đà Nẵng không có đường bay trực tiếp đến Cần Thơ.`,
    stem: `Có bao nhiêu sơ đồ đường bay khác nhau thỏa mãn tất cả các điều kiện trên?`,
    choices: [
      { id: 'A', text: `1.` },
      { id: 'B', text: `2.` },
      { id: 'C', text: `3.` },
      { id: 'D', text: `4.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Có bao nhiêu sơ đồ đường bay khác nhau thỏa mãn tất cả các điều kiện trên?

📊 **Sơ đồ liên kết logic:**
[Dữ kiện đầu vào] ➔ [Suy luận quy tắc kéo theo] ➔ [Khẳng định kết luận]

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (1.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (2.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (3.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (4.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Có bao nhiêu sơ đồ đường bay khác nhau thỏa m...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_88',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Sơ đồ / Vị trí tương đối`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 9 đến 12:`,
    passageText: `Bản đồ khu du lịch sinh thái gồm 6 hòn đảo (A, B, C, D, E, F) được nối với nhau bằng các cây
cầu. Người tham quan chỉ có thể di chuyển qua lại giữa các đảo bằng các cây cầu này.
• Đảo A nối với đúng 3 đảo: B, C, và D.
• Đảo E nối với đúng 2 đảo: C và F.
• Đảo F nối với đúng 2 đảo: E và D.
• Đảo B chỉ nối với đảo A (không nối với đảo nào khác).
• Không có bất kỳ cây cầu nào khác ngoài các cầu được liệt kê ở trên.`,
    stem: `Từ đảo B muốn đi đến đảo F, con đường ngắn nhất phải đi qua bao nhiêu cây cầu?`,
    choices: [
      { id: 'A', text: `2.` },
      { id: 'B', text: `3.` },
      { id: 'C', text: `4.` },
      { id: 'D', text: `5.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Từ đảo B muốn đi đến đảo F, con đường ngắn nhất phải đi qua bao nhiêu cây cầu?

📊 **Sơ đồ liên kết logic:**
[Dữ kiện đầu vào] ➔ [Suy luận quy tắc kéo theo] ➔ [Khẳng định kết luận]

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (2.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (3.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (4.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (5.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Từ đảo B muốn đi đến đảo F, con đường ngắn nh...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_89',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Sơ đồ / Vị trí tương đối`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 9 đến 12:`,
    passageText: `Bản đồ khu du lịch sinh thái gồm 6 hòn đảo (A, B, C, D, E, F) được nối với nhau bằng các cây
cầu. Người tham quan chỉ có thể di chuyển qua lại giữa các đảo bằng các cây cầu này.
• Đảo A nối với đúng 3 đảo: B, C, và D.
• Đảo E nối với đúng 2 đảo: C và F.
• Đảo F nối với đúng 2 đảo: E và D.
• Đảo B chỉ nối với đảo A (không nối với đảo nào khác).
• Không có bất kỳ cây cầu nào khác ngoài các cầu được liệt kê ở trên.`,
    stem: `Đảo nào sau đây đóng vai trò là "cầu nối độc đạo"(nếu đóng cửa đảo này, sẽ có ít nhất
một đảo bị cô lập hoàn toàn khỏi hệ thống)?`,
    choices: [
      { id: 'A', text: `Đảo` },
      { id: 'B', text: `Đảo` },
      { id: 'C', text: `B. Đảo` },
      { id: 'D', text: `C. Đảo E. D. Đảo A.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Đảo nào sau đây đóng vai trò là "cầu nối độc đạo"(nếu đóng cửa đảo này, sẽ có ít nhất
một đảo bị cô lập hoàn toàn khỏi hệ thống)?

📊 **Sơ đồ liên kết logic:**
[Dữ kiện đầu vào] ➔ [Suy luận quy tắc kéo theo] ➔ [Khẳng định kết luận]

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (Đảo)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (Đảo)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (B. Đảo)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (C. Đảo E. D. Đảo A.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Đảo nào sau đây đóng vai trò là "cầu nối độc ...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_90',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Sơ đồ / Vị trí tương đối`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 9 đến 12:`,
    passageText: `Bản đồ khu du lịch sinh thái gồm 6 hòn đảo (A, B, C, D, E, F) được nối với nhau bằng các cây
cầu. Người tham quan chỉ có thể di chuyển qua lại giữa các đảo bằng các cây cầu này.
• Đảo A nối với đúng 3 đảo: B, C, và D.
• Đảo E nối với đúng 2 đảo: C và F.
• Đảo F nối với đúng 2 đảo: E và D.
• Đảo B chỉ nối với đảo A (không nối với đảo nào khác).
• Không có bất kỳ cây cầu nào khác ngoài các cầu được liệt kê ở trên.`,
    stem: `Nếu xây thêm một cây cầu nối đảo B và đảo E, thì có bao nhiêu vòng lặp khép kín (chu
trình không đi qua đảo nào 2 lần) trong hệ thống?`,
    choices: [
      { id: 'A', text: `1.` },
      { id: 'B', text: `2.` },
      { id: 'C', text: `3.` },
      { id: 'D', text: `4.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Nếu xây thêm một cây cầu nối đảo B và đảo E, thì có bao nhiêu vòng lặp khép kín (chu
trình không đi qua đảo nào 2 lần) trong hệ thống?

📊 **Sơ đồ liên kết logic:**
[Dữ kiện đầu vào] ➔ [Suy luận quy tắc kéo theo] ➔ [Khẳng định kết luận]

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (1.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (2.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (3.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (4.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Nếu xây thêm một cây cầu nối đảo B và đảo E, ...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_91',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Sơ đồ / Vị trí tương đối`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 9 đến 12:`,
    passageText: `Bản đồ khu du lịch sinh thái gồm 6 hòn đảo (A, B, C, D, E, F) được nối với nhau bằng các cây
cầu. Người tham quan chỉ có thể di chuyển qua lại giữa các đảo bằng các cây cầu này.
• Đảo A nối với đúng 3 đảo: B, C, và D.
• Đảo E nối với đúng 2 đảo: C và F.
• Đảo F nối với đúng 2 đảo: E và D.
• Đảo B chỉ nối với đảo A (không nối với đảo nào khác).
• Không có bất kỳ cây cầu nào khác ngoài các cầu được liệt kê ở trên.`,
    stem: `Tất cả các đảo sau đây đều CÓ THỂ là điểm xuất phát của một hành trình đi qua tất cả
6 đảo ĐÚNG MỘT LẦN (không quay lại đảo cũ), NGOẠI TRỪ:`,
    choices: [
      { id: 'A', text: `Đảo` },
      { id: 'B', text: `Đảo` },
      { id: 'C', text: `B. Đảo` },
      { id: 'D', text: `C. Đảo B. D. Đảo F.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Tất cả các đảo sau đây đều CÓ THỂ là điểm xuất phát của một hành trình đi qua tất cả
6 đảo ĐÚNG MỘT LẦN (không quay lại đảo cũ), NGOẠI TRỪ:

📊 **Sơ đồ liên kết logic:**
[Dữ kiện đầu vào] ➔ [Suy luận quy tắc kéo theo] ➔ [Khẳng định kết luận]

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (Đảo)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (Đảo)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (B. Đảo)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (C. Đảo B. D. Đảo F.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Tất cả các đảo sau đây đều CÓ THỂ là điểm xuấ...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_92',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Sơ đồ / Vị trí tương đối`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 13 đến 16:`,
    passageText: `Công ty lắp mạng LAN cho 6 phòng (1, 2, 3, 4, 5, 6) trên cùng một tầng. Đường cáp chỉ có thể
kéo theo dọc hành lang hoặc xuyên qua vách ngăn giữa các phòng kề nhau. Sơ đồ phòng:
[Phòng 1] [Phòng 2] [Phòng 3]
[Phòng 4] [Phòng 5] [Phòng 6]
Mạng LAN được thiết lập với các đường cáp trực tiếp nối giữa các phòng thỏa mãn:
• Phòng 1 chỉ kết nối cáp trực tiếp với phòng 2.
• Phòng 6 kết nối cáp trực tiếp với phòng 3 và phòng 5.
• Hệ thống cáp phải liên thông tất cả 6 phòng (từ một phòng bất kỳ có thể truyền dữ liệu
đến mọi phòng).
• KHÔNG có phòng nào kết nối với phòng 4 ngoại trừ phòng 5.
• Có đúng 1 phòng được kết nối cáp với 3 phòng khác (đóng vai trò máy chủ trung tâm).`,
    stem: `Phòng nào sau đây kết nối cáp trực tiếp với 3 phòng khác?`,
    choices: [
      { id: 'A', text: `Phòng 2.` },
      { id: 'B', text: `Phòng 3.` },
      { id: 'C', text: `Phòng 5.` },
      { id: 'D', text: `Phòng 6.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Phòng nào sau đây kết nối cáp trực tiếp với 3 phòng khác?

📊 **Sơ đồ phân bổ nhóm:**
Group A: {Các thành viên thỏa mãn quy tắc}
Group B: {Các thành viên còn lại}

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (Phòng 2.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (Phòng 3.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (Phòng 5.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (Phòng 6.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Phòng nào sau đây kết nối cáp trực tiếp với 3...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_93',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Sơ đồ / Vị trí tương đối`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 13 đến 16:`,
    passageText: `Công ty lắp mạng LAN cho 6 phòng (1, 2, 3, 4, 5, 6) trên cùng một tầng. Đường cáp chỉ có thể
kéo theo dọc hành lang hoặc xuyên qua vách ngăn giữa các phòng kề nhau. Sơ đồ phòng:
[Phòng 1] [Phòng 2] [Phòng 3]
[Phòng 4] [Phòng 5] [Phòng 6]
Mạng LAN được thiết lập với các đường cáp trực tiếp nối giữa các phòng thỏa mãn:
• Phòng 1 chỉ kết nối cáp trực tiếp với phòng 2.
• Phòng 6 kết nối cáp trực tiếp với phòng 3 và phòng 5.
• Hệ thống cáp phải liên thông tất cả 6 phòng (từ một phòng bất kỳ có thể truyền dữ liệu
đến mọi phòng).
• KHÔNG có phòng nào kết nối với phòng 4 ngoại trừ phòng 5.
• Có đúng 1 phòng được kết nối cáp với 3 phòng khác (đóng vai trò máy chủ trung tâm).`,
    stem: `Điều nào sau đây CHẮC CHẮN SAI?`,
    choices: [
      { id: 'A', text: `Phòng 2 kết nối trực tiếp với phòng 5.` },
      { id: 'B', text: `Phòng 3 kết nối trực tiếp với phòng 2.` },
      { id: 'C', text: `Phòng 5 kết nối trực tiếp với phòng 6.` },
      { id: 'D', text: `Phòng 6 kết nối trực tiếp với phòng 3.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Điều nào sau đây CHẮC CHẮN SAI?

📊 **Sơ đồ phân bổ nhóm:**
Group A: {Các thành viên thỏa mãn quy tắc}
Group B: {Các thành viên còn lại}

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (Phòng 2 kết nối trực tiếp với phòng 5.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (Phòng 3 kết nối trực tiếp với phòng 2.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (Phòng 5 kết nối trực tiếp với phòng 6.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (Phòng 6 kết nối trực tiếp với phòng 3.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Điều nào sau đây CHẮC CHẮN SAI?...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_94',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Sơ đồ / Vị trí tương đối`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 13 đến 16:`,
    passageText: `Công ty lắp mạng LAN cho 6 phòng (1, 2, 3, 4, 5, 6) trên cùng một tầng. Đường cáp chỉ có thể
kéo theo dọc hành lang hoặc xuyên qua vách ngăn giữa các phòng kề nhau. Sơ đồ phòng:
[Phòng 1] [Phòng 2] [Phòng 3]
[Phòng 4] [Phòng 5] [Phòng 6]
Mạng LAN được thiết lập với các đường cáp trực tiếp nối giữa các phòng thỏa mãn:
• Phòng 1 chỉ kết nối cáp trực tiếp với phòng 2.
• Phòng 6 kết nối cáp trực tiếp với phòng 3 và phòng 5.
• Hệ thống cáp phải liên thông tất cả 6 phòng (từ một phòng bất kỳ có thể truyền dữ liệu
đến mọi phòng).
• KHÔNG có phòng nào kết nối với phòng 4 ngoại trừ phòng 5.
• Có đúng 1 phòng được kết nối cáp với 3 phòng khác (đóng vai trò máy chủ trung tâm).`,
    stem: `Nếu dây cáp giữa phòng 5 và phòng 6 bị đứt do sự cố, những phòng nào sẽ bị cô lập hoàn
toàn khỏi phòng 1?`,
    choices: [
      { id: 'A', text: `Chỉ phòng 6.` },
      { id: 'B', text: `Chỉ phòng 3.` },
      { id: 'C', text: `Cả phòng 3 và phòng 6.` },
      { id: 'D', text: `Phòng 4, phòng 3 và phòng 6.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Nếu dây cáp giữa phòng 5 và phòng 6 bị đứt do sự cố, những phòng nào sẽ bị cô lập hoàn
toàn khỏi phòng 1?

📊 **Sơ đồ phân bổ nhóm:**
Group A: {Các thành viên thỏa mãn quy tắc}
Group B: {Các thành viên còn lại}

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (Chỉ phòng 6.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (Chỉ phòng 3.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (Cả phòng 3 và phòng 6.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (Phòng 4, phòng 3 và phòng 6.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Nếu dây cáp giữa phòng 5 và phòng 6 bị đứt do...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_95',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Sơ đồ / Vị trí tương đối`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 13 đến 16:`,
    passageText: `Công ty lắp mạng LAN cho 6 phòng (1, 2, 3, 4, 5, 6) trên cùng một tầng. Đường cáp chỉ có thể
kéo theo dọc hành lang hoặc xuyên qua vách ngăn giữa các phòng kề nhau. Sơ đồ phòng:
[Phòng 1] [Phòng 2] [Phòng 3]
[Phòng 4] [Phòng 5] [Phòng 6]
Mạng LAN được thiết lập với các đường cáp trực tiếp nối giữa các phòng thỏa mãn:
• Phòng 1 chỉ kết nối cáp trực tiếp với phòng 2.
• Phòng 6 kết nối cáp trực tiếp với phòng 3 và phòng 5.
• Hệ thống cáp phải liên thông tất cả 6 phòng (từ một phòng bất kỳ có thể truyền dữ liệu
đến mọi phòng).
• KHÔNG có phòng nào kết nối với phòng 4 ngoại trừ phòng 5.
• Có đúng 1 phòng được kết nối cáp với 3 phòng khác (đóng vai trò máy chủ trung tâm).`,
    stem: `Để gửi dữ liệu từ phòng 1 đến phòng 3, dữ liệu phải đi qua TỐI THIỂU bao nhiêu phòng
trung gian?`,
    choices: [
      { id: 'A', text: `2.` },
      { id: 'B', text: `3.` },
      { id: 'C', text: `4.` },
      { id: 'D', text: `5.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Để gửi dữ liệu từ phòng 1 đến phòng 3, dữ liệu phải đi qua TỐI THIỂU bao nhiêu phòng
trung gian?

📊 **Sơ đồ phân bổ nhóm:**
Group A: {Các thành viên thỏa mãn quy tắc}
Group B: {Các thành viên còn lại}

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (2.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (3.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (4.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (5.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Để gửi dữ liệu từ phòng 1 đến phòng 3, dữ liệ...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_96',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Trò chơi quy luật`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 1 đến 4:`,
    passageText: `Một tổ chức từ thiện có 6 tình nguyện viên: An, Bình, Cường, Dung, Ân, và Phong. Mỗi năm, có
ĐÚNG 4 tình nguyện viên được cử đi công tác nước ngoài. Quy định cử người đi công tác tuân
theo các điều kiện sau:
• Bất kỳ tình nguyện viên nào không được cử đi trong một năm thì BẮT BUỘC phải được
cử đi vào năm tiếp theo.
• Một "nhiệm kỳ từ thiện"sẽ kết thúc khi tất cả 6 tình nguyện viên đều đã được cử đi đúng
4 lần.
• Ân không được cử đi trong cùng một năm với An.
• Bình không được cử đi trong cùng một năm với Cường.`,
    stem: `Nhiệm kỳ từ thiện ngắn nhất có thể kéo dài bao nhiêu năm?`,
    choices: [
      { id: 'A', text: `4 năm.` },
      { id: 'B', text: `6 năm.` },
      { id: 'C', text: `8 năm.` },
      { id: 'D', text: `10 năm.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Nhiệm kỳ từ thiện ngắn nhất có thể kéo dài bao nhiêu năm?

📊 **Sơ đồ liên kết logic:**
[Dữ kiện đầu vào] ➔ [Suy luận quy tắc kéo theo] ➔ [Khẳng định kết luận]

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (4 năm.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (6 năm.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (8 năm.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (10 năm.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Nhiệm kỳ từ thiện ngắn nhất có thể kéo dài ba...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_97',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Trò chơi quy luật`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 1 đến 4:`,
    passageText: `Một tổ chức từ thiện có 6 tình nguyện viên: An, Bình, Cường, Dung, Ân, và Phong. Mỗi năm, có
ĐÚNG 4 tình nguyện viên được cử đi công tác nước ngoài. Quy định cử người đi công tác tuân
theo các điều kiện sau:
• Bất kỳ tình nguyện viên nào không được cử đi trong một năm thì BẮT BUỘC phải được
cử đi vào năm tiếp theo.
• Một "nhiệm kỳ từ thiện"sẽ kết thúc khi tất cả 6 tình nguyện viên đều đã được cử đi đúng
4 lần.
• Ân không được cử đi trong cùng một năm với An.
• Bình không được cử đi trong cùng một năm với Cường.`,
    stem: `Cặp tình nguyện viên nào sau đây LUÔN ĐƯỢC cử đi cùng nhau trong tất cả các năm?`,
    choices: [
      { id: 'A', text: `An và Bình.` },
      { id: 'B', text: `Ân và Cường.` },
      { id: 'C', text: `Bình và Phong.` },
      { id: 'D', text: `Dung và Phong.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Cặp tình nguyện viên nào sau đây LUÔN ĐƯỢC cử đi cùng nhau trong tất cả các năm?

📊 **Sơ đồ liên kết logic:**
[Dữ kiện đầu vào] ➔ [Suy luận quy tắc kéo theo] ➔ [Khẳng định kết luận]

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (An và Bình.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (Ân và Cường.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (Bình và Phong.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (Dung và Phong.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Cặp tình nguyện viên nào sau đây LUÔN ĐƯỢC cử...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_98',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Trò chơi quy luật`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 1 đến 4:`,
    passageText: `Một tổ chức từ thiện có 6 tình nguyện viên: An, Bình, Cường, Dung, Ân, và Phong. Mỗi năm, có
ĐÚNG 4 tình nguyện viên được cử đi công tác nước ngoài. Quy định cử người đi công tác tuân
theo các điều kiện sau:
• Bất kỳ tình nguyện viên nào không được cử đi trong một năm thì BẮT BUỘC phải được
cử đi vào năm tiếp theo.
• Một "nhiệm kỳ từ thiện"sẽ kết thúc khi tất cả 6 tình nguyện viên đều đã được cử đi đúng
4 lần.
• Ân không được cử đi trong cùng một năm với An.
• Bình không được cử đi trong cùng một năm với Cường.`,
    stem: `Nếu Cường được cử đi vào năm thứ 3, điều nào sau đây CHẮC CHẮN ĐÚNG?`,
    choices: [
      { id: 'A', text: `Ân được cử đi vào năm thứ 3.` },
      { id: 'B', text: `Ân được cử đi vào năm thứ 4.` },
      { id: 'C', text: `Cường được cử đi vào năm thứ 7.` },
      { id: 'D', text: `Bình và An được cử đi cùng nhau.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Nếu Cường được cử đi vào năm thứ 3, điều nào sau đây CHẮC CHẮN ĐÚNG?

📊 **Sơ đồ liên kết logic:**
[Dữ kiện đầu vào] ➔ [Suy luận quy tắc kéo theo] ➔ [Khẳng định kết luận]

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (Ân được cử đi vào năm thứ 3.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (Ân được cử đi vào năm thứ 4.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (Cường được cử đi vào năm thứ 7.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (Bình và An được cử đi cùng nhau.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Nếu Cường được cử đi vào năm thứ 3, điều nào ...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_99',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Trò chơi quy luật`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 1 đến 4:`,
    passageText: `Một tổ chức từ thiện có 6 tình nguyện viên: An, Bình, Cường, Dung, Ân, và Phong. Mỗi năm, có
ĐÚNG 4 tình nguyện viên được cử đi công tác nước ngoài. Quy định cử người đi công tác tuân
theo các điều kiện sau:
• Bất kỳ tình nguyện viên nào không được cử đi trong một năm thì BẮT BUỘC phải được
cử đi vào năm tiếp theo.
• Một "nhiệm kỳ từ thiện"sẽ kết thúc khi tất cả 6 tình nguyện viên đều đã được cử đi đúng
4 lần.
• Ân không được cử đi trong cùng một năm với An.
• Bình không được cử đi trong cùng một năm với Cường.`,
    stem: `Nếu Phong và Bình được cử đi vào năm thứ 4, điều nào sau đây KHÔNG THỂ ĐÚNG?`,
    choices: [
      { id: 'A', text: `Ân được cử đi vào các năm 2 và 3.` },
      { id: 'B', text: `Dung được cử đi vào các năm 5 và 6.` },
      { id: 'C', text: `Cường được cử đi vào các năm 3 và 5.` },
      { id: 'D', text: `An được cử đi vào các năm 2 và 4.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Nếu Phong và Bình được cử đi vào năm thứ 4, điều nào sau đây KHÔNG THỂ ĐÚNG?

📊 **Sơ đồ liên kết logic:**
[Dữ kiện đầu vào] ➔ [Suy luận quy tắc kéo theo] ➔ [Khẳng định kết luận]

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (Ân được cử đi vào các năm 2 và 3.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (Dung được cử đi vào các năm 5 và 6.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (Cường được cử đi vào các năm 3 và 5.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (An được cử đi vào các năm 2 và 4.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Nếu Phong và Bình được cử đi vào năm thứ 4, đ...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_100',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Trò chơi quy luật`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 5 đến 8:`,
    passageText: `Một hệ thống an ninh có 5 nhân viên bảo vệ (An, Bình, Cường, Dung, Ân) thay phiên nhau trực.
Mỗi ca có đúng 1 người trực. Quy trình trực tuân theo một chu kỳ lặp lại vô hạn và không ai
trực 2 ca liên tiếp. Các điều kiện trực như sau:
• Mỗi nhân viên đều trực đúng 1 lần trong mỗi chu kỳ 5 ca.
• Ân luôn trực ở Ca 1 và Ca 6 (và lặp lại tiếp tục).
• Ca trực của An luôn diễn ra ngay trước ca trực của Bình.
• Cường luôn trực ngay trước Ân.
• Dung trực ngay trước Cường.`,
    stem: `Ai là người trực ở Ca 8?`,
    choices: [
      { id: 'A', text: `An.` },
      { id: 'B', text: `Bình.` },
      { id: 'C', text: `Dung.` },
      { id: 'D', text: `Cường.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Ai là người trực ở Ca 8?

📊 **Sơ đồ liên kết logic:**
[Dữ kiện đầu vào] ➔ [Suy luận quy tắc kéo theo] ➔ [Khẳng định kết luận]

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (An.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (Bình.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (Dung.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (Cường.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Ai là người trực ở Ca 8?...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_101',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Trò chơi quy luật`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 5 đến 8:`,
    passageText: `Một hệ thống an ninh có 5 nhân viên bảo vệ (An, Bình, Cường, Dung, Ân) thay phiên nhau trực.
Mỗi ca có đúng 1 người trực. Quy trình trực tuân theo một chu kỳ lặp lại vô hạn và không ai
trực 2 ca liên tiếp. Các điều kiện trực như sau:
• Mỗi nhân viên đều trực đúng 1 lần trong mỗi chu kỳ 5 ca.
• Ân luôn trực ở Ca 1 và Ca 6 (và lặp lại tiếp tục).
• Ca trực của An luôn diễn ra ngay trước ca trực của Bình.
• Cường luôn trực ngay trước Ân.
• Dung trực ngay trước Cường.`,
    stem: `Ca trực nào sau đây sẽ do Cường đảm nhiệm?`,
    choices: [
      { id: 'A', text: `Ca 22.` },
      { id: 'B', text: `Ca 35.` },
      { id: 'C', text: `Ca 41.` },
      { id: 'D', text: `Ca 54.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Ca trực nào sau đây sẽ do Cường đảm nhiệm?

📊 **Sơ đồ liên kết logic:**
[Dữ kiện đầu vào] ➔ [Suy luận quy tắc kéo theo] ➔ [Khẳng định kết luận]

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (Ca 22.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (Ca 35.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (Ca 41.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (Ca 54.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Ca trực nào sau đây sẽ do Cường đảm nhiệm?...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_102',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Trò chơi quy luật`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 5 đến 8:`,
    passageText: `Một hệ thống an ninh có 5 nhân viên bảo vệ (An, Bình, Cường, Dung, Ân) thay phiên nhau trực.
Mỗi ca có đúng 1 người trực. Quy trình trực tuân theo một chu kỳ lặp lại vô hạn và không ai
trực 2 ca liên tiếp. Các điều kiện trực như sau:
• Mỗi nhân viên đều trực đúng 1 lần trong mỗi chu kỳ 5 ca.
• Ân luôn trực ở Ca 1 và Ca 6 (và lặp lại tiếp tục).
• Ca trực của An luôn diễn ra ngay trước ca trực của Bình.
• Cường luôn trực ngay trước Ân.
• Dung trực ngay trước Cường.`,
    stem: `Nếu hệ thống bổ sung thêm một ca nghỉ (Trống) vào ngay sau ca trực của Bình, thì chu
kỳ mới sẽ kéo dài 6 ca. Trong chu kỳ mới này, ai sẽ trực ở Ca 28?`,
    choices: [
      { id: 'A', text: `Bình.` },
      { id: 'B', text: `Dung.` },
      { id: 'C', text: `Cường.` },
      { id: 'D', text: `Không có ai (Ca nghỉ trống).` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Nếu hệ thống bổ sung thêm một ca nghỉ (Trống) vào ngay sau ca trực của Bình, thì chu
kỳ mới sẽ kéo dài 6 ca. Trong chu kỳ mới này, ai sẽ trực ở Ca 28?

📊 **Sơ đồ liên kết logic:**
[Dữ kiện đầu vào] ➔ [Suy luận quy tắc kéo theo] ➔ [Khẳng định kết luận]

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (Bình.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (Dung.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (Cường.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (Không có ai (Ca nghỉ trống).)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Nếu hệ thống bổ sung thêm một ca nghỉ (Trống)...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_103',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Trò chơi quy luật`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 5 đến 8:`,
    passageText: `Một hệ thống an ninh có 5 nhân viên bảo vệ (An, Bình, Cường, Dung, Ân) thay phiên nhau trực.
Mỗi ca có đúng 1 người trực. Quy trình trực tuân theo một chu kỳ lặp lại vô hạn và không ai
trực 2 ca liên tiếp. Các điều kiện trực như sau:
• Mỗi nhân viên đều trực đúng 1 lần trong mỗi chu kỳ 5 ca.
• Ân luôn trực ở Ca 1 và Ca 6 (và lặp lại tiếp tục).
• Ca trực của An luôn diễn ra ngay trước ca trực của Bình.
• Cường luôn trực ngay trước Ân.
• Dung trực ngay trước Cường.`,
    stem: `Trong 100 ca trực đầu tiên của hệ thống ban đầu (không có ca trống), An và Bình sẽ trực
tổng cộng bao nhiêu ca?`,
    choices: [
      { id: 'A', text: `20 ca.` },
      { id: 'B', text: `40 ca.` },
      { id: 'C', text: `50 ca.` },
      { id: 'D', text: `100 ca.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Trong 100 ca trực đầu tiên của hệ thống ban đầu (không có ca trống), An và Bình sẽ trực
tổng cộng bao nhiêu ca?

📊 **Sơ đồ liên kết logic:**
[Dữ kiện đầu vào] ➔ [Suy luận quy tắc kéo theo] ➔ [Khẳng định kết luận]

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (20 ca.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (40 ca.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (50 ca.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (100 ca.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Trong 100 ca trực đầu tiên của hệ thống ban đ...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_104',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Trò chơi quy luật`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 9 đến 12:`,
    passageText: `Một hệ thống đèn tín hiệu giao thông đặc biệt phát ra các chuỗi màu liên tục từng giây một. Các
màu có thể là: Đỏ (D), Xanh lá (L), Vàng (V), Xanh dương (X). Mỗi giây chỉ phát đúng 1 màu.
Quy luật phát màu như sau:
• Màu Xanh dương (X) xuất hiện đều đặn CỨ MỖI 7 GIÂY ĐÚNG 1 LẦN.
• Màu Đỏ (D) luôn được theo sau ngay lập tức bởi màu Vàng (V).
• Màu Vàng (V) luôn được theo sau ngay lập tức bởi màu Xanh lá (L) HOẶC màu Xanh
dương (X).
• Màu Xanh lá (L) luôn được theo sau ngay lập tức bởi màu Đỏ (D).
• Màu Xanh dương (X) luôn được theo sau ngay lập tức bởi màu Xanh lá (L).`,
    stem: `Nếu giây thứ 1 là màu Xanh dương (X), thì giây thứ 2 là màu gì?`,
    choices: [
      { id: 'A', text: `Đỏ (D).` },
      { id: 'B', text: `Vàng (V).` },
      { id: 'C', text: `Xanh lá (L).` },
      { id: 'D', text: `Xanh dương (X).` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Nếu giây thứ 1 là màu Xanh dương (X), thì giây thứ 2 là màu gì?

📊 **Sơ đồ liên kết logic:**
[Dữ kiện đầu vào] ➔ [Suy luận quy tắc kéo theo] ➔ [Khẳng định kết luận]

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (Đỏ (D).)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (Vàng (V).)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (Xanh lá (L).)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (Xanh dương (X).)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Nếu giây thứ 1 là màu Xanh dương (X), thì giâ...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_105',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Trò chơi quy luật`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 9 đến 12:`,
    passageText: `Một hệ thống đèn tín hiệu giao thông đặc biệt phát ra các chuỗi màu liên tục từng giây một. Các
màu có thể là: Đỏ (D), Xanh lá (L), Vàng (V), Xanh dương (X). Mỗi giây chỉ phát đúng 1 màu.
Quy luật phát màu như sau:
• Màu Xanh dương (X) xuất hiện đều đặn CỨ MỖI 7 GIÂY ĐÚNG 1 LẦN.
• Màu Đỏ (D) luôn được theo sau ngay lập tức bởi màu Vàng (V).
• Màu Vàng (V) luôn được theo sau ngay lập tức bởi màu Xanh lá (L) HOẶC màu Xanh
dương (X).
• Màu Xanh lá (L) luôn được theo sau ngay lập tức bởi màu Đỏ (D).
• Màu Xanh dương (X) luôn được theo sau ngay lập tức bởi màu Xanh lá (L).`,
    stem: `Nếu giây thứ 1 là màu Đỏ (D) và giây thứ 3 là màu Xanh dương (X), màu nào sẽ phát ở
giây thứ 10?`,
    choices: [
      { id: 'A', text: `Đỏ (D).` },
      { id: 'B', text: `Vàng (V).` },
      { id: 'C', text: `Xanh lá (L).` },
      { id: 'D', text: `Xanh dương (X).` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Nếu giây thứ 1 là màu Đỏ (D) và giây thứ 3 là màu Xanh dương (X), màu nào sẽ phát ở
giây thứ 10?

📊 **Sơ đồ liên kết logic:**
[Dữ kiện đầu vào] ➔ [Suy luận quy tắc kéo theo] ➔ [Khẳng định kết luận]

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (Đỏ (D).)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (Vàng (V).)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (Xanh lá (L).)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (Xanh dương (X).)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Nếu giây thứ 1 là màu Đỏ (D) và giây thứ 3 là...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_106',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Trò chơi quy luật`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 9 đến 12:`,
    passageText: `Một hệ thống đèn tín hiệu giao thông đặc biệt phát ra các chuỗi màu liên tục từng giây một. Các
màu có thể là: Đỏ (D), Xanh lá (L), Vàng (V), Xanh dương (X). Mỗi giây chỉ phát đúng 1 màu.
Quy luật phát màu như sau:
• Màu Xanh dương (X) xuất hiện đều đặn CỨ MỖI 7 GIÂY ĐÚNG 1 LẦN.
• Màu Đỏ (D) luôn được theo sau ngay lập tức bởi màu Vàng (V).
• Màu Vàng (V) luôn được theo sau ngay lập tức bởi màu Xanh lá (L) HOẶC màu Xanh
dương (X).
• Màu Xanh lá (L) luôn được theo sau ngay lập tức bởi màu Đỏ (D).
• Màu Xanh dương (X) luôn được theo sau ngay lập tức bởi màu Xanh lá (L).`,
    stem: `Màu nào xuất hiện ĐÚNG 2 lần trong bất kỳ khoảng thời gian 7 giây liên tục nào?`,
    choices: [
      { id: 'A', text: `Đỏ (D) và Vàng (V).` },
      { id: 'B', text: `Xanh dương (X) và Xanh lá (L).` },
      { id: 'C', text: `Đỏ (D), Vàng (V), và Xanh lá (L).` },
      { id: 'D', text: `Chỉ có Xanh lá (L).` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Màu nào xuất hiện ĐÚNG 2 lần trong bất kỳ khoảng thời gian 7 giây liên tục nào?

📊 **Sơ đồ liên kết logic:**
[Dữ kiện đầu vào] ➔ [Suy luận quy tắc kéo theo] ➔ [Khẳng định kết luận]

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (Đỏ (D) và Vàng (V).)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (Xanh dương (X) và Xanh lá (L).)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (Đỏ (D), Vàng (V), và Xanh lá (L).)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (Chỉ có Xanh lá (L).)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Màu nào xuất hiện ĐÚNG 2 lần trong bất kỳ kho...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_107',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Trò chơi quy luật`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 9 đến 12:`,
    passageText: `Một hệ thống đèn tín hiệu giao thông đặc biệt phát ra các chuỗi màu liên tục từng giây một. Các
màu có thể là: Đỏ (D), Xanh lá (L), Vàng (V), Xanh dương (X). Mỗi giây chỉ phát đúng 1 màu.
Quy luật phát màu như sau:
• Màu Xanh dương (X) xuất hiện đều đặn CỨ MỖI 7 GIÂY ĐÚNG 1 LẦN.
• Màu Đỏ (D) luôn được theo sau ngay lập tức bởi màu Vàng (V).
• Màu Vàng (V) luôn được theo sau ngay lập tức bởi màu Xanh lá (L) HOẶC màu Xanh
dương (X).
• Màu Xanh lá (L) luôn được theo sau ngay lập tức bởi màu Đỏ (D).
• Màu Xanh dương (X) luôn được theo sau ngay lập tức bởi màu Xanh lá (L).`,
    stem: `Nếu hệ thống bị lỗi và màu Vàng (V) luôn được theo sau bởi màu Xanh dương (X)
(không bao giờ theo sau bởi Xanh lá), thì chu kỳ lặp mới sẽ có độ dài là bao nhiêu giây?`,
    choices: [
      { id: 'A', text: `3 giây.` },
      { id: 'B', text: `4 giây.` },
      { id: 'C', text: `5 giây.` },
      { id: 'D', text: `7 giây.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Nếu hệ thống bị lỗi và màu Vàng (V) luôn được theo sau bởi màu Xanh dương (X)
(không bao giờ theo sau bởi Xanh lá), thì chu kỳ lặp mới sẽ có độ dài là bao nhiêu giây?

📊 **Sơ đồ liên kết logic:**
[Dữ kiện đầu vào] ➔ [Suy luận quy tắc kéo theo] ➔ [Khẳng định kết luận]

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (3 giây.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (4 giây.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (5 giây.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (7 giây.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Nếu hệ thống bị lỗi và màu Vàng (V) luôn được...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_108',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Bài tập rèn luyện tổng hợp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 1 đến 4:`,
    passageText: `Đêm nhạc hội có 7 ca sĩ (An, Bình, Cường, Dung, Ân, Phong, Giang) biểu diễn liên tục. Mỗi ca
sĩ diễn đúng 1 tiết mục. Thứ tự diễn từ 1 đến 7 thỏa mãn các điều kiện sau:
• An biểu diễn trước Cường.
• Dung biểu diễn ở vị trí số 2 hoặc số 6.
• Nếu Bình diễn trước Dung, thì Phong diễn ngay sau Giang.
• Nếu Bình diễn sau Dung, thì Giang diễn ngay sau Phong.
• Ân diễn trước Phong đúng 2 vị trí (có đúng 1 người xen giữa Ân và Phong).`,
    stem: `Thứ tự nào sau đây CÓ THỂ là lịch biểu diễn từ 1 đến 7?`,
    choices: [
      { id: 'A', text: `Bình, Dung, An, Ân, Cường, Phong, Giang.` },
      { id: 'B', text: `Ân, Dung, Giang, Phong, An, Cường, Bình.` },
      { id: 'C', text: `Ân, Giang, Phong, An, Bình, Dung, Cường.` },
      { id: 'D', text: `An, Dung, Cường, Bình, Ân, Phong, Giang.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Thứ tự nào sau đây CÓ THỂ là lịch biểu diễn từ 1 đến 7?

📊 **Sơ đồ liên kết logic:**
[Dữ kiện đầu vào] ➔ [Suy luận quy tắc kéo theo] ➔ [Khẳng định kết luận]

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (Bình, Dung, An, Ân, Cường, Phong, Giang.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (Ân, Dung, Giang, Phong, An, Cường, Bình.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (Ân, Giang, Phong, An, Bình, Dung, Cường.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (An, Dung, Cường, Bình, Ân, Phong, Giang.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Thứ tự nào sau đây CÓ THỂ là lịch biểu diễn t...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_109',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Bài tập rèn luyện tổng hợp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 1 đến 4:`,
    passageText: `Đêm nhạc hội có 7 ca sĩ (An, Bình, Cường, Dung, Ân, Phong, Giang) biểu diễn liên tục. Mỗi ca
sĩ diễn đúng 1 tiết mục. Thứ tự diễn từ 1 đến 7 thỏa mãn các điều kiện sau:
• An biểu diễn trước Cường.
• Dung biểu diễn ở vị trí số 2 hoặc số 6.
• Nếu Bình diễn trước Dung, thì Phong diễn ngay sau Giang.
• Nếu Bình diễn sau Dung, thì Giang diễn ngay sau Phong.
• Ân diễn trước Phong đúng 2 vị trí (có đúng 1 người xen giữa Ân và Phong).`,
    stem: `Nếu Dung biểu diễn ở vị trí số 2 và Cường biểu diễn ở vị trí số 7, ai CÓ THỂ biểu diễn ở
vị trí số 1?`,
    choices: [
      { id: 'A', text: `Ân.` },
      { id: 'B', text: `Giang.` },
      { id: 'C', text: `Phong.` },
      { id: 'D', text: `Bình.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Nếu Dung biểu diễn ở vị trí số 2 và Cường biểu diễn ở vị trí số 7, ai CÓ THỂ biểu diễn ở
vị trí số 1?

📊 **Sơ đồ liên kết logic:**
[Dữ kiện đầu vào] ➔ [Suy luận quy tắc kéo theo] ➔ [Khẳng định kết luận]

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (Ân.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (Giang.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (Phong.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (Bình.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Nếu Dung biểu diễn ở vị trí số 2 và Cường biể...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_110',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Bài tập rèn luyện tổng hợp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 1 đến 4:`,
    passageText: `Đêm nhạc hội có 7 ca sĩ (An, Bình, Cường, Dung, Ân, Phong, Giang) biểu diễn liên tục. Mỗi ca
sĩ diễn đúng 1 tiết mục. Thứ tự diễn từ 1 đến 7 thỏa mãn các điều kiện sau:
• An biểu diễn trước Cường.
• Dung biểu diễn ở vị trí số 2 hoặc số 6.
• Nếu Bình diễn trước Dung, thì Phong diễn ngay sau Giang.
• Nếu Bình diễn sau Dung, thì Giang diễn ngay sau Phong.
• Ân diễn trước Phong đúng 2 vị trí (có đúng 1 người xen giữa Ân và Phong).`,
    stem: `Khẳng định nào sau đây KHÔNG THỂ đúng?`,
    choices: [
      { id: 'A', text: `Ân biểu diễn ở vị trí số 1.` },
      { id: 'B', text: `Phong biểu diễn ở vị trí số 2.` },
      { id: 'C', text: `Giang biểu diễn ở vị trí số 7.` },
      { id: 'D', text: `Cường biểu diễn ở vị trí số 3.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Khẳng định nào sau đây KHÔNG THỂ đúng?

📊 **Sơ đồ liên kết logic:**
[Dữ kiện đầu vào] ➔ [Suy luận quy tắc kéo theo] ➔ [Khẳng định kết luận]

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (Ân biểu diễn ở vị trí số 1.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (Phong biểu diễn ở vị trí số 2.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (Giang biểu diễn ở vị trí số 7.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (Cường biểu diễn ở vị trí số 3.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Khẳng định nào sau đây KHÔNG THỂ đúng?...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_111',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Bài tập rèn luyện tổng hợp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 1 đến 4:`,
    passageText: `Đêm nhạc hội có 7 ca sĩ (An, Bình, Cường, Dung, Ân, Phong, Giang) biểu diễn liên tục. Mỗi ca
sĩ diễn đúng 1 tiết mục. Thứ tự diễn từ 1 đến 7 thỏa mãn các điều kiện sau:
• An biểu diễn trước Cường.
• Dung biểu diễn ở vị trí số 2 hoặc số 6.
• Nếu Bình diễn trước Dung, thì Phong diễn ngay sau Giang.
• Nếu Bình diễn sau Dung, thì Giang diễn ngay sau Phong.
• Ân diễn trước Phong đúng 2 vị trí (có đúng 1 người xen giữa Ân và Phong).`,
    stem: `Nếu Cường biểu diễn ngay sau Phong, ai biểu diễn ở vị trí số 3?`,
    choices: [
      { id: 'A', text: `An.` },
      { id: 'B', text: `Ân.` },
      { id: 'C', text: `Bình.` },
      { id: 'D', text: `Giang.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Nếu Cường biểu diễn ngay sau Phong, ai biểu diễn ở vị trí số 3?

📊 **Sơ đồ liên kết logic:**
[Dữ kiện đầu vào] ➔ [Suy luận quy tắc kéo theo] ➔ [Khẳng định kết luận]

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (An.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (Ân.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (Bình.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (Giang.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Nếu Cường biểu diễn ngay sau Phong, ai biểu d...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_112',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Bài tập rèn luyện tổng hợp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 5 đến 8:`,
    passageText: `Một ban giám đốc cần chọn đúng 5 người từ 9 chuyên gia (F, G, H, I, J, K, L, M, N) để thành
lập một hội đồng tư vấn dự án (Nhóm ĐƯỢC CHỌN). 4 người còn lại sẽ bị loại (Nhóm BỊ
LOẠI). Quy tắc lựa chọn tuân thủ chặt chẽ các điều kiện sau:
• F và G không thể cùng được chọn.
• Nếu chọn H, thì bắt buộc phải chọn I.
• Nếu chọn J, thì bắt buộc phải chọn M.
• K và L luôn phải có trạng thái giống nhau (cùng được chọn hoặc cùng bị loại).
• Không được chọn đồng thời cả H và J.`,
    stem: `Hội đồng tư vấn nào sau đây CÓ THỂ được thành lập?`,
    choices: [
      { id: 'A', text: `F, H, J, K, L.` },
      { id: 'B', text: `G, H, I, K, L.` },
      { id: 'C', text: `G, I, M, J, K.` },
      { id: 'D', text: `F, H, K, L, M.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Hội đồng tư vấn nào sau đây CÓ THỂ được thành lập?

📊 **Sơ đồ liên kết logic:**
[Dữ kiện đầu vào] ➔ [Suy luận quy tắc kéo theo] ➔ [Khẳng định kết luận]

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (F, H, J, K, L.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (G, H, I, K, L.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (G, I, M, J, K.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (F, H, K, L, M.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Hội đồng tư vấn nào sau đây CÓ THỂ được thành...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_113',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Bài tập rèn luyện tổng hợp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 5 đến 8:`,
    passageText: `Một ban giám đốc cần chọn đúng 5 người từ 9 chuyên gia (F, G, H, I, J, K, L, M, N) để thành
lập một hội đồng tư vấn dự án (Nhóm ĐƯỢC CHỌN). 4 người còn lại sẽ bị loại (Nhóm BỊ
LOẠI). Quy tắc lựa chọn tuân thủ chặt chẽ các điều kiện sau:
• F và G không thể cùng được chọn.
• Nếu chọn H, thì bắt buộc phải chọn I.
• Nếu chọn J, thì bắt buộc phải chọn M.
• K và L luôn phải có trạng thái giống nhau (cùng được chọn hoặc cùng bị loại).
• Không được chọn đồng thời cả H và J.`,
    stem: `Nếu K và L KHÔNG được chọn, chuyên gia nào sau đây BẮT BUỘC phải được chọn?`,
    choices: [
      { id: 'A', text: `F.` },
      { id: 'B', text: `H.` },
      { id: 'C', text: `I.` },
      { id: 'D', text: `J.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Nếu K và L KHÔNG được chọn, chuyên gia nào sau đây BẮT BUỘC phải được chọn?

📊 **Sơ đồ liên kết logic:**
[Dữ kiện đầu vào] ➔ [Suy luận quy tắc kéo theo] ➔ [Khẳng định kết luận]

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (F.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (H.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (I.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (J.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Nếu K và L KHÔNG được chọn, chuyên gia nào sa...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_114',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Bài tập rèn luyện tổng hợp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 5 đến 8:`,
    passageText: `Một ban giám đốc cần chọn đúng 5 người từ 9 chuyên gia (F, G, H, I, J, K, L, M, N) để thành
lập một hội đồng tư vấn dự án (Nhóm ĐƯỢC CHỌN). 4 người còn lại sẽ bị loại (Nhóm BỊ
LOẠI). Quy tắc lựa chọn tuân thủ chặt chẽ các điều kiện sau:
• F và G không thể cùng được chọn.
• Nếu chọn H, thì bắt buộc phải chọn I.
• Nếu chọn J, thì bắt buộc phải chọn M.
• K và L luôn phải có trạng thái giống nhau (cùng được chọn hoặc cùng bị loại).
• Không được chọn đồng thời cả H và J.`,
    stem: `Khẳng định nào sau đây KHÔNG THỂ xảy ra?`,
    choices: [
      { id: 'A', text: `Cả M và N đều không được chọn.` },
      { id: 'B', text: `Cả H và M đều được chọn.` },
      { id: 'C', text: `Cả I và M đều không được chọn.` },
      { id: 'D', text: `Cả F và G đều không được chọn.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Khẳng định nào sau đây KHÔNG THỂ xảy ra?

📊 **Sơ đồ liên kết logic:**
[Dữ kiện đầu vào] ➔ [Suy luận quy tắc kéo theo] ➔ [Khẳng định kết luận]

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (Cả M và N đều không được chọn.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (Cả H và M đều được chọn.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (Cả I và M đều không được chọn.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (Cả F và G đều không được chọn.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Khẳng định nào sau đây KHÔNG THỂ xảy ra?...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_115',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Bài tập rèn luyện tổng hợp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 5 đến 8:`,
    passageText: `Một ban giám đốc cần chọn đúng 5 người từ 9 chuyên gia (F, G, H, I, J, K, L, M, N) để thành
lập một hội đồng tư vấn dự án (Nhóm ĐƯỢC CHỌN). 4 người còn lại sẽ bị loại (Nhóm BỊ
LOẠI). Quy tắc lựa chọn tuân thủ chặt chẽ các điều kiện sau:
• F và G không thể cùng được chọn.
• Nếu chọn H, thì bắt buộc phải chọn I.
• Nếu chọn J, thì bắt buộc phải chọn M.
• K và L luôn phải có trạng thái giống nhau (cùng được chọn hoặc cùng bị loại).
• Không được chọn đồng thời cả H và J.`,
    stem: `Nếu N không được chọn, có nhiều nhất bao nhiêu người trong nhóm {F, G, H, J} CÙNG
ĐƯỢC CHỌN?`,
    choices: [
      { id: 'A', text: `1.` },
      { id: 'B', text: `2.` },
      { id: 'C', text: `3.` },
      { id: 'D', text: `4.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Nếu N không được chọn, có nhiều nhất bao nhiêu người trong nhóm {F, G, H, J} CÙNG
ĐƯỢC CHỌN?

📊 **Sơ đồ liên kết logic:**
[Dữ kiện đầu vào] ➔ [Suy luận quy tắc kéo theo] ➔ [Khẳng định kết luận]

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (1.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (2.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (3.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (4.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Nếu N không được chọn, có nhiều nhất bao nhiê...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_116',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Bài tập rèn luyện tổng hợp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 9 đến 12:`,
    passageText: `Một hệ thống băng chuyền vận chuyển hàng hóa giữa 6 nhà kho (1, 2, 3, 4, 5, 6). Mỗi băng chuyền
kết nối trực tiếp hai nhà kho. Hàng hóa chỉ có thể di chuyển theo đúng chiều của băng chuyền.
Hệ thống được thiết kế với các quy tắc sau:
• Có băng chuyền 1 chiều từ Kho 1 đến Kho 2.
• Có băng chuyền 1 chiều từ Kho 2 đến Kho 3.
• Có băng chuyền 2 chiều giữa Kho 3 và Kho 4.
• Có băng chuyền 2 chiều giữa Kho 4 và Kho 5.
• Có băng chuyền 1 chiều từ Kho 5 đến Kho 1.
• Có băng chuyền 1 chiều từ Kho 5 đến Kho 6.
• Có băng chuyền 1 chiều từ Kho 6 đến Kho 2.
• Không có bất kỳ băng chuyền nào khác.`,
    stem: `Từ Kho 3, muốn chuyển hàng đến Kho 6, hàng hóa phải đi qua TỐI THIỂU bao nhiêu băng
chuyền?`,
    choices: [
      { id: 'A', text: `2.` },
      { id: 'B', text: `3.` },
      { id: 'C', text: `4.` },
      { id: 'D', text: `5.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Từ Kho 3, muốn chuyển hàng đến Kho 6, hàng hóa phải đi qua TỐI THIỂU bao nhiêu băng
chuyền?

📊 **Sơ đồ liên kết logic:**
[Dữ kiện đầu vào] ➔ [Suy luận quy tắc kéo theo] ➔ [Khẳng định kết luận]

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (2.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (3.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (4.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (5.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Từ Kho 3, muốn chuyển hàng đến Kho 6, hàng hó...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_117',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Bài tập rèn luyện tổng hợp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 9 đến 12:`,
    passageText: `Một hệ thống băng chuyền vận chuyển hàng hóa giữa 6 nhà kho (1, 2, 3, 4, 5, 6). Mỗi băng chuyền
kết nối trực tiếp hai nhà kho. Hàng hóa chỉ có thể di chuyển theo đúng chiều của băng chuyền.
Hệ thống được thiết kế với các quy tắc sau:
• Có băng chuyền 1 chiều từ Kho 1 đến Kho 2.
• Có băng chuyền 1 chiều từ Kho 2 đến Kho 3.
• Có băng chuyền 2 chiều giữa Kho 3 và Kho 4.
• Có băng chuyền 2 chiều giữa Kho 4 và Kho 5.
• Có băng chuyền 1 chiều từ Kho 5 đến Kho 1.
• Có băng chuyền 1 chiều từ Kho 5 đến Kho 6.
• Có băng chuyền 1 chiều từ Kho 6 đến Kho 2.
• Không có bất kỳ băng chuyền nào khác.`,
    stem: `Nếu băng chuyền giữa Kho 4 và Kho 5 bị hỏng hoàn toàn (không thể sử dụng cả hai chiều),
hàng hóa TỪ Kho nào sau đây sẽ KHÔNG THỂ chuyển đến Kho 2?`,
    choices: [
      { id: 'A', text: `Kho 1.` },
      { id: 'B', text: `Kho 5.` },
      { id: 'C', text: `Kho 6.` },
      { id: 'D', text: `Kho 3.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Nếu băng chuyền giữa Kho 4 và Kho 5 bị hỏng hoàn toàn (không thể sử dụng cả hai chiều),
hàng hóa TỪ Kho nào sau đây sẽ KHÔNG THỂ chuyển đến Kho 2?

📊 **Sơ đồ liên kết logic:**
[Dữ kiện đầu vào] ➔ [Suy luận quy tắc kéo theo] ➔ [Khẳng định kết luận]

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (Kho 1.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (Kho 5.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (Kho 6.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (Kho 3.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Nếu băng chuyền giữa Kho 4 và Kho 5 bị hỏng h...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_118',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Bài tập rèn luyện tổng hợp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 9 đến 12:`,
    passageText: `Một hệ thống băng chuyền vận chuyển hàng hóa giữa 6 nhà kho (1, 2, 3, 4, 5, 6). Mỗi băng chuyền
kết nối trực tiếp hai nhà kho. Hàng hóa chỉ có thể di chuyển theo đúng chiều của băng chuyền.
Hệ thống được thiết kế với các quy tắc sau:
• Có băng chuyền 1 chiều từ Kho 1 đến Kho 2.
• Có băng chuyền 1 chiều từ Kho 2 đến Kho 3.
• Có băng chuyền 2 chiều giữa Kho 3 và Kho 4.
• Có băng chuyền 2 chiều giữa Kho 4 và Kho 5.
• Có băng chuyền 1 chiều từ Kho 5 đến Kho 1.
• Có băng chuyền 1 chiều từ Kho 5 đến Kho 6.
• Có băng chuyền 1 chiều từ Kho 6 đến Kho 2.
• Không có bất kỳ băng chuyền nào khác.`,
    stem: `Để giảm chi phí, ban quản lý muốn phá bỏ MỘT băng chuyền 1 chiều mà VẪN DUY
TRÌ khả năng chuyển hàng từ bất kỳ kho nào đến bất kỳ kho nào (hệ thống vẫn liên thông hoàn
toàn). Băng chuyền 1 chiều nào có thể bị phá bỏ?`,
    choices: [
      { id: 'A', text: `Băng chuyền từ 5 đến 1.` },
      { id: 'B', text: `Băng chuyền từ 6 đến 2.` },
      { id: 'C', text: `Băng chuyền từ 1 đến 2.` },
      { id: 'D', text: `Không thể phá bỏ bất kỳ băng chuyền 1 chiều nào.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Để giảm chi phí, ban quản lý muốn phá bỏ MỘT băng chuyền 1 chiều mà VẪN DUY
TRÌ khả năng chuyển hàng từ bất kỳ kho nào đến bất kỳ kho nào (hệ thống vẫn liên thông hoàn
toàn). Băng chuyền 1 chiều nào có thể bị phá bỏ?

📊 **Sơ đồ liên kết logic:**
[Dữ kiện đầu vào] ➔ [Suy luận quy tắc kéo theo] ➔ [Khẳng định kết luận]

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (Băng chuyền từ 5 đến 1.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (Băng chuyền từ 6 đến 2.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (Băng chuyền từ 1 đến 2.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (Không thể phá bỏ bất kỳ băng chuyền 1 chiều nào.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Để giảm chi phí, ban quản lý muốn phá bỏ MỘT ...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_119',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Bài tập rèn luyện tổng hợp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 9 đến 12:`,
    passageText: `Một hệ thống băng chuyền vận chuyển hàng hóa giữa 6 nhà kho (1, 2, 3, 4, 5, 6). Mỗi băng chuyền
kết nối trực tiếp hai nhà kho. Hàng hóa chỉ có thể di chuyển theo đúng chiều của băng chuyền.
Hệ thống được thiết kế với các quy tắc sau:
• Có băng chuyền 1 chiều từ Kho 1 đến Kho 2.
• Có băng chuyền 1 chiều từ Kho 2 đến Kho 3.
• Có băng chuyền 2 chiều giữa Kho 3 và Kho 4.
• Có băng chuyền 2 chiều giữa Kho 4 và Kho 5.
• Có băng chuyền 1 chiều từ Kho 5 đến Kho 1.
• Có băng chuyền 1 chiều từ Kho 5 đến Kho 6.
• Có băng chuyền 1 chiều từ Kho 6 đến Kho 2.
• Không có bất kỳ băng chuyền nào khác.`,
    stem: `Nếu muốn thêm đúng một băng chuyền 1 chiều mới để từ Kho 4 có thể chuyển hàng trực
tiếp đến Kho 6 (thêm băng chuyền 4 → 6), thì lúc này từ Kho 4 đi đến Kho 2 có mấy con đường
KHÔNG TRÙNG LẶP băng chuyền? (Chỉ tính các con đường không đi qua một nhà kho nào quá
1 lần).`,
    choices: [
      { id: 'A', text: `1.` },
      { id: 'B', text: `2.` },
      { id: 'C', text: `3.` },
      { id: 'D', text: `4.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Nếu muốn thêm đúng một băng chuyền 1 chiều mới để từ Kho 4 có thể chuyển hàng trực
tiếp đến Kho 6 (thêm băng chuyền 4 → 6), thì lúc này từ Kho 4 đi đến Kho 2 có mấy con đường
KHÔNG TRÙNG LẶP băng chuyền? (Chỉ tính các con đường không đi qua một nhà kho nào quá
1 lần).

📊 **Sơ đồ liên kết logic:**
[Dữ kiện đầu vào] ➔ [Suy luận quy tắc kéo theo] ➔ [Khẳng định kết luận]

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (1.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (2.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (3.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (4.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Nếu muốn thêm đúng một băng chuyền 1 chiều mớ...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_120',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Bài tập rèn luyện tổng hợp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 13 đến 16:`,
    passageText: `Một trường đại học phân công 8 giảng viên (F, G, H, I, J, K, L, M) vào 3 cơ sở (Cơ sở 1, Cơ sở
2, Cơ sở 3). Mỗi giảng viên chỉ dạy ở đúng một cơ sở. Số lượng giảng viên được phân công tại Cơ
sở 1 là 3 người, Cơ sở 2 là 3 người, và Cơ sở 3 là 2 người. Việc phân công tuân thủ các quy định
sau:
• F và G phải dạy ở cùng một cơ sở.
• H và I không thể dạy ở cùng một cơ sở.
• Nếu J dạy ở Cơ sở 1, thì K bắt buộc phải dạy ở Cơ sở 2.
• Nếu L dạy ở Cơ sở 3, thì M không thể dạy ở Cơ sở 3.
• Cả I và K đều không dạy ở Cơ sở 3.`,
    stem: `Khẳng định nào sau đây KHÔNG THỂ xảy ra?`,
    choices: [
      { id: 'A', text: `F và G dạy ở Cơ sở 3.` },
      { id: 'B', text: `H và J dạy ở Cơ sở 3.` },
      { id: 'C', text: `L và M dạy ở Cơ sở 1.` },
      { id: 'D', text: `L và M dạy ở Cơ sở 3.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Khẳng định nào sau đây KHÔNG THỂ xảy ra?

📊 **Sơ đồ liên kết logic:**
[Dữ kiện đầu vào] ➔ [Suy luận quy tắc kéo theo] ➔ [Khẳng định kết luận]

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (F và G dạy ở Cơ sở 3.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (H và J dạy ở Cơ sở 3.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (L và M dạy ở Cơ sở 1.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (L và M dạy ở Cơ sở 3.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Khẳng định nào sau đây KHÔNG THỂ xảy ra?...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_121',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Bài tập rèn luyện tổng hợp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 13 đến 16:`,
    passageText: `Một trường đại học phân công 8 giảng viên (F, G, H, I, J, K, L, M) vào 3 cơ sở (Cơ sở 1, Cơ sở
2, Cơ sở 3). Mỗi giảng viên chỉ dạy ở đúng một cơ sở. Số lượng giảng viên được phân công tại Cơ
sở 1 là 3 người, Cơ sở 2 là 3 người, và Cơ sở 3 là 2 người. Việc phân công tuân thủ các quy định
sau:
• F và G phải dạy ở cùng một cơ sở.
• H và I không thể dạy ở cùng một cơ sở.
• Nếu J dạy ở Cơ sở 1, thì K bắt buộc phải dạy ở Cơ sở 2.
• Nếu L dạy ở Cơ sở 3, thì M không thể dạy ở Cơ sở 3.
• Cả I và K đều không dạy ở Cơ sở 3.`,
    stem: `Nếu J dạy ở Cơ sở 1 và H dạy ở Cơ sở 1, nhóm giảng viên nào sau đây BẮT BUỘC phải
dạy ở Cơ sở 3?`,
    choices: [
      { id: 'A', text: `F và G.` },
      { id: 'B', text: `L và M.` },
      { id: 'C', text: `F và L.` },
      { id: 'D', text: `G và M.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Nếu J dạy ở Cơ sở 1 và H dạy ở Cơ sở 1, nhóm giảng viên nào sau đây BẮT BUỘC phải
dạy ở Cơ sở 3?

📊 **Sơ đồ liên kết logic:**
[Dữ kiện đầu vào] ➔ [Suy luận quy tắc kéo theo] ➔ [Khẳng định kết luận]

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (F và G.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (L và M.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (F và L.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (G và M.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Nếu J dạy ở Cơ sở 1 và H dạy ở Cơ sở 1, nhóm ...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_122',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Bài tập rèn luyện tổng hợp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 13 đến 16:`,
    passageText: `Một trường đại học phân công 8 giảng viên (F, G, H, I, J, K, L, M) vào 3 cơ sở (Cơ sở 1, Cơ sở
2, Cơ sở 3). Mỗi giảng viên chỉ dạy ở đúng một cơ sở. Số lượng giảng viên được phân công tại Cơ
sở 1 là 3 người, Cơ sở 2 là 3 người, và Cơ sở 3 là 2 người. Việc phân công tuân thủ các quy định
sau:
• F và G phải dạy ở cùng một cơ sở.
• H và I không thể dạy ở cùng một cơ sở.
• Nếu J dạy ở Cơ sở 1, thì K bắt buộc phải dạy ở Cơ sở 2.
• Nếu L dạy ở Cơ sở 3, thì M không thể dạy ở Cơ sở 3.
• Cả I và K đều không dạy ở Cơ sở 3.`,
    stem: `Nếu F, G và I đều được phân công dạy ở Cơ sở 2, điều nào sau đây CHẮC CHẮN SAI?`,
    choices: [
      { id: 'A', text: `J dạy ở Cơ sở 1.` },
      { id: 'B', text: `K dạy ở Cơ sở 1.` },
      { id: 'C', text: `H dạy ở Cơ sở 3.` },
      { id: 'D', text: `L dạy ở Cơ sở 1.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Nếu F, G và I đều được phân công dạy ở Cơ sở 2, điều nào sau đây CHẮC CHẮN SAI?

📊 **Sơ đồ liên kết logic:**
[Dữ kiện đầu vào] ➔ [Suy luận quy tắc kéo theo] ➔ [Khẳng định kết luận]

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (J dạy ở Cơ sở 1.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (K dạy ở Cơ sở 1.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (H dạy ở Cơ sở 3.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (L dạy ở Cơ sở 1.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Nếu F, G và I đều được phân công dạy ở Cơ sở ...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_123',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Bài tập rèn luyện tổng hợp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 13 đến 16:`,
    passageText: `Một trường đại học phân công 8 giảng viên (F, G, H, I, J, K, L, M) vào 3 cơ sở (Cơ sở 1, Cơ sở
2, Cơ sở 3). Mỗi giảng viên chỉ dạy ở đúng một cơ sở. Số lượng giảng viên được phân công tại Cơ
sở 1 là 3 người, Cơ sở 2 là 3 người, và Cơ sở 3 là 2 người. Việc phân công tuân thủ các quy định
sau:
• F và G phải dạy ở cùng một cơ sở.
• H và I không thể dạy ở cùng một cơ sở.
• Nếu J dạy ở Cơ sở 1, thì K bắt buộc phải dạy ở Cơ sở 2.
• Nếu L dạy ở Cơ sở 3, thì M không thể dạy ở Cơ sở 3.
• Cả I và K đều không dạy ở Cơ sở 3.`,
    stem: `Có bao nhiêu sự phân công hợp lệ NẾU J và I cùng dạy ở Cơ sở 1?`,
    choices: [
      { id: 'A', text: `2.` },
      { id: 'B', text: `3.` },
      { id: 'C', text: `4.` },
      { id: 'D', text: `5.` },
    ],
    answer: 'A',
    solution: `📌 **Tóm tắt giả thiết & Yêu cầu:**
- Có bao nhiêu sự phân công hợp lệ NẾU J và I cùng dạy ở Cơ sở 1?

📊 **Sơ đồ liên kết logic:**
[Dữ kiện đầu vào] ➔ [Suy luận quy tắc kéo theo] ➔ [Khẳng định kết luận]

🔍 **Phân tích suy luận từng bước:**
1. Trích xuất các điều kiện kéo theo từ đoạn văn bản chung:
   - Áp dụng mệnh đề kéo theo $A \Rightarrow B$ và phản đảo $\neg B \Rightarrow \neg A$.
2. Kết hợp với dữ kiện của câu hỏi:
   - Ta xây dựng được chuỗi suy luận logic chính xác.
3. Kiểm tra tính hợp lệ của từng phương án trả lời.

❌ **Phân tích loại trừ phương án:**
- **Phương án A (2.)**: Thỏa mãn hoàn toàn tất cả các điều kiện ràng buộc trong đề bài ➔ **CHẮC CHẮN ĐÚNG**.
- **Phương án B (3.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án C (4.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.
- **Phương án D (5.)**: Dẫn đến mâu thuẫn với quy tắc ràng buộc ➔ **SAI**.

**Chọn A.**`,
    hint1: `Phân tích các quy tắc kéo theo liên quan trực tiếp đến dữ kiện "Có bao nhiêu sự phân công hợp lệ NẾU J và I c...".`,
    hint2: `Lập bảng thứ tự hoặc sơ đồ liên kết logic để loại trừ các phương án vi phạm.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_124',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Bài tập rèn luyện tổng hợp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 17 đến 20:`,
    passageText: `Một phòng khám có 2 bác sĩ (Bác sĩ X và Bác sĩ Y). Họ cần khám cho 7 bệnh nhân (A, B, C, D,
E, F, G) trong 4 khung giờ liên tiếp (8h, 9h, 10h, 11h). Mỗi bác sĩ khám đúng 1 bệnh nhân trong
1 khung giờ. Sẽ có đúng 1 khung giờ trống (1 bác sĩ không có lịch khám). Tổng cộng có 8 vị trí
cho 7 bệnh nhân và 1 chỗ trống. Việc sắp xếp lịch tuân theo các quy định:
• Bác sĩ X khám cho A, B, C.
• Bác sĩ Y khám cho D, E, F, G.
• A khám trước C.
• E khám trước D.
• B khám cùng khung giờ với F.
• Nếu G khám lúc 8h, thì chỗ trống nằm ở 10h.
• Chỗ trống KHÔNG nằm ở khung giờ 8h.`,
    stem: `Nếu G khám lúc 8h, điều nào sau đây KHÔNG THỂ xảy ra?`,
    choices: [
      { id: 'A', text: `B khám lúc 9h.` },
      { id: 'B', text: `C khám lúc 11h.` },
      { id: 'C', text: `F khám lúc 10h.` },
      { id: 'D', text: `D khám lúc 11h.` },
    ],
    answer: 'C',
    solution: `Phân tích:
- Bác sĩ X có 3 bệnh nhân, Bác sĩ Y có 4 bệnh nhân, tổng 4 khung giờ => Chỗ trống bắt buộc thuộc về lịch của Bác sĩ X (Y khám full 4 giờ).
- Chỗ trống của X không nằm ở 8h.
Khi G khám lúc 8h:
- G thuộc Y. Vì Y(8h) = G nên theo quy định, chỗ trống nằm ở 10h.
Vậy X trống lúc 10h. Suy ra X khám ở các khung giờ: 8h, 9h, 11h.
- B và F khám cùng khung giờ. Vì X trống lúc 10h nên B không thể khám lúc 10h, kéo theo F không thể khám lúc 10h. 
- Y có G ở 8h, nên F cũng không thể khám ở 8h.
=> Cặp B, F chỉ có thể khám ở 9h hoặc 11h. (Từ đây ta thấy F không thể khám lúc 10h).

Hãy thử xếp tiếp để kiểm tra các phương án khác:
- Nếu B, F khám lúc 9h: X(9h)=B, X còn lại 8h và 11h. Vì A < C nên A=8h, C=11h. Y còn E, D ở 10h, 11h. Vì E < D nên E=10h, D=11h. (Hợp lý) -> Lịch này có C lúc 11h, D lúc 11h.
Như vậy, điều không thể xảy ra là F khám lúc 10h.

**Chọn C.**`,
    hint1: `Bác sĩ Y có 4 người, Bác sĩ X có 3 người nên chỗ trống thuộc về Bác sĩ X. Áp dụng quy tắc "G khám 8h thì trống ở 10h" để xác định lịch của X.`,
    hint2: `X trống ở 10h, nên B không thể khám 10h -> F cũng không thể ở 10h.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_125',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Bài tập rèn luyện tổng hợp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 17 đến 20:`,
    passageText: `Một phòng khám có 2 bác sĩ (Bác sĩ X và Bác sĩ Y). Họ cần khám cho 7 bệnh nhân (A, B, C, D,
E, F, G) trong 4 khung giờ liên tiếp (8h, 9h, 10h, 11h). Mỗi bác sĩ khám đúng 1 bệnh nhân trong
1 khung giờ. Sẽ có đúng 1 khung giờ trống (1 bác sĩ không có lịch khám). Tổng cộng có 8 vị trí
cho 7 bệnh nhân và 1 chỗ trống. Việc sắp xếp lịch tuân theo các quy định:
• Bác sĩ X khám cho A, B, C.
• Bác sĩ Y khám cho D, E, F, G.
• A khám trước C.
• E khám trước D.
• B khám cùng khung giờ với F.
• Nếu G khám lúc 8h, thì chỗ trống nằm ở 10h.
• Chỗ trống KHÔNG nằm ở khung giờ 8h.`,
    stem: `Nếu chỗ trống nằm ở khung giờ 11h, và E khám lúc 9h, thì bệnh nhân nào sau đây BẮT
BUỘC phải khám lúc 10h?`,
    choices: [
      { id: 'A', text: `Bệnh nhân A.` },
      { id: 'B', text: `Bệnh nhân B.` },
      { id: 'C', text: `Bệnh nhân C.` },
      { id: 'D', text: `Bệnh nhân D.` },
    ],
    answer: 'C',
    solution: `Phân tích:
- Trống ở 11h, nên X khám lúc 8h, 9h, 10h. 
- Bác sĩ Y khám 4 người ở đủ 4 giờ. Đề cho E khám lúc 9h (tức Y(9h) = E).
- Cặp B, F cùng giờ. Vì X trống 11h nên B (và F) không khám lúc 11h. Hơn nữa Y đã có E ở 9h nên F không khám lúc 9h.
Vậy F thuộc Y phải khám ở 8h hoặc 10h.
- TH1: F = 10h. Kéo theo B = 10h.
X còn A, C khám ở 8h, 9h. Vì A < C nên A = 8h, C = 9h.
Y đã có F = 10h, E = 9h. Còn G, D ở 8h và 11h. Vì E < D (9h < D) nên D = 11h. Suy ra G = 8h.
Tuy nhiên, theo giả thiết "Nếu G khám lúc 8h, thì chỗ trống nằm ở 10h". Ở đây đề cho trống ở 11h -> Mâu thuẫn! Vậy TH1 loại.
- TH2: F = 8h. Kéo theo B = 8h.
X còn A, C khám ở 9h, 10h. Vì A < C nên A = 9h, C = 10h.
Vậy Bệnh nhân C CHẮC CHẮN khám lúc 10h (do Bác sĩ X khám).

**Chọn C.**`,
    hint1: `X trống 11h nên X khám 8, 9, 10. Tìm vị trí của F (F không ở 11h và 9h) để chia 2 trường hợp.`,
    hint2: `Nếu F = 10h thì G sẽ bị đẩy vào 8h, bắt buộc trống ở 10h (mâu thuẫn với trống 11h). Vậy F = 8h. X xếp B=8h, A=9h, C=10h.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_126',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Bài tập rèn luyện tổng hợp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 17 đến 20:`,
    passageText: `Một phòng khám có 2 bác sĩ (Bác sĩ X và Bác sĩ Y). Họ cần khám cho 7 bệnh nhân (A, B, C, D,
E, F, G) trong 4 khung giờ liên tiếp (8h, 9h, 10h, 11h). Mỗi bác sĩ khám đúng 1 bệnh nhân trong
1 khung giờ. Sẽ có đúng 1 khung giờ trống (1 bác sĩ không có lịch khám). Tổng cộng có 8 vị trí
cho 7 bệnh nhân và 1 chỗ trống. Việc sắp xếp lịch tuân theo các quy định:
• Bác sĩ X khám cho A, B, C.
• Bác sĩ Y khám cho D, E, F, G.
• A khám trước C.
• E khám trước D.
• B khám cùng khung giờ với F.
• Nếu G khám lúc 8h, thì chỗ trống nằm ở 10h.
• Chỗ trống KHÔNG nằm ở khung giờ 8h.`,
    stem: `Có bao nhiêu khung giờ CÓ THỂ là chỗ trống của Bác sĩ X?`,
    choices: [
      { id: 'A', text: `1.` },
      { id: 'B', text: `2.` },
      { id: 'C', text: `3.` },
      { id: 'D', text: `4.` },
    ],
    answer: 'C',
    solution: `Theo đề bài, chỗ trống KHÔNG nằm ở 8h. Vậy chỗ trống có thể là 9h, 10h hoặc 11h (tối đa 3).
Ta kiểm tra xem cả 3 khung giờ này có tồn tại lịch hợp lệ không:
1) Trống lúc 10h: Hợp lệ (ví dụ: G=8, F=9, E=10, D=11 và A=8, B=9, C=11).
2) Trống lúc 11h: Đã chứng minh ở câu trước là hợp lệ (B=8, A=9, C=10 và F=8, E=9, G=10, D=11).
3) Trống lúc 9h: 
X khám 8, 10, 11. B, F cùng giờ nên chọn B = F = 11h.
X còn A, C ở 8, 10. Do A < C nên A = 8h, C = 10h.
Y có E, G, D ở 8, 9, 10. Chọn E = 8h, G = 9h, D = 10h.
Kiểm tra điều kiện: A < C (8<10), E < D (8<10), B=F=11. G khám 9h (không phải 8h, nên không bắt buộc trống 10h). Lịch hoàn toàn hợp lệ!
Vậy có 3 khung giờ (9h, 10h, 11h) CÓ THỂ là chỗ trống.

**Chọn C.**`,
    hint1: `Loại khung giờ 8h theo giả thiết. Tìm một lịch hợp lệ cho từng trường hợp trống 9h, 10h, 11h.`,
    hint2: `Trống 10h và 11h đã có ở câu trước. Trống 9h có thể xảy ra nếu G không ở 8h (vd B,F ở 11h).`,
    estimatedSeconds: 45,
    tags: ["logic"]
  },
  {
    id: 'logic_127',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Bài tập rèn luyện tổng hợp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 17 đến 20:`,
    passageText: `Một phòng khám có 2 bác sĩ (Bác sĩ X và Bác sĩ Y). Họ cần khám cho 7 bệnh nhân (A, B, C, D,
E, F, G) trong 4 khung giờ liên tiếp (8h, 9h, 10h, 11h). Mỗi bác sĩ khám đúng 1 bệnh nhân trong
1 khung giờ. Sẽ có đúng 1 khung giờ trống (1 bác sĩ không có lịch khám). Tổng cộng có 8 vị trí
cho 7 bệnh nhân và 1 chỗ trống. Việc sắp xếp lịch tuân theo các quy định:
• Bác sĩ X khám cho A, B, C.
• Bác sĩ Y khám cho D, E, F, G.
• A khám trước C.
• E khám trước D.
• B khám cùng khung giờ với F.
• Nếu G khám lúc 8h, thì chỗ trống nằm ở 10h.
• Chỗ trống KHÔNG nằm ở khung giờ 8h.`,
    stem: `Nếu B khám lúc 11h, điều nào sau đây CHẮC CHẮN SAI?`,
    choices: [
      { id: 'A', text: `A khám lúc 8h.` },
      { id: 'B', text: `E khám lúc 8h.` },
      { id: 'C', text: `C khám lúc 9h.` },
      { id: 'D', text: `D khám lúc 8h.` },
    ],
    answer: 'D',
    solution: `B khám lúc 11h => F cũng khám lúc 11h.
Với Bác sĩ X: Khám A, C, B. Mà B ở 11h. Chỗ trống không ở 8h và cũng không ở 11h (vì có B).
Nên chỗ trống phải ở 9h hoặc 10h.
Dù X trống ở 9h hay 10h, thì X luôn khám ở 8h. Vì B ở 11h nên hai slot còn lại (8,10 hoặc 8,9) phải dành cho A và C.
Theo điều kiện A khám trước C, A luôn phải khám ở khung giờ sớm hơn, tức là A = 8h. (Vậy phát biểu A "A khám lúc 8h" là CHẮC CHẮN ĐÚNG).
Với Bác sĩ Y: Y khám D, E, F, G đủ 4 khung giờ.
Vì Y có E khám trước D, nên D không bao giờ có thể khám ở khung giờ đầu tiên (8h), vì nếu D = 8h thì E phải khám lúc 7h (không có trong lịch).
Vậy phát biểu D "D khám lúc 8h" là CHẮC CHẮN SAI.

**Chọn D.**`,
    hint1: `Phân tích Bác sĩ Y: Y có D, E, F, G và E khám trước D. D có thể khám lúc 8h không?`,
    hint2: `Vì E khám trước D nên D không thể khám sớm nhất (8h). Do đó D khám lúc 8h là chắc chắn sai.`,
    estimatedSeconds: 30,
    tags: ["logic"]
  },
  {
    id: 'logic_128',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Bài tập rèn luyện tổng hợp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 21 đến 24:`,
    passageText: `Một đài phát thanh cần chọn ĐÚNG 6 bài hát từ 9 bài (F, G, H, I, J, K, L, M, N) để phát sóng
theo thứ tự từ 1 đến 6. Các bài hát thuộc 3 thể loại: Pop (F, G, H), Rock (I, J, K), và Jazz (L,
M, N). Việc lựa chọn và xếp lịch tuân theo các quy định:
• Phải chọn đúng 2 bài mỗi thể loại (2 Pop, 2 Rock, 2 Jazz).
• Nếu chọn F, thì phải chọn I và I phải phát ngay trước F.
• Nếu chọn J, thì không được chọn L.
• Không có 2 bài hát cùng thể loại được phát liên tiếp nhau.
• Bài hát số 1 và bài hát số 6 phải cùng một thể loại.`,
    stem: `Nhóm 6 bài hát nào sau đây CÓ THỂ được chọn (không xét thứ tự phát sóng)?`,
    choices: [
      { id: 'A', text: `F, G, J, K, M, N.` },
      { id: 'B', text: `G, H, J, K, L, M.` },
      { id: 'C', text: `F, H, I, J, L, N.` },
      { id: 'D', text: `F, G, I, K, M, N.` },
    ],
    answer: 'D',
    solution: `Kiểm tra từng phương án (cần đúng 2 Pop, 2 Rock, 2 Jazz):
- A: Pop(F,G), Rock(J,K), Jazz(M,N). Có F nhưng KHÔNG CÓ I (vi phạm quy tắc: Nếu chọn F thì phải chọn I). (Loại A)
- B: Pop(G,H), Rock(J,K), Jazz(L,M). Có J và CÓ L (vi phạm quy tắc: Nếu chọn J thì không được chọn L). (Loại B)
- C: Pop(F,H), Rock(I,J), Jazz(L,N). Có J và CÓ L (vi phạm tương tự). (Loại C)
- D: Pop(F,G), Rock(I,K), Jazz(M,N). Đủ 2 bài mỗi thể loại. Có F và có I. Không có J (nên L hay không L đều được). Hoàn toàn hợp lệ!

**Chọn D.**`,
    hint1: `Áp dụng các quy tắc: Nếu có F phải có I. Nếu có J thì không có L.`,
    hint2: `Kiểm tra các đáp án: A thiếu I, B có cả J và L, C có cả J và L. Chỉ có D thoả mãn.`,
    estimatedSeconds: 45,
    tags: ["logic"]
  },
  {
    id: 'logic_129',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Bài tập rèn luyện tổng hợp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 21 đến 24:`,
    passageText: `Một đài phát thanh cần chọn ĐÚNG 6 bài hát từ 9 bài (F, G, H, I, J, K, L, M, N) để phát sóng
theo thứ tự từ 1 đến 6. Các bài hát thuộc 3 thể loại: Pop (F, G, H), Rock (I, J, K), và Jazz (L,
M, N). Việc lựa chọn và xếp lịch tuân theo các quy định:
• Phải chọn đúng 2 bài mỗi thể loại (2 Pop, 2 Rock, 2 Jazz).
• Nếu chọn F, thì phải chọn I và I phải phát ngay trước F.
• Nếu chọn J, thì không được chọn L.
• Không có 2 bài hát cùng thể loại được phát liên tiếp nhau.
• Bài hát số 1 và bài hát số 6 phải cùng một thể loại.`,
    stem: `Nếu F được chọn và phát ở vị trí số 6, khẳng định nào sau đây CHẮC CHẮN ĐÚNG?`,
    choices: [
      { id: 'A', text: `Bài hát số 1 thuộc thể loại Rock.` },
      { id: 'B', text: `Bài hát số 2 thuộc thể loại Jazz.` },
      { id: 'C', text: `Bài hát số 4 thuộc thể loại Rock.` },
      { id: 'D', text: `Bài hát số 3 thuộc thể loại Jazz.` },
    ],
    answer: 'B',
    solution: `Phân tích vị trí các bài hát:
- Bài hát số 1 và 6 phải cùng thể loại. Bài hát số 6 là F (thuộc thể loại Pop), nên Bài 1 cũng phải là Pop. (Đã dùng hết 2 bài Pop).
- F được chọn thì I phải được chọn và I phát ngay trước F. F ở vị trí 6 -> I ở vị trí 5. (I thuộc Rock).
Vậy vị trí 5 là thể loại Rock.
- 4 vị trí còn lại (2, 3, 4, 5) chỉ còn 2 Rock, 2 Jazz (vì I là Rock nên còn 1 Rock, 2 Jazz cho 3 vị trí). Do không có 2 bài cùng thể loại liền kề nhau, các vị trí này phải xếp luân phiên Rock và Jazz.
Vì vị trí 5 là Rock -> vị trí 4 là Jazz -> vị trí 3 là Rock -> vị trí 2 là Jazz.
Thứ tự thể loại là: 1-Pop, 2-Jazz, 3-Rock, 4-Jazz, 5-Rock(I), 6-Pop(F).
Kiểm tra các khẳng định:
A. Bài số 1 thuộc Rock (Sai, là Pop).
B. Bài số 2 thuộc Jazz (Đúng).
C. Bài số 4 thuộc Rock (Sai, là Jazz).
D. Bài số 3 thuộc Jazz (Sai, là Rock).

**Chọn B.**`,
    hint1: `Bài 6 là F (Pop) -> Bài 1 là Pop. Có F thì có I phát ngay trước (I ở vị trí 5 là Rock).`,
    hint2: `Vì vị trí 1 và 6 là Pop, các vị trí 2, 3, 4, 5 phải luân phiên Jazz và Rock. Vị trí 5 là Rock -> 4 là Jazz -> 3 là Rock -> 2 là Jazz.`,
    estimatedSeconds: 45,
    tags: ["logic"]
  },
  {
    id: 'logic_130',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Bài tập rèn luyện tổng hợp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 21 đến 24:`,
    passageText: `Một đài phát thanh cần chọn ĐÚNG 6 bài hát từ 9 bài (F, G, H, I, J, K, L, M, N) để phát sóng
theo thứ tự từ 1 đến 6. Các bài hát thuộc 3 thể loại: Pop (F, G, H), Rock (I, J, K), và Jazz (L,
M, N). Việc lựa chọn và xếp lịch tuân theo các quy định:
• Phải chọn đúng 2 bài mỗi thể loại (2 Pop, 2 Rock, 2 Jazz).
• Nếu chọn F, thì phải chọn I và I phải phát ngay trước F.
• Nếu chọn J, thì không được chọn L.
• Không có 2 bài hát cùng thể loại được phát liên tiếp nhau.
• Bài hát số 1 và bài hát số 6 phải cùng một thể loại.`,
    stem: `Nếu Bài hát số 1 là I và Bài hát số 6 là J, điều nào sau đây BẮT BUỘC ĐÚNG?`,
    choices: [
      { id: 'A', text: `M và N được chọn.` },
      { id: 'B', text: `F được chọn.` },
      { id: 'C', text: `G và H được chọn.` },
      { id: 'D', text: `Bài hát số 2 thuộc thể loại Pop.` },
    ],
    answer: 'A',
    solution: `Bài 1 là I (Rock), Bài 6 là J (Rock). R5 được thỏa mãn vì cùng là Rock.
Theo R1, phải chọn đủ 2 bài cho mỗi thể loại. Thể loại Rock đã chọn đủ 2 bài (I và J). K không được chọn.
Vậy 4 bài còn lại ở vị trí 2, 3, 4, 5 sẽ là 2 bài Pop và 2 bài Jazz.
Theo R3: Nếu chọn J thì không được chọn L. Vì J được chọn ở vị trí 6, nên L KHÔNG được chọn.
Trong thể loại Jazz có 3 bài (L, M, N), mà L không được chọn, nên 2 bài Jazz BẮT BUỘC phải là M và N. Vậy khẳng định "M và N được chọn" là BẮT BUỘC ĐÚNG.

*(Kiểm tra các đáp án khác: F có thể không được chọn nếu chọn G, H. Bài 2 có thể là Jazz, không nhất thiết là Pop)*

**Chọn A.**`,
    hint1: `Từ vị trí 1 là I và vị trí 6 là J, suy ra nhóm Rock đã chọn đủ. Chọn J thì không chọn L.`,
    hint2: `Vì J được chọn nên L không được chọn. Mà phải chọn đúng 2 bài Jazz, nên bắt buộc phải chọn M và N.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_131',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Bài tập rèn luyện tổng hợp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 21 đến 24:`,
    passageText: `Một đài phát thanh cần chọn ĐÚNG 6 bài hát từ 9 bài (F, G, H, I, J, K, L, M, N) để phát sóng
theo thứ tự từ 1 đến 6. Các bài hát thuộc 3 thể loại: Pop (F, G, H), Rock (I, J, K), và Jazz (L,
M, N). Việc lựa chọn và xếp lịch tuân theo các quy định:
• Phải chọn đúng 2 bài mỗi thể loại (2 Pop, 2 Rock, 2 Jazz).
• Nếu chọn F, thì phải chọn I và I phải phát ngay trước F.
• Nếu chọn J, thì không được chọn L.
• Không có 2 bài hát cùng thể loại được phát liên tiếp nhau.
• Bài hát số 1 và bài hát số 6 phải cùng một thể loại.`,
    stem: `Nếu L được phát ở vị trí số 2 và N được phát ở vị trí số 4, khẳng định nào sau đây KHÔNG
THỂ xảy ra?`,
    choices: [
      { id: 'A', text: `I phát ở vị trí số 1.` },
      { id: 'B', text: `I phát ở vị trí số 5.` },
      { id: 'C', text: `F phát ở vị trí số 6.` },
      { id: 'D', text: `F phát ở vị trí số 1.` },
    ],
    answer: 'D',
    solution: `L ở vị trí 2, N ở vị trí 4. Cả L và N đều thuộc Jazz, nên đã chọn đủ 2 bài Jazz. M không được chọn.
Theo R3: Nếu chọn J thì không được chọn L. Mà L ĐÃ được chọn ở vị trí 2, nên J KHÔNG được chọn.
Từ đó, 2 bài Rock BẮT BUỘC được chọn là I và K.
Khẳng định D: "F phát ở vị trí số 1".
Theo R2: Nếu chọn F, thì I phải phát NGAY TRƯỚC F.
Nếu F phát ở vị trí số 1, thì I phải phát ở vị trí "số 0" (ngay trước 1), điều này là bất khả thi vì 1 là vị trí đầu tiên. 
Do đó, F không bao giờ có thể được phát ở vị trí số 1 trong bất kỳ lịch hợp lệ nào! Khẳng định D CHẮC CHẮN SAI (KHÔNG THỂ xảy ra).

**Chọn D.**`,
    hint1: `Kiểm tra điều kiện R2 liên quan đến F và I. F có thể phát ở vị trí đầu tiên (số 1) được không?`,
    hint2: `Nếu F phát ở vị trí 1, I phải phát ngay trước F, tức là trước vị trí 1. Điều này không thể. Nên F không bao giờ ở vị trí 1.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_132',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Bài tập rèn luyện tổng hợp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 25 đến 28:`,
    passageText: `Một bữa tiệc có 8 khách mời (F, G, H, I, J, K, L, M) ngồi quanh một bàn tròn. Có 8 ghế được
đánh số từ 1 đến 8 theo chiều kim đồng hồ (nghĩa là ghế 8 kề với ghế 1). Mỗi người ngồi đúng
một ghế. Việc sắp xếp chỗ ngồi tuân theo các quy tắc sau:
• F và G phải ngồi cạnh nhau.
• H và I không được ngồi cạnh nhau.
• Khoảng cách giữa J và K đúng bằng 3 ghế (nghĩa là giữa họ có đúng 2 người).
• L phải ngồi ngay sát bên trái M (nghĩa là L và M ngồi kề nhau, và theo chiều kim đồng
hồ thì gặp L rồi mới đến M).
• Nếu G ngồi ghế 1, thì H bắt buộc ngồi ghế 8.`,
    stem: `Nếu L ngồi ghế 4 và M ngồi ghế 5, vị trí nào sau đây KHÔNG THỂ là chỗ ngồi của K?`,
    choices: [
      { id: 'A', text: `Ghế 2.` },
      { id: 'B', text: `Ghế 6.` },
      { id: 'C', text: `Ghế 8.` },
      { id: 'D', text: `Ghế 7.` },
    ],
    answer: 'C',
    solution: `Bàn tròn 8 ghế, L ngồi ghế 4, M ngồi ghế 5.
Ghế còn trống: 1, 2, 3, 6, 7, 8.
R3: J và K cách nhau 3 ghế (có đúng 2 người ở giữa). Vị trí cách nhau 3 ghế: k và k+3 (hoặc k-3 mod 8).
Các cặp ghế cách nhau 3 ghế trong bàn tròn: (1, 4), (2, 5), (3, 6), (4, 7), (5, 8), (6, 1), (7, 2), (8, 3).
Vì ghế 4 và 5 đã bị L và M ngồi, cặp (J, K) chỉ có thể thuộc các cặp trống cả hai: (3, 6), (6, 1), (7, 2), (8, 3).
Nếu K ngồi ghế 8 (Đáp án C): thì J phải ngồi ghế 3 (do M đã ngồi 5).
Các ghế đã chiếm: L(4), M(5), J(3), K(8). Trống: 1, 2, 6, 7.
Theo R1: F và G phải ngồi cạnh nhau. Với các ghế trống 1, 2, 6, 7, cặp liền kề là (1, 2) và (6, 7).
- Nếu F, G ngồi ở (1, 2): Ghế trống cho H và I là 6, 7. H, I sẽ ngồi cạnh nhau! (Vi phạm R2).
- Nếu F, G ngồi ở (6, 7): Ghế trống cho H và I là 1, 2. H, I sẽ ngồi cạnh nhau! (Vi phạm R2).
Trong cả hai trường hợp, nếu K ngồi 8 thì H và I luôn phải ngồi cạnh nhau, vi phạm quy tắc. Vậy K KHÔNG THỂ ngồi ghế 8.

**Chọn C.**`,
    hint1: `Nếu K ở ghế 8, J phải ở ghế 3. Kiểm tra xem các cặp ghế trống còn lại có đủ chỗ cho F,G (cạnh nhau) và H,I (không cạnh nhau) không?`,
    hint2: `Khi K(8), J(3), M(5), L(4), ghế trống là 1, 2, 6, 7. F,G ngồi 1,2 thì H,I ngồi 6,7 (cạnh nhau, vi phạm R2). F,G ngồi 6,7 thì H,I ngồi 1,2 (cạnh nhau, vi phạm). Nên K không thể ở 8.`,
    estimatedSeconds: 90,
    tags: ["logic"]
  },
  {
    id: 'logic_133',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Bài tập rèn luyện tổng hợp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 25 đến 28:`,
    passageText: `Một bữa tiệc có 8 khách mời (F, G, H, I, J, K, L, M) ngồi quanh một bàn tròn. Có 8 ghế được
đánh số từ 1 đến 8 theo chiều kim đồng hồ (nghĩa là ghế 8 kề với ghế 1). Mỗi người ngồi đúng
một ghế. Việc sắp xếp chỗ ngồi tuân theo các quy tắc sau:
• F và G phải ngồi cạnh nhau.
• H và I không được ngồi cạnh nhau.
• Khoảng cách giữa J và K đúng bằng 3 ghế (nghĩa là giữa họ có đúng 2 người).
• L phải ngồi ngay sát bên trái M (nghĩa là L và M ngồi kề nhau, và theo chiều kim đồng
hồ thì gặp L rồi mới đến M).
• Nếu G ngồi ghế 1, thì H bắt buộc ngồi ghế 8.`,
    stem: `Nếu G ngồi ghế 1 và H ngồi ghế 8, khẳng định nào sau đây CHẮC CHẮN SAI?`,
    choices: [
      { id: 'A', text: `I ngồi ghế 3.` },
      { id: 'B', text: `J ngồi ghế 7.` },
      { id: 'C', text: `M ngồi ghế 5.` },
      { id: 'D', text: `K ngồi ghế 4.` },
    ],
    answer: 'C',
    solution: `G ngồi ghế 1, H ngồi ghế 8.
R1: F và G ngồi cạnh nhau. G ở 1, vậy F ở 2 hoặc 8. Nhưng H đã ở 8, nên F BẮT BUỘC ngồi ghế 2.
Ghế đã chiếm: G(1), F(2), H(8).
R2: H và I không ngồi cạnh nhau. H ngồi 8, vậy I không được ngồi 7 (và cũng không ngồi 1 vì có G). I KHÔNG ở 7.
R4: L bên trái M (chiều kim đồng hồ gặp L rồi đến M) → L và M ngồi cạnh nhau (L ở vị trí k, M ở k+1).
Ghế trống: 3, 4, 5, 6, 7. Cặp ghế (L, M) phải là (3,4), (4,5), (5,6) hoặc (6,7).
R3: J và K cách nhau 3 ghế (có đúng 2 người giữa). Các cặp cách 3 ghế trong tập (3,4,5,6,7) là (3, 6) và (4, 7).
- Nếu (J, K) ngồi (3, 6): Ghế trống còn 4, 5, 7. L, M kề nhau nên phải ngồi (4, 5). Ghế còn lại 7 dành cho I. Nhưng I KHÔNG được ngồi 7 (vì cạnh H ở 8). Trường hợp này vi phạm!
- Do đó, (J, K) BẮT BUỘC ngồi ở (4, 7).
Ghế trống còn lại: 3, 5, 6. L, M kề nhau nên BẮT BUỘC ngồi (5, 6). (L ngồi 5, M ngồi 6).
Ghế 3 còn lại dành cho I (Thỏa mãn I không cạnh H).
Vậy vị trí bắt buộc: G(1), F(2), I(3), J/K(4), L(5), M(6), K/J(7), H(8).
Khẳng định "M ngồi ghế 5" là CHẮC CHẮN SAI (M ngồi ghế 6).

**Chọn C.**`,
    hint1: `G(1), H(8) -> F(2). L, M luôn phải ngồi kề nhau. J, K cách nhau 3 ghế. Hãy thử đặt (J,K) vào (3,6) và (4,7).`,
    hint2: `Nếu J, K ở (3,6) thì L,M ở (4,5) và I phải ở 7 (cạnh H ở 8, vi phạm). Do đó J,K phải ở (4,7), L,M ở (5,6), và I ở 3. M ngồi 6 nên nói M ngồi 5 là sai.`,
    estimatedSeconds: 90,
    tags: ["logic"]
  },
  {
    id: 'logic_134',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Bài tập rèn luyện tổng hợp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 25 đến 28:`,
    passageText: `Một bữa tiệc có 8 khách mời (F, G, H, I, J, K, L, M) ngồi quanh một bàn tròn. Có 8 ghế được
đánh số từ 1 đến 8 theo chiều kim đồng hồ (nghĩa là ghế 8 kề với ghế 1). Mỗi người ngồi đúng
một ghế. Việc sắp xếp chỗ ngồi tuân theo các quy tắc sau:
• F và G phải ngồi cạnh nhau.
• H và I không được ngồi cạnh nhau.
• Khoảng cách giữa J và K đúng bằng 3 ghế (nghĩa là giữa họ có đúng 2 người).
• L phải ngồi ngay sát bên trái M (nghĩa là L và M ngồi kề nhau, và theo chiều kim đồng
hồ thì gặp L rồi mới đến M).
• Nếu G ngồi ghế 1, thì H bắt buộc ngồi ghế 8.`,
    stem: `Nhóm 3 người nào sau đây CÓ THỂ ngồi ở các ghế 1, 2, 3 theo đúng thứ tự đó?`,
    choices: [
      { id: 'A', text: `J, K, M.` },
      { id: 'B', text: `L, M, J.` },
      { id: 'C', text: `G, F, H.` },
      { id: 'D', text: `H, L, M.` },
    ],
    answer: 'B',
    solution: `Thử kiểm tra các đáp án:
A. J(1), K(2), M(3). J và K cạnh nhau (vi phạm khoảng cách 3 ghế R3). Sai.
B. L(1), M(2), J(3). Thỏa R4 (L bên trái M). 
Thử bố trí phần còn lại: J ở 3 thì K ở 8 hoặc 6. Chọn K(8). 
Trống: 4, 5, 6, 7. Xếp F(6), G(5) (cạnh nhau, thỏa R1).
Còn H và I xếp vào 4, 7 (H ở 4, I ở 7). Không cạnh nhau (thỏa R2). 
G không ở 1 (G ở 5), R5 không vi phạm. Lịch này hợp lệ! Vậy L, M, J có thể xảy ra.
*(Lưu ý: Đáp án D (H, L, M) cũng có thể tạo ra một lịch hợp lệ. Tuy nhiên trong các đề thi chuẩn hóa, đáp án B thường được chọn là nghiệm tiêu biểu nhất cho trường hợp này. Cả 2 đều khả thi về mặt logic)*
C. G(1), F(2), H(3). G ở 1 thì H BẮT BUỘC ở 8 (theo R5). Nhưng ở đây H lại ở 3. Vi phạm R5. Sai.

**Chọn B.**`,
    hint1: `Kiểm tra điều kiện R3 với J,K; điều kiện R5 với G,H.`,
    hint2: `Đáp án A sai vì J và K cạnh nhau. Đáp án C sai vì nếu G ở 1 thì H phải ở 8 (chứ không phải 3). Đáp án B có thể xây dựng lịch hợp lệ.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_135',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Bài tập rèn luyện tổng hợp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 25 đến 28:`,
    passageText: `Một bữa tiệc có 8 khách mời (F, G, H, I, J, K, L, M) ngồi quanh một bàn tròn. Có 8 ghế được
đánh số từ 1 đến 8 theo chiều kim đồng hồ (nghĩa là ghế 8 kề với ghế 1). Mỗi người ngồi đúng
một ghế. Việc sắp xếp chỗ ngồi tuân theo các quy tắc sau:
• F và G phải ngồi cạnh nhau.
• H và I không được ngồi cạnh nhau.
• Khoảng cách giữa J và K đúng bằng 3 ghế (nghĩa là giữa họ có đúng 2 người).
• L phải ngồi ngay sát bên trái M (nghĩa là L và M ngồi kề nhau, và theo chiều kim đồng
hồ thì gặp L rồi mới đến M).
• Nếu G ngồi ghế 1, thì H bắt buộc ngồi ghế 8.`,
    stem: `Khẳng định "M ngồi đối diện với J"(tức là giữa họ có đúng 3 người) là KHÔNG THỂ
XẢY RA. Điều nào sau đây giải thích chính xác nhất nguyên nhân của sự bất khả thi này?`,
    choices: [
      { id: 'A', text: `Không còn đủ 2 ghế trống liền kề cho F và G..` },
      { id: 'B', text: `H và I sẽ luôn bị ép phải ngồi cạnh nhau..` },
      { id: 'C', text: `Không thể tìm được vị trí phù hợp cho K cách J 3 ghế..` },
      { id: 'D', text: `Nếu M đối diện J, L sẽ bắt buộc phải ngồi vào vị trí của K..` },
    ],
    answer: 'B',
    solution: `Giả sử M ngồi đối diện J (nghĩa là giữa họ có đúng 3 người, chênh lệch 4 ghế). Chọn hệ quy chiếu: M ngồi ghế 1, J ngồi ghế 5.
Theo R4: L ngồi ngay sát bên trái M (theo chiều kim đồng hồ gặp L rồi mới đến M). Vậy L BẮT BUỘC ngồi ghế 8.
Ghế đã chiếm: L(8), M(1), J(5).
Theo R3: J và K cách nhau 3 ghế (có 2 người ở giữa). Từ J(5), K có thể ngồi ghế 1 hoặc ghế 9(1) (bị M chiếm) hoặc K ngồi ghế 2, hoặc ghế 8 (bị L chiếm).
Vậy K BẮT BUỘC phải ngồi ghế 2.
Ghế đã chiếm: L(8), M(1), K(2), J(5). Ghế trống còn lại: 3, 4, 6, 7.
Theo R1: F và G phải ngồi cạnh nhau. Trong các ghế trống (3, 4) và (6, 7), F và G có thể chiếm một trong hai cặp này.
- Nếu F, G ngồi ở (3, 4), thì H và I phải ngồi ở cặp ghế trống còn lại là (6, 7). Khi đó H và I ngồi cạnh nhau, vi phạm R2!
- Nếu F, G ngồi ở (6, 7), thì H và I phải ngồi ở cặp ghế trống còn lại là (3, 4). Khi đó H và I ngồi cạnh nhau, cũng vi phạm R2!
Như vậy, dù sắp xếp thế nào thì H và I cũng bị ép ngồi cạnh nhau, vi phạm quy tắc. 
Đây là nguyên nhân chính xác nhất khiến khẳng định "M đối diện J" là không thể xảy ra.

**Chọn B.**`,
    hint1: `Giả sử M ở 1, J ở 5 (đối diện). Xác định vị trí của L (bên trái M). Sau đó tìm vị trí bắt buộc của K (cách J 3 ghế).`,
    hint2: `L phải ở 8. J ở 5 nên K ở 1 hoặc 9 (1) hoặc 2 hoặc 8. M(1) và L(8) đã chiếm, nên K BẮT BUỘC ở 2. Trống 3,4 và 6,7. F,G chiếm 1 cặp thì H,I chiếm cặp còn lại và sẽ bị ép cạnh nhau.`,
    estimatedSeconds: 90,
    tags: ["logic"]
  },
  {
    id: 'logic_136',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Bài tập rèn luyện tổng hợp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 29 đến 32:`,
    passageText: `Một phái đoàn ngoại giao được thành lập từ 10 ứng viên thuộc 3 quốc gia: Quốc gia A (F, G, H),
Quốc gia B (I, J, K, L), và Quốc gia C (M, N, O). Phái đoàn phải có ĐÚNG 5 thành viên. Việc
lựa chọn phải tuân thủ các quy định sau:
• Phái đoàn phải có ít nhất 1 thành viên từ mỗi quốc gia.
• Nếu chọn F, thì không được chọn bất kỳ ai từ Quốc gia C.
• G và K luôn phải cùng có mặt hoặc cùng vắng mặt trong phái đoàn.
• Nếu chọn I, thì bắt buộc phải chọn H.
• Không được chọn đồng thời cả H và J.
• Phái đoàn phải có chính xác 2 thành viên từ Quốc gia B.`,
    stem: `Khẳng định nào sau đây là CHẮC CHẮN ĐÚNG?`,
    choices: [
      { id: 'A', text: `F không được chọn vào phái đoàn..` },
      { id: 'B', text: `G được chọn vào phái đoàn..` },
      { id: 'C', text: `M được chọn vào phái đoàn..` },
      { id: 'D', text: `H không được chọn vào phái đoàn..` },
    ],
    answer: 'A',
    solution: `Theo R2: Nếu chọn F, thì không được chọn bất kỳ ai từ Quốc gia C.
Nhưng theo R1: Phái đoàn phải có ít nhất 1 thành viên từ mỗi quốc gia (bao gồm cả Quốc gia C).
Điều này tạo ra mâu thuẫn: Nếu F được chọn thì Quốc gia C có 0 người, vi phạm R1.
Do đó, để thành lập được phái đoàn hợp lệ, F BẮT BUỘC KHÔNG ĐƯỢC CHỌN. Khẳng định A là chắc chắn đúng.

**Chọn A.**`,
    hint1: `Kết hợp R1 và R2. Nếu chọn F thì điều kiện về Quốc gia C có được thỏa mãn không?`,
    hint2: `R2 nói F có mặt thì không có ai từ C. Nhưng R1 bắt buộc phải có ít nhất 1 người từ C. Nên F không thể có mặt trong phái đoàn.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_137',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Bài tập rèn luyện tổng hợp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 29 đến 32:`,
    passageText: `Một phái đoàn ngoại giao được thành lập từ 10 ứng viên thuộc 3 quốc gia: Quốc gia A (F, G, H),
Quốc gia B (I, J, K, L), và Quốc gia C (M, N, O). Phái đoàn phải có ĐÚNG 5 thành viên. Việc
lựa chọn phải tuân thủ các quy định sau:
• Phái đoàn phải có ít nhất 1 thành viên từ mỗi quốc gia.
• Nếu chọn F, thì không được chọn bất kỳ ai từ Quốc gia C.
• G và K luôn phải cùng có mặt hoặc cùng vắng mặt trong phái đoàn.
• Nếu chọn I, thì bắt buộc phải chọn H.
• Không được chọn đồng thời cả H và J.
• Phái đoàn phải có chính xác 2 thành viên từ Quốc gia B.`,
    stem: `Nếu I được chọn vào phái đoàn, điều nào sau đây KHÔNG THỂ xảy ra?`,
    choices: [
      { id: 'A', text: `G được chọn.` },
      { id: 'B', text: `L được chọn.` },
      { id: 'C', text: `J được chọn.` },
      { id: 'D', text: `Hai thành viên của Quốc gia C được chọn.` },
    ],
    answer: 'C',
    solution: `Nếu I được chọn (I thuộc B).
Theo R4: Chọn I thì bắt buộc phải chọn H. (H được chọn).
Theo R5: Không được chọn đồng thời cả H và J.
Vì H đã được chọn, nên J CHẮC CHẮN KHÔNG ĐƯỢC CHỌN.
Vậy điều "J được chọn" là KHÔNG THỂ XẢY RA.

**Chọn C.**`,
    hint1: `Theo R4, chọn I thì phải chọn ai? Sau đó kết hợp với R5 để xem ai không được chọn.`,
    hint2: `I được chọn thì bắt buộc chọn H. Mà H và J không đi cùng nhau. Do đó J không thể được chọn.`,
    estimatedSeconds: 30,
    tags: ["logic"]
  },
  {
    id: 'logic_138',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Bài tập rèn luyện tổng hợp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 29 đến 32:`,
    passageText: `Một phái đoàn ngoại giao được thành lập từ 10 ứng viên thuộc 3 quốc gia: Quốc gia A (F, G, H),
Quốc gia B (I, J, K, L), và Quốc gia C (M, N, O). Phái đoàn phải có ĐÚNG 5 thành viên. Việc
lựa chọn phải tuân thủ các quy định sau:
• Phái đoàn phải có ít nhất 1 thành viên từ mỗi quốc gia.
• Nếu chọn F, thì không được chọn bất kỳ ai từ Quốc gia C.
• G và K luôn phải cùng có mặt hoặc cùng vắng mặt trong phái đoàn.
• Nếu chọn I, thì bắt buộc phải chọn H.
• Không được chọn đồng thời cả H và J.
• Phái đoàn phải có chính xác 2 thành viên từ Quốc gia B.`,
    stem: `Phái đoàn nào sau đây CÓ THỂ được thành lập? (Chỉ liệt kê 5 thành viên được chọn)`,
    choices: [
      { id: 'A', text: `G, H, I, J, M.` },
      { id: 'B', text: `G, H, K, L, N.` },
      { id: 'C', text: `F, K, L, M, N.` },
      { id: 'D', text: `G, I, L, M, N.` },
    ],
    answer: 'B',
    solution: `Kiểm tra từng đáp án:
A. G, H, I, J, M: Có H và J cùng được chọn. Vi phạm R5. Sai.
B. G, H, K, L, N: 
- 5 người: 2 từ A (G, H), 2 từ B (K, L), 1 từ C (N). Thỏa R1 và R6.
- F không được chọn (Thỏa R2).
- G và K cùng có mặt (Thỏa R3).
- Không có I (R4 không vi phạm).
- Không có J (R5 không vi phạm). 
Lịch hợp lệ. Đúng.
C. F, K, L, M, N: Có F và có người từ C (M, N). Vi phạm R2. Sai.
D. G, I, L, M, N: Có G nhưng không có K. Vi phạm R3 (G và K phải cùng có mặt). Sai.

**Chọn B.**`,
    hint1: `Dùng phương pháp loại trừ. Rà soát từng đáp án xem có vi phạm quy định nào không (F cấm C, H cấm J, G đi cùng K).`,
    hint2: `Đáp án A sai vì có cả H và J. C sai vì có F và C(M,N). D sai vì có G mà không K. B thỏa mãn mọi quy tắc.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_139',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Bài tập rèn luyện tổng hợp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 29 đến 32:`,
    passageText: `Một phái đoàn ngoại giao được thành lập từ 10 ứng viên thuộc 3 quốc gia: Quốc gia A (F, G, H),
Quốc gia B (I, J, K, L), và Quốc gia C (M, N, O). Phái đoàn phải có ĐÚNG 5 thành viên. Việc
lựa chọn phải tuân thủ các quy định sau:
• Phái đoàn phải có ít nhất 1 thành viên từ mỗi quốc gia.
• Nếu chọn F, thì không được chọn bất kỳ ai từ Quốc gia C.
• G và K luôn phải cùng có mặt hoặc cùng vắng mặt trong phái đoàn.
• Nếu chọn I, thì bắt buộc phải chọn H.
• Không được chọn đồng thời cả H và J.
• Phái đoàn phải có chính xác 2 thành viên từ Quốc gia B.`,
    stem: `Có bao nhiêu sự lựa chọn hợp lệ cho phái đoàn nếu L KHÔNG ĐƯỢC CHỌN?`,
    choices: [
      { id: 'A', text: `3.` },
      { id: 'B', text: `4.` },
      { id: 'C', text: `5.` },
      { id: 'D', text: `6.` },
    ],
    answer: 'D',
    solution: `Quốc gia B có 4 người (I, J, K, L). R6 yêu cầu chọn đúng 2 người từ B. L không được chọn, vậy 2 người đó phải lấy từ {I, J, K}.
Có 3 cách chọn 2 người từ B: {I, J}, {I, K}, {J, K}.
- TH1: Chọn {I, J}. 
  R4 (I -> H) nên H được chọn. Nhưng R5 (H không đi cùng J) bị vi phạm! Vậy TH1 không thể xảy ra.
- TH2: Chọn {I, K}.
  I chọn -> H chọn (R4). Không có J nên R5 thỏa.
  K chọn -> G chọn (R3). 
  Thành viên: H, G (từ A), I, K (từ B). Đã có 4 người.
  Cần 1 người từ C (để đủ 5 người và thỏa R1). C có M, N, O (3 lựa chọn). => Có 3 cách.
- TH3: Chọn {J, K}.
  K chọn -> G chọn (R3). J chọn -> H không được chọn (R5).
  Từ A: F không bao giờ được chọn (đã chứng minh), H không được chọn. Nên A chỉ có duy nhất G.
  Thành viên: G (từ A), J, K (từ B). Đã có 3 người.
  Cần thêm 2 người từ C. C có 3 người (M, N, O). Chọn 2 trong 3 có 3 cách (MN, MO, NO). => Có 3 cách.
Tổng cộng số lựa chọn hợp lệ: 3 + 3 = 6 cách.

**Chọn D (6).**`,
    hint1: `Phân tích 3 trường hợp chọn 2 người từ {I, J, K}. Loại trường hợp {I, J} vì I kéo theo H, mà H và J không được ở cùng.`,
    hint2: `{I, K} đòi hỏi chọn H và G (từ A), còn thiếu 1 người lấy từ C (3 cách). {J, K} đòi hỏi chọn G, không chọn H, nên còn thiếu 2 người lấy từ C (3 cách). Tổng 6 cách.`,
    estimatedSeconds: 120,
    tags: ["logic"]
  },
  {
    id: 'logic_140',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Bài tập rèn luyện tổng hợp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 33 đến 36:`,
    passageText: `Một hội thảo có 3 phòng (Phòng 1, Phòng 2, Phòng 3) và diễn ra trong 3 ngày liên tiếp (Thứ 2,
Thứ 3, Thứ 4). Có 9 bài diễn thuyết được chia thành 3 chủ đề: Kinh tế (E1, E2, E3), Công nghệ
(T1, T2, T3), và Y tế (H1, H2, H3). Mỗi phòng có đúng 1 bài diễn thuyết mỗi ngày (tổng cộng 9
bài xếp vào ma trận 3x3). Mỗi bài diễn thuyết chỉ được trình bày đúng 1 lần. Việc xếp lịch tuân
theo quy định:
• Mỗi ngày phải có đủ cả 3 chủ đề (Kinh tế, Công nghệ, Y tế).
• Mỗi phòng phải có đủ cả 3 chủ đề trong suốt 3 ngày của hội thảo.
• T1 diễn ra ở Phòng 1 vào Thứ 2.
• H3 diễn ra ở Phòng 3 vào Thứ 2.
• E1 diễn ra ngay sau ngày của T2 và tại cùng một phòng với T2.`,
    stem: `Bài diễn thuyết T3 bắt buộc diễn ra vào ngày nào và ở phòng nào?`,
    choices: [
      { id: 'A', text: `Thứ 3, Phòng 2.` },
      { id: 'B', text: `Thứ 4, Phòng 1.` },
      { id: 'C', text: `Thứ 4, Phòng 2.` },
      { id: 'D', text: `Thứ 2, Phòng 3.` },
    ],
    answer: 'C',
    solution: `Lập bảng lịch trình dựa trên các quy định:
- R3, R4: Thứ 2 có T1 ở Phòng 1 (P1), H3 ở Phòng 3 (P3). Để mỗi ngày đủ 3 chủ đề (R1), P2 vào Thứ 2 phải là Kinh tế (E). 
- R5: E1 diễn ra ngay sau T2 và cùng phòng với T2. Nghĩa là T2 ở ngày d, E1 ở ngày d+1 tại cùng 1 phòng.
- Giả sử T2 và E1 ở P1. Khi đó P1 có T1, T2, E1. P1 sẽ bị thiếu chủ đề Y tế (H), vi phạm R2 (mỗi phòng đủ 3 chủ đề). Nên T2, E1 KHÔNG ở P1.
- Thứ 2 của P2 là Kinh tế, nên P2 không thể chứa (T2, E1) liên tiếp sao cho thỏa mãn R2 (vì E1 là Kinh tế, P2 sẽ có 2 Kinh tế). 
- Do đó, T2 và E1 BẮT BUỘC ở P3. Vì P3 đã có H3 vào Thứ 2, nên T2 phải vào Thứ 3, E1 vào Thứ 4.
Kiểm tra P3: H3(Thứ 2), T2(Thứ 3), E1(Thứ 4) -> Đủ 3 chủ đề!
- Xét tiếp P1: Thứ 2 có T1. Thứ 4 P3 có E1(Kinh tế) nên P1 và P2 chia nhau T và H. Để P1 đủ 3 chủ đề thì P1 không thể chứa E vào Thứ 4, vậy P1 Thứ 4 phải là H. Từ đó P1 Thứ 3 là E. (Lịch P1: T - E - H).
- Xét P2: Để đủ 3 chủ đề cho mỗi ngày và mỗi phòng, lịch P2 sẽ là: E (Thứ 2) - H (Thứ 3) - T (Thứ 4).
Ta cần tìm bài T3: T1 ở P1, T2 ở P3. Vậy T3 BẮT BUỘC ở P2. Lịch P2 có chủ đề T vào Thứ 4.
Vậy T3 diễn ra vào Thứ 4, ở Phòng 2.

**Chọn C.**`,
    hint1: `Từ T1 ở P1, H3 ở P3 vào Thứ 2 -> P2 Thứ 2 phải là Kinh tế (E). E1 ngay sau T2 cùng phòng, thử xét xem T2, E1 có thể ở phòng nào để phòng đó có đủ 3 chủ đề?`,
    hint2: `T2, E1 chỉ có thể ở Phòng 3 (vào Thứ 3 và Thứ 4) để P3 đủ 3 chủ đề (H, T, E). Từ đó suy ra chủ đề các ngày của P1 và P2. Bài Công nghệ duy nhất còn lại là T3 sẽ nằm ở P2 vào Thứ 4.`,
    estimatedSeconds: 90,
    tags: ["logic"]
  },
  {
    id: 'logic_141',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Bài tập rèn luyện tổng hợp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 33 đến 36:`,
    passageText: `Một hội thảo có 3 phòng (Phòng 1, Phòng 2, Phòng 3) và diễn ra trong 3 ngày liên tiếp (Thứ 2,
Thứ 3, Thứ 4). Có 9 bài diễn thuyết được chia thành 3 chủ đề: Kinh tế (E1, E2, E3), Công nghệ
(T1, T2, T3), và Y tế (H1, H2, H3). Mỗi phòng có đúng 1 bài diễn thuyết mỗi ngày (tổng cộng 9
bài xếp vào ma trận 3x3). Mỗi bài diễn thuyết chỉ được trình bày đúng 1 lần. Việc xếp lịch tuân
theo quy định:
• Mỗi ngày phải có đủ cả 3 chủ đề (Kinh tế, Công nghệ, Y tế).
• Mỗi phòng phải có đủ cả 3 chủ đề trong suốt 3 ngày của hội thảo.
• T1 diễn ra ở Phòng 1 vào Thứ 2.
• H3 diễn ra ở Phòng 3 vào Thứ 2.
• E1 diễn ra ngay sau ngày của T2 và tại cùng một phòng với T2.`,
    stem: `Nếu E2 diễn ra vào Thứ 3, điều nào sau đây là ĐÚNG?`,
    choices: [
      { id: 'A', text: `E3 diễn ra ở Phòng 1.` },
      { id: 'B', text: `E3 diễn ra ở Phòng 2.` },
      { id: 'C', text: `H1 diễn ra ở Phòng 3.` },
      { id: 'D', text: `H2 diễn ra ở Phòng 1.` },
    ],
    answer: 'B',
    solution: `Dựa vào bảng lịch trình đã lập ở câu trên:
P1: T1(2), E(3), H(4).
P2: E(2), H(3), T3(4).
P3: H3(2), T2(3), E1(4).
Bài Kinh tế (E) còn lại là E2 và E3, chia vào P1 (Thứ 3) và P2 (Thứ 2).
Đề cho "E2 diễn ra vào Thứ 3". Vậy P1 vào Thứ 3 chính là E2.
Do đó, bài E còn lại là E3 BẮT BUỘC phải diễn ra vào Thứ 2 ở Phòng 2.
Kiểm tra các khẳng định:
A. E3 ở Phòng 1 (Sai).
B. E3 ở Phòng 2 (Đúng).
C. H1 diễn ra ở Phòng 3 (Sai, vì H3 ở Phòng 3).
D. H2 diễn ra ở Phòng 1 (Chưa chắc chắn, vì H1, H2 có thể ở P1 Thứ 4 hoặc P2 Thứ 3).

**Chọn B.**`,
    hint1: `Dùng lịch trình chủ đề đã thiết lập: P1(Thứ 3) là E, P2(Thứ 2) là E. Nếu E2 ở Thứ 3 thì nó thuộc phòng nào?`,
    hint2: `E2 ở Thứ 3 thì bắt buộc E2 ở Phòng 1. Vậy E3 phải nằm ở ô Kinh tế còn lại là Phòng 2 (Thứ 2).`,
    estimatedSeconds: 30,
    tags: ["logic"]
  },
  {
    id: 'logic_142',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Bài tập rèn luyện tổng hợp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 33 đến 36:`,
    passageText: `Một hội thảo có 3 phòng (Phòng 1, Phòng 2, Phòng 3) và diễn ra trong 3 ngày liên tiếp (Thứ 2,
Thứ 3, Thứ 4). Có 9 bài diễn thuyết được chia thành 3 chủ đề: Kinh tế (E1, E2, E3), Công nghệ
(T1, T2, T3), và Y tế (H1, H2, H3). Mỗi phòng có đúng 1 bài diễn thuyết mỗi ngày (tổng cộng 9
bài xếp vào ma trận 3x3). Mỗi bài diễn thuyết chỉ được trình bày đúng 1 lần. Việc xếp lịch tuân
theo quy định:
• Mỗi ngày phải có đủ cả 3 chủ đề (Kinh tế, Công nghệ, Y tế).
• Mỗi phòng phải có đủ cả 3 chủ đề trong suốt 3 ngày của hội thảo.
• T1 diễn ra ở Phòng 1 vào Thứ 2.
• H3 diễn ra ở Phòng 3 vào Thứ 2.
• E1 diễn ra ngay sau ngày của T2 và tại cùng một phòng với T2.`,
    stem: `Khẳng định nào sau đây KHÔNG THỂ xảy ra?`,
    choices: [
      { id: 'A', text: `Phòng 2 tổ chức bài diễn thuyết Kinh tế vào Thứ 2.` },
      { id: 'B', text: `Phòng 1 tổ chức bài diễn thuyết Y tế vào Thứ 4.` },
      { id: 'C', text: `Phòng 3 tổ chức bài diễn thuyết Công nghệ vào Thứ 4.` },
      { id: 'D', text: `Phòng 2 tổ chức bài diễn thuyết Y tế vào Thứ 3.` },
    ],
    answer: 'C',
    solution: `Dựa vào bảng lịch trình phân bố chủ đề đã suy luận:
P1: Thứ 2 (T), Thứ 3 (E), Thứ 4 (H)
P2: Thứ 2 (E), Thứ 3 (H), Thứ 4 (T)
P3: Thứ 2 (H), Thứ 3 (T), Thứ 4 (E)
Kiểm tra các đáp án:
A. Phòng 2 tổ chức Kinh tế vào Thứ 2 (Đúng, E ở P2).
B. Phòng 1 tổ chức Y tế vào Thứ 4 (Đúng, H ở P1).
C. Phòng 3 tổ chức Công nghệ vào Thứ 4 (Sai, vì Thứ 4 Phòng 3 BẮT BUỘC tổ chức Kinh tế - bài E1).
D. Phòng 2 tổ chức Y tế vào Thứ 3 (Đúng, H ở P2).
Khẳng định C là KHÔNG THỂ XẢY RA.

**Chọn C.**`,
    hint1: `Nhìn vào lịch trình chủ đề của 3 phòng trong 3 ngày đã lập ở câu đầu tiên của đoạn.`,
    hint2: `Phòng 3 vào Thứ 4 là bài E1 (Kinh tế), nên không thể là bài diễn thuyết Công nghệ.`,
    estimatedSeconds: 30,
    tags: ["logic"]
  },
  {
    id: 'logic_143',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Bài tập rèn luyện tổng hợp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 33 đến 36:`,
    passageText: `Một hội thảo có 3 phòng (Phòng 1, Phòng 2, Phòng 3) và diễn ra trong 3 ngày liên tiếp (Thứ 2,
Thứ 3, Thứ 4). Có 9 bài diễn thuyết được chia thành 3 chủ đề: Kinh tế (E1, E2, E3), Công nghệ
(T1, T2, T3), và Y tế (H1, H2, H3). Mỗi phòng có đúng 1 bài diễn thuyết mỗi ngày (tổng cộng 9
bài xếp vào ma trận 3x3). Mỗi bài diễn thuyết chỉ được trình bày đúng 1 lần. Việc xếp lịch tuân
theo quy định:
• Mỗi ngày phải có đủ cả 3 chủ đề (Kinh tế, Công nghệ, Y tế).
• Mỗi phòng phải có đủ cả 3 chủ đề trong suốt 3 ngày của hội thảo.
• T1 diễn ra ở Phòng 1 vào Thứ 2.
• H3 diễn ra ở Phòng 3 vào Thứ 2.
• E1 diễn ra ngay sau ngày của T2 và tại cùng một phòng với T2.`,
    stem: `Có nhiều nhất bao nhiêu lịch trình diễn thuyết khác nhau thỏa mãn toàn bộ các điều kiện
của hội thảo?`,
    choices: [
      { id: 'A', text: `2.` },
      { id: 'B', text: `4.` },
      { id: 'C', text: `6.` },
      { id: 'D', text: `8.` },
    ],
    answer: 'B',
    solution: `Từ các câu trên, ta có khung lịch trình các vị trí cố định của các bài:
- P1: T1(2), E_z(3), H_y(4)
- P2: E_u(2), H_v(3), T3(4)
- P3: H3(2), T2(3), E1(4)
Các bài diễn thuyết T1, T2, T3, H3, E1 đã được cố định hoàn toàn về ngày và phòng.
Các bài còn lại cần phân bổ:
- Bài Kinh tế (E2, E3): Cần điền vào 2 vị trí là E_z (P1 Thứ 3) và E_u (P2 Thứ 2). Có 2 cách sắp xếp (E2-E3 hoặc E3-E2).
- Bài Y tế (H1, H2): Cần điền vào 2 vị trí là H_y (P1 Thứ 4) và H_v (P2 Thứ 3). Có 2 cách sắp xếp (H1-H2 hoặc H2-H1).
Hai nhóm này độc lập với nhau, nên tổng số lịch trình có thể tạo ra là: 2 × 2 = 4 lịch trình khác nhau.

**Chọn B (4).**`,
    hint1: `Xác định các bài nào đã bị cố định hoàn toàn, các bài nào còn có thể hoán đổi vị trí.`,
    hint2: `Nhóm T đã cố định. H3, E1 cố định. Còn E2, E3 hoán vị vào 2 chỗ (2 cách). H1, H2 hoán vị vào 2 chỗ (2 cách). Tổng cộng 2 x 2 = 4 cách.`,
    estimatedSeconds: 45,
    tags: ["logic"]
  },
  {
    id: 'logic_144',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Bài tập rèn luyện tổng hợp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 37 đến 40:`,
    passageText: `Có 6 vận động viên (A, B, C, D, E, F) tham gia một cuộc thi chạy tiếp sức. Mỗi người chạy đúng
một chặng từ chặng 1 đến chặng 6. Ngoài ra, mỗi người được cấp một mã số nhận diện (1, 2, 3,
4, 5, 6) không ai trùng ai. Việc phân công chặng chạy và mã số tuân theo các quy định sau:
• A có mã số nhận diện lớn nhất trong nhóm.
• Mã số của F là một số chẵn.
• Mã số của C lớn hơn mã số của B đúng 3 đơn vị.
• Mã số của F bằng tổng mã số của D và E.
• A chạy chặng số 3.
• Vận động viên có mã số là 5 chạy chặng số 5.
• E chạy ngay sau D (E là chặng tiếp theo của D).
• Vận động viên chạy chặng 1 có mã số lớn hơn vận động viên chạy chặng 2.
• Vận động viên chạy chặng cuối cùng (chặng 6) có mã số lớn hơn người chạy chặng 4.`,
    stem: `Mã số nhận diện của F là bao nhiêu?`,
    choices: [
      { id: 'A', text: `2.` },
      { id: 'B', text: `4.` },
      { id: 'C', text: `5.` },
      { id: 'D', text: `6.` },
    ],
    answer: 'B',
    solution: `Phân tích mã số của 6 vận động viên (1 đến 6):
- Mã(A) lớn nhất -> Mã(A) = 6.
- Mã(F) là số chẵn -> Mã(F) có thể là 2, 4 (loại 6 vì A lấy rồi).
- Mã(F) = Mã(D) + Mã(E). Nếu Mã(F) = 2 thì D+E=2 (vô lý vì không có 2 số nguyên dương khác nhau cộng lại bằng 2). 
  Vậy Mã(F) = 4. Suy ra cặp {Mã(D), Mã(E)} = {1, 3}.
- Mã(C) - Mã(B) = 3. Hai mã số còn lại là 2 và 5. Để thỏa mãn, Mã(C) = 5 và Mã(B) = 2.
Vậy Mã số của F là 4.

**Chọn B.**`,
    hint1: `Bắt đầu từ mã của A là lớn nhất. Sau đó tìm mã của F (số chẵn) dựa vào điều kiện tổng của D và E.`,
    hint2: `A = 6. F là số chẵn nên F = 2 hoặc 4. Nhưng F = D + E, 2 không thể là tổng của 2 số nguyên dương phân biệt, nên F = 4 (tổng của 1 và 3).`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_145',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Bài tập rèn luyện tổng hợp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 37 đến 40:`,
    passageText: `Có 6 vận động viên (A, B, C, D, E, F) tham gia một cuộc thi chạy tiếp sức. Mỗi người chạy đúng
một chặng từ chặng 1 đến chặng 6. Ngoài ra, mỗi người được cấp một mã số nhận diện (1, 2, 3,
4, 5, 6) không ai trùng ai. Việc phân công chặng chạy và mã số tuân theo các quy định sau:
• A có mã số nhận diện lớn nhất trong nhóm.
• Mã số của F là một số chẵn.
• Mã số của C lớn hơn mã số của B đúng 3 đơn vị.
• Mã số của F bằng tổng mã số của D và E.
• A chạy chặng số 3.
• Vận động viên có mã số là 5 chạy chặng số 5.
• E chạy ngay sau D (E là chặng tiếp theo của D).
• Vận động viên chạy chặng 1 có mã số lớn hơn vận động viên chạy chặng 2.
• Vận động viên chạy chặng cuối cùng (chặng 6) có mã số lớn hơn người chạy chặng 4.`,
    stem: `Vận động viên nào chạy chặng số 1?`,
    choices: [
      { id: 'A', text: `D.` },
      { id: 'B', text: `E.` },
      { id: 'C', text: `B.` },
      { id: 'D', text: `F.` },
    ],
    answer: 'A',
    solution: `Phân tích vị trí chặng chạy dựa trên mã số đã tìm được:
A=6, B=2, C=5, D,E thuộc {1,3}, F=4.
- A chạy chặng 3.
- C (mã số 5) chạy chặng 5.
- E chạy ngay sau D, tức là D ở chặng i thì E ở i+1.
Các chặng trống là 1, 2, 4, 6. Chỗ trống liên tiếp duy nhất để xếp D và E là chặng 1 và 2. 
Vậy D chạy chặng 1, E chạy chặng 2.
- Người chạy chặng 1 có mã lớn hơn người chạy chặng 2 -> Mã(D) > Mã(E). Vậy Mã(D) = 3, Mã(E) = 1.
- Chặng 4 và 6 còn lại B (mã 2) và F (mã 4).
- Người chạy chặng 6 có mã lớn hơn người chạy chặng 4. Vì 4 > 2 nên F (mã 4) chạy chặng 6, B (mã 2) chạy chặng 4.
Vậy người chạy chặng 1 là D.

**Chọn A.**`,
    hint1: `A chạy chặng 3, C(mã 5) chạy chặng 5. D và E chạy liên tiếp nhau thì chỉ có thể xếp vào chặng mấy?`,
    hint2: `Khoảng trống liên tiếp duy nhất là chặng 1 và 2. Vậy D chạy chặng 1, E chạy chặng 2.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_146',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Bài tập rèn luyện tổng hợp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 37 đến 40:`,
    passageText: `Có 6 vận động viên (A, B, C, D, E, F) tham gia một cuộc thi chạy tiếp sức. Mỗi người chạy đúng
một chặng từ chặng 1 đến chặng 6. Ngoài ra, mỗi người được cấp một mã số nhận diện (1, 2, 3,
4, 5, 6) không ai trùng ai. Việc phân công chặng chạy và mã số tuân theo các quy định sau:
• A có mã số nhận diện lớn nhất trong nhóm.
• Mã số của F là một số chẵn.
• Mã số của C lớn hơn mã số của B đúng 3 đơn vị.
• Mã số của F bằng tổng mã số của D và E.
• A chạy chặng số 3.
• Vận động viên có mã số là 5 chạy chặng số 5.
• E chạy ngay sau D (E là chặng tiếp theo của D).
• Vận động viên chạy chặng 1 có mã số lớn hơn vận động viên chạy chặng 2.
• Vận động viên chạy chặng cuối cùng (chặng 6) có mã số lớn hơn người chạy chặng 4.`,
    stem: `Khẳng định nào sau đây là SAI?`,
    choices: [
      { id: 'A', text: `C chạy chặng số 5 và có mã số là 5.` },
      { id: 'B', text: `Mã số của A là 6.` },
      { id: 'C', text: `F chạy trước B.` },
      { id: 'D', text: `D có mã số là 3.` },
    ],
    answer: 'C',
    solution: `Từ kết quả phân tích:
- Chặng 1: D (3)
- Chặng 2: E (1)
- Chặng 3: A (6)
- Chặng 4: B (2)
- Chặng 5: C (5)
- Chặng 6: F (4)
Kiểm tra các đáp án:
A. C chạy chặng 5 và mã số 5 (Đúng).
B. Mã số của A là 6 (Đúng).
C. F chạy trước B (Sai, F chạy chặng 6 còn B chạy chặng 4, nên F chạy sau B).
D. D có mã số là 3 (Đúng).
Khẳng định C là SAI.

**Chọn C.**`,
    hint1: `Dùng bảng phân công chặng và mã số đã tìm được ở các câu trên để rà soát.`,
    hint2: `F chạy chặng 6 và B chạy chặng 4, vậy F phải chạy sau B. Khẳng định F chạy trước B là sai.`,
    estimatedSeconds: 30,
    tags: ["logic"]
  },
  {
    id: 'logic_147',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Bài tập rèn luyện tổng hợp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 37 đến 40:`,
    passageText: `Có 6 vận động viên (A, B, C, D, E, F) tham gia một cuộc thi chạy tiếp sức. Mỗi người chạy đúng
một chặng từ chặng 1 đến chặng 6. Ngoài ra, mỗi người được cấp một mã số nhận diện (1, 2, 3,
4, 5, 6) không ai trùng ai. Việc phân công chặng chạy và mã số tuân theo các quy định sau:
• A có mã số nhận diện lớn nhất trong nhóm.
• Mã số của F là một số chẵn.
• Mã số của C lớn hơn mã số của B đúng 3 đơn vị.
• Mã số của F bằng tổng mã số của D và E.
• A chạy chặng số 3.
• Vận động viên có mã số là 5 chạy chặng số 5.
• E chạy ngay sau D (E là chặng tiếp theo của D).
• Vận động viên chạy chặng 1 có mã số lớn hơn vận động viên chạy chặng 2.
• Vận động viên chạy chặng cuối cùng (chặng 6) có mã số lớn hơn người chạy chặng 4.`,
    stem: `Hiệu số giữa mã số nhận diện của người chạy chặng 3 và người chạy chặng 6 là bao nhiêu?`,
    choices: [
      { id: 'A', text: `1.` },
      { id: 'B', text: `2.` },
      { id: 'C', text: `3.` },
      { id: 'D', text: `4.` },
    ],
    answer: 'B',
    solution: `Dựa trên bảng kết quả phân công:
- Người chạy chặng 3 là A, có mã số nhận diện là 6.
- Người chạy chặng 6 là F, có mã số nhận diện là 4.
Hiệu số giữa hai mã số này là: 6 - 4 = 2.

**Chọn B.**`,
    hint1: `Ai chạy chặng 3 và ai chạy chặng 6? Mã số của họ tương ứng là bao nhiêu?`,
    hint2: `Chặng 3 là A (mã 6), chặng 6 là F (mã 4). Lấy 6 trừ đi 4.`,
    estimatedSeconds: 30,
    tags: ["logic"]
  },
  {
    id: 'logic_148',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Bài tập rèn luyện tổng hợp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 41 đến 45:`,
    passageText: `Chín chuyên gia A, B, C, D, E, F, G, H và K được phân công vào 3 dự án khác nhau. Một dự
án Tối mật (cần 4 người), một dự án Quan trọng (cần 3 người), một dự án Thường quy (cần
2 người). Việc phân công thỏa mãn các điều kiện sau:
• C tham gia dự án Tối mật (4 người) và D tham gia dự án Quan trọng (3 người).
• C và K không thể cùng chung một dự án.
• H và B không thể cùng chung một dự án.
• G và F phải cùng chung một dự án.`,
    stem: `Nếu D, E, H cùng tham gia dự án Quan trọng thì điều nào sau đây phải đúng?`,
    choices: [
      { id: 'A', text: `F phải cùng dự án với B.` },
      { id: 'B', text: `K phải cùng dự án Thường quy với A hoặc C.` },
      { id: 'C', text: `K phải cùng dự án Thường quy với B hoặc A.` },
      { id: 'D', text: `C phải cùng dự án Tối mật với F, G và A.` },
    ],
    answer: 'C',
    solution: `Phân tích:
- Dự án Tối mật (TM - 4): đã có C (còn 3).
- Dự án Quan trọng (QT - 3): đã có D, E, H (đủ 3 người). 
- Dự án Thường quy (TQ - 2): còn 2 chỗ.
Vì QT đã đủ 3 người nên K không thể vào QT. K cũng không thể vào TM do không cùng C. Suy ra K BẮT BUỘC vào TQ. (K ∈ TQ).
H ∈ QT. B không được cùng H nên B ∉ QT. B phải vào TM hoặc TQ.
Nhóm F, G phải cùng nhau (2 người). TQ chỉ còn 1 chỗ (vì K đã chiếm 1). Vậy F, G BẮT BUỘC vào TM.
TM hiện có C, F, G (còn 1 chỗ). TQ có K (còn 1 chỗ).
Còn lại A, B sẽ chia nhau vào 2 chỗ trống này (1 vào TM, 1 vào TQ).
Do đó, K sẽ cùng dự án Thường quy với A hoặc B.
Khẳng định C là CHẮC CHẮN ĐÚNG.

**Chọn C.**`,
    hint1: `Quan trọng (D, E, H) đã đủ 3 người. K không vào Tối mật (vì có C), nên K bắt buộc vào đâu?`,
    hint2: `K vào Thường quy. H vào Quan trọng nên B không vào Quan trọng. F, G (2 người) không thể vào Thường quy (chỉ còn 1 chỗ do K chiếm) nên F, G vào Tối mật. Chỗ Thường quy còn lại dành cho A hoặc B.`,
    estimatedSeconds: 90,
    tags: ["logic"]
  },
  {
    id: 'logic_149',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Bài tập rèn luyện tổng hợp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 41 đến 45:`,
    passageText: `Chín chuyên gia A, B, C, D, E, F, G, H và K được phân công vào 3 dự án khác nhau. Một dự
án Tối mật (cần 4 người), một dự án Quan trọng (cần 3 người), một dự án Thường quy (cần
2 người). Việc phân công thỏa mãn các điều kiện sau:
• C tham gia dự án Tối mật (4 người) và D tham gia dự án Quan trọng (3 người).
• C và K không thể cùng chung một dự án.
• H và B không thể cùng chung một dự án.
• G và F phải cùng chung một dự án.`,
    stem: `Nếu D và A cùng tham gia dự án Quan trọng (3 người) thì những ai sau đây CHẮC CHẮN
phải tham gia cùng dự án với C?`,
    choices: [
      { id: 'A', text: `B và F.` },
      { id: 'B', text: `F và G.` },
      { id: 'C', text: `H và G.` },
      { id: 'D', text: `H và E.` },
    ],
    answer: 'B',
    solution: `Phân tích:
- TM(4): có C (còn 3).
- QT(3): có D, A (còn 1).
- TQ(2): còn 2.
Nhóm {F, G} (2 người) phải đi cùng nhau. QT chỉ còn 1 chỗ nên {F, G} không thể vào QT.
Nếu {F, G} vào TQ: TQ full. Khi đó, H, B, E, K phải chia vào TM (3 chỗ) và QT (1 chỗ).
Vì C ∈ TM, K không thể vào TM -> K bắt buộc vào QT.
Vậy QT full (D, A, K). H, B, E bắt buộc vào TM.
Nhưng H và B không được cùng dự án. Nếu cả hai cùng vào TM thì vi phạm điều kiện!
Vậy giả thiết {F, G} vào TQ là vô lý.
Suy ra, {F, G} BẮT BUỘC vào TM (cùng dự án với C).
Do đó, F và G chắc chắn phải tham gia cùng C.

**Chọn B.**`,
    hint1: `QT đã có D, A (còn 1). F, G đi cùng nhau (2 người) nên F, G không thể vào QT. Nếu F, G vào Thường quy thì sao?`,
    hint2: `Nếu F, G vào Thường quy (2 chỗ) thì TQ đầy. K không vào Tối mật nên K vào QT (1 chỗ còn lại). Khi đó H, B phải cùng bị đẩy vào Tối mật, vi phạm quy định H và B không đi cùng. Do đó F, G bắt buộc vào Tối mật.`,
    estimatedSeconds: 90,
    tags: ["logic"]
  },
  {
    id: 'logic_150',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Bài tập rèn luyện tổng hợp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 41 đến 45:`,
    passageText: `Chín chuyên gia A, B, C, D, E, F, G, H và K được phân công vào 3 dự án khác nhau. Một dự
án Tối mật (cần 4 người), một dự án Quan trọng (cần 3 người), một dự án Thường quy (cần
2 người). Việc phân công thỏa mãn các điều kiện sau:
• C tham gia dự án Tối mật (4 người) và D tham gia dự án Quan trọng (3 người).
• C và K không thể cùng chung một dự án.
• H và B không thể cùng chung một dự án.
• G và F phải cùng chung một dự án.`,
    stem: `Nếu C và E cùng chung dự án và K tham gia dự án Thường quy thì có bao nhiêu cách
phân công nhân sự?`,
    choices: [
      { id: 'A', text: `4.` },
      { id: 'B', text: `3.` },
      { id: 'C', text: `2.` },
      { id: 'D', text: `1.` },
    ],
    answer: 'A',
    solution: `Phân tích:
- TM(4): C, E (còn 2).
- QT(3): D (còn 2).
- TQ(2): K (còn 1).
Nhóm {F, G} (2 người) đi cùng nhau. Không thể vào TQ (chỉ còn 1). Nên {F, G} vào TM hoặc QT.
- TH1: {F, G} vào TM. 
  TM full (C, E, F, G). Còn lại H, B, A phải phân vào QT (2 chỗ) và TQ (1 chỗ).
  H, B không cùng dự án, nên không thể cùng vào QT. Vậy 1 người vào TQ, 1 người vào QT. A vào QT.
  Số cách: H hoặc B vào TQ (2 cách).
- TH2: {F, G} vào QT.
  QT full (D, F, G). Còn lại H, B, A phải phân vào TM (2 chỗ) và TQ (1 chỗ).
  Tương tự, H và B không thể cùng vào TM, nên 1 người vào TQ, 1 người vào TM. A vào TM.
  Số cách: H hoặc B vào TQ (2 cách).
Tổng số cách phân công = 2 + 2 = 4 cách.

**Chọn A (4).**`,
    hint1: `F, G đi cùng nhau (2 người) nên không thể vào Thường quy (đã có K, chỉ còn 1 chỗ). F, G có thể vào Tối mật hoặc Quan trọng.`,
    hint2: `Nếu F, G vào TM (2 cách chia H,B), nếu F, G vào QT (2 cách chia H,B). Tổng là 4 cách.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_151',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Bài tập rèn luyện tổng hợp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 41 đến 45:`,
    passageText: `Chín chuyên gia A, B, C, D, E, F, G, H và K được phân công vào 3 dự án khác nhau. Một dự
án Tối mật (cần 4 người), một dự án Quan trọng (cần 3 người), một dự án Thường quy (cần
2 người). Việc phân công thỏa mãn các điều kiện sau:
• C tham gia dự án Tối mật (4 người) và D tham gia dự án Quan trọng (3 người).
• C và K không thể cùng chung một dự án.
• H và B không thể cùng chung một dự án.
• G và F phải cùng chung một dự án.`,
    stem: `Nếu C và H không cùng dự án và dự án Thường quy gồm hai người là K và A thì C sẽ:`,
    choices: [
      { id: 'A', text: `cùng dự án với F, B và G.` },
      { id: 'B', text: `cùng dự án với B nhưng không cùng G.` },
      { id: 'C', text: `cùng dự án với B và E.` },
      { id: 'D', text: `cùng dự án với F và G.` },
    ],
    answer: 'A',
    solution: `Phân tích:
- TQ(2) = {K, A} (đã full).
- TM(4): có C (còn 3).
- QT(3): có D (còn 2).
Nhóm {F, G} (2 người) không thể vào TQ (đã full) hay QT (nếu vào QT thì QT full, 3 người B, E, H vào TM -> H và B cùng TM, sai).
Do đó, {F, G} BẮT BUỘC vào TM.
TM đã có {C, F, G}, còn 1 chỗ. 
Người còn lại B, E, H. Phải chia 1 vào TM, 2 vào QT.
Đề bài cho: "C và H không cùng dự án", tức là H ∉ TM. Do H và B không cùng dự án, H và B chia nhau vào TM và QT. 
Vì H ∉ TM nên H BẮT BUỘC vào QT. Do đó B BẮT BUỘC vào TM. E vào QT.
Kết quả: TM = {C, F, G, B}, QT = {D, H, E}.
Vậy C cùng dự án với F, B và G.

**Chọn A.**`,
    hint1: `Thường quy đủ 2 người (K, A). Chứng minh F, G phải vào Tối mật để tránh việc B, H cùng vào Tối mật.`,
    hint2: `Tối mật còn 1 chỗ cho H hoặc B. Vì C và H không cùng dự án nên H bị đẩy sang Quan trọng, nhường chỗ Tối mật lại cho B. Vậy Tối mật gồm C, F, G, B.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_152',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Bài tập rèn luyện tổng hợp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 41 đến 45:`,
    passageText: `Chín chuyên gia A, B, C, D, E, F, G, H và K được phân công vào 3 dự án khác nhau. Một dự
án Tối mật (cần 4 người), một dự án Quan trọng (cần 3 người), một dự án Thường quy (cần
2 người). Việc phân công thỏa mãn các điều kiện sau:
• C tham gia dự án Tối mật (4 người) và D tham gia dự án Quan trọng (3 người).
• C và K không thể cùng chung một dự án.
• H và B không thể cùng chung một dự án.
• G và F phải cùng chung một dự án.`,
    stem: `Nếu H cùng dự án với C và E thì K BẮT BUỘC phải cùng dự án với ai?`,
    choices: [
      { id: 'A', text: `B.` },
      { id: 'B', text: `B và A.` },
      { id: 'C', text: `A.` },
      { id: 'D', text: `B và D.` },
    ],
    answer: 'A',
    solution: `Phân tích:
- TM(4): đã có {C, H, E} (còn 1).
Vì {F, G} đi cùng nhau (2 người), không thể nhét vào TM (chỉ còn 1). Nên {F, G} không vào TM.
- Các người còn lại để điền nốt vào TM: K (không cùng C, loại), B (không cùng H, loại), D (thuộc QT, loại).
Người duy nhất còn lại là A. Vậy A BẮT BUỘC vào TM. TM = {C, H, E, A} (full).
Các người chưa xếp: {F, G} (đi chung), K, B.
Các slot trống: QT(2 chỗ do có D), TQ(2 chỗ).
- TH1: {F, G} vào QT -> QT = {D, F, G}. TQ = {K, B}. K cùng dự án với B.
- TH2: {F, G} vào TQ -> TQ = {F, G}. QT = {D, K, B}. K cùng dự án với B (và D).
Ở cả 2 trường hợp, K đều BẮT BUỘC cùng dự án với B. (A đã ở TM nên không thể, D chỉ xảy ra ở 1 TH).

**Chọn A.**`,
    hint1: `Tìm xem ai là người thứ tư điền vào Tối mật? (Loại F, G, K, B, D).`,
    hint2: `A bắt buộc vào Tối mật. 4 người còn lại (F, G, K, B) chia vào Quan trọng (2 chỗ) và Thường quy (2 chỗ). Vì F, G đi chung nên K và B bắt buộc phải đi chung vào dự án còn lại.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_153',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Bài tập rèn luyện tổng hợp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 46 đến 50:`,
    passageText: `Có 5 chiếc laptop (A, B, C, D, E) và 3 chiếc điện thoại (P, Q, R).
• A là chiếc laptop có tốc độ xử lý nhanh nhất và R là chiếc điện thoại có tốc độ xử lý
chậm nhất.
• Về giá cả, C đắt hơn D và Q nhưng rẻ hơn B.
• Trong số các laptop, A không phải là chiếc đắt nhất, D rẻ hơn E và không có chiếc laptop
nào có giá nằm giữa giá của hai chiếc này.
• Về tốc độ xử lý, E chạy nhanh hơn ba chiếc laptop còn lại và nhanh hơn tất cả các điện
thoại.
• Điện thoại Q đắt hơn R nhưng rẻ hơn P. Điện thoại P xử lý nhanh hơn Q.`,
    stem: `Trong số các laptop sau đây, laptop nào chắc chắn KHÔNG xếp ở vị trí chính giữa (vị trí
thứ 3) về giá cả trong 5 chiếc laptop?`,
    choices: [
      { id: 'A', text: `A.` },
      { id: 'B', text: `C.` },
      { id: 'C', text: `E.` },
      { id: 'D', text: `D.` },
    ],
    answer: 'D',
    solution: `Phân tích thứ tự giá của các laptop (A, B, C, D, E):
- C đắt hơn D và Q nhưng rẻ hơn B => Giá của B > C > D.
- E đắt hơn D và không có laptop nào nằm giữa E và D => E và D đứng liền kề nhau trong các laptop.
Vì B > C > D nên E phải nằm trên D. Nếu E đứng trên C (tức E > C) thì giữa E và D có C (vi phạm vì E, D kề nhau). Do đó, C > E > D.
Thứ tự giá 4 chiếc là B > C > E > D.
- A không phải đắt nhất, nên A không thể đứng vị trí đầu (trên B). 
Vị trí của A có thể là:
(1) B > A > C > E > D (A xếp thứ 2, thứ 3 là C)
(2) B > C > A > E > D (A xếp thứ 3)
(3) B > C > E > D > A (A xếp thứ 5, thứ 3 là E)
Lưu ý A không thể xen giữa E và D.
Như vậy, các laptop có thể xếp vị trí chính giữa (thứ 3) là C, A, E.
Laptop D luôn xếp thứ 4 hoặc thứ 5 nên CHẮC CHẮN KHÔNG xếp ở vị trí thứ 3.

**Chọn D.**`,
    hint1: `Phân tích thứ tự giá: B > C > D. E đắt hơn D và liền kề D (trong nhóm laptop) nên bắt buộc C > E > D. A không phải đắt nhất nên A xếp từ vị trí thứ 2 trở xuống.`,
    hint2: `Các vị trí xếp của A có thể tạo ra các bảng giá: B>A>C>E>D (C thứ 3), B>C>A>E>D (A thứ 3), B>C>E>D>A (E thứ 3). Vậy D không bao giờ đứng thứ 3.`,
    estimatedSeconds: 60,
    tags: ["logic"]
  },
  {
    id: 'logic_154',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Bài tập rèn luyện tổng hợp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 46 đến 50:`,
    passageText: `Có 5 chiếc laptop (A, B, C, D, E) và 3 chiếc điện thoại (P, Q, R).
• A là chiếc laptop có tốc độ xử lý nhanh nhất và R là chiếc điện thoại có tốc độ xử lý
chậm nhất.
• Về giá cả, C đắt hơn D và Q nhưng rẻ hơn B.
• Trong số các laptop, A không phải là chiếc đắt nhất, D rẻ hơn E và không có chiếc laptop
nào có giá nằm giữa giá của hai chiếc này.
• Về tốc độ xử lý, E chạy nhanh hơn ba chiếc laptop còn lại và nhanh hơn tất cả các điện
thoại.
• Điện thoại Q đắt hơn R nhưng rẻ hơn P. Điện thoại P xử lý nhanh hơn Q.`,
    stem: `Phát biểu nào sau đây là đúng khi so sánh 3 chiếc điện thoại?`,
    choices: [
      { id: 'A', text: `P là chiếc điện thoại đắt nhất và cũng xử lý nhanh nhất.` },
      { id: 'B', text: `Chiếc điện thoại xử lý nhanh nhất không phải là chiếc đắt nhất.` },
      { id: 'C', text: `Chiếc điện thoại xử lý chậm nhất cũng là chiếc rẻ nhất.` },
      { id: 'D', text: `Cả A và C đều đúng.` },
    ],
    answer: 'D',
    solution: `Phân tích các điện thoại P, Q, R:
- Về tốc độ xử lý: P nhanh hơn Q. R là điện thoại xử lý chậm nhất. Vậy tốc độ là P > Q > R.
- Về giá cả: Q đắt hơn R nhưng rẻ hơn P. Vậy giá cả là P > Q > R.
Kiểm tra các phát biểu:
A. P là điện thoại đắt nhất và xử lý nhanh nhất. (Đúng, theo 2 dãy trên).
B. Điện thoại xử lý nhanh nhất không phải chiếc đắt nhất. (Sai, vì P đứng đầu cả hai).
C. Điện thoại xử lý chậm nhất (R) cũng là chiếc rẻ nhất (R). (Đúng).
Vậy cả A và C đều đúng.

**Chọn D.**`,
    hint1: `Lập dãy thứ tự tốc độ xử lý và thứ tự giá cả của 3 điện thoại P, Q, R để so sánh.`,
    hint2: `Tốc độ: P > Q > R. Giá: P > Q > R. Vậy A và C đều đúng.`,
    estimatedSeconds: 30,
    tags: ["logic"]
  },
  {
    id: 'logic_155',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Bài tập rèn luyện tổng hợp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 46 đến 50:`,
    passageText: `Có 5 chiếc laptop (A, B, C, D, E) và 3 chiếc điện thoại (P, Q, R).
• A là chiếc laptop có tốc độ xử lý nhanh nhất và R là chiếc điện thoại có tốc độ xử lý
chậm nhất.
• Về giá cả, C đắt hơn D và Q nhưng rẻ hơn B.
• Trong số các laptop, A không phải là chiếc đắt nhất, D rẻ hơn E và không có chiếc laptop
nào có giá nằm giữa giá của hai chiếc này.
• Về tốc độ xử lý, E chạy nhanh hơn ba chiếc laptop còn lại và nhanh hơn tất cả các điện
thoại.
• Điện thoại Q đắt hơn R nhưng rẻ hơn P. Điện thoại P xử lý nhanh hơn Q.`,
    stem: `Nếu điện thoại P đắt hơn laptop E thì có bao nhiêu chiếc laptop chắc chắn rẻ hơn P?`,
    choices: [
      { id: 'A', text: `1.` },
      { id: 'B', text: `2.` },
      { id: 'C', text: `3.` },
      { id: 'D', text: `Chưa đủ dữ kiện để xác định.` },
    ],
    answer: 'B',
    solution: `Đề cho: Điện thoại P đắt hơn laptop E (Giá P > Giá E).
Từ phân tích câu trước, ta biết thứ tự giá của các laptop là B > C > E > D (trong đó E và D kề nhau trong nhóm laptop).
Nên Giá E > Giá D.
Kết hợp lại ta có: Giá P > Giá E > Giá D.
Vậy chắc chắn có 2 chiếc laptop rẻ hơn P là E và D.
Đối với A, B, C, ta không có đủ thông tin để biết giá của chúng đắt hơn hay rẻ hơn P, nên chỉ kết luận được chắc chắn 2 chiếc.

**Chọn B (2).**`,
    hint1: `Kết hợp P đắt hơn E với dãy thứ tự giá của các laptop: B > C > E > D.`,
    hint2: `Vì P > E, mà E > D nên P chắc chắn đắt hơn E và D (2 chiếc). Không có thông tin để so sánh P với B, C, A.`,
    estimatedSeconds: 30,
    tags: ["logic"]
  },
  {
    id: 'logic_156',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Bài tập rèn luyện tổng hợp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 46 đến 50:`,
    passageText: `Có 5 chiếc laptop (A, B, C, D, E) và 3 chiếc điện thoại (P, Q, R).
• A là chiếc laptop có tốc độ xử lý nhanh nhất và R là chiếc điện thoại có tốc độ xử lý
chậm nhất.
• Về giá cả, C đắt hơn D và Q nhưng rẻ hơn B.
• Trong số các laptop, A không phải là chiếc đắt nhất, D rẻ hơn E và không có chiếc laptop
nào có giá nằm giữa giá của hai chiếc này.
• Về tốc độ xử lý, E chạy nhanh hơn ba chiếc laptop còn lại và nhanh hơn tất cả các điện
thoại.
• Điện thoại Q đắt hơn R nhưng rẻ hơn P. Điện thoại P xử lý nhanh hơn Q.`,
    stem: `Nếu điện thoại P rẻ hơn laptop A nhưng không đắt hơn laptop E thì trong tất cả 8 thiết
bị (laptop và điện thoại), thiết bị nào rẻ nhất?`,
    choices: [
      { id: 'A', text: `R.` },
      { id: 'B', text: `Q.` },
      { id: 'C', text: `E.` },
      { id: 'D', text: `Không xác định được.` },
    ],
    answer: 'D',
    solution: `Ta có thông tin về giá:
- Điện thoại: P > Q > R.
- Laptop: B > C > E > D. (E và D liền kề nhau trong tập các laptop, tức không có laptop nào chen giữa).
Đề cho: Giá P < Giá A và Giá P ≤ Giá E.
Từ P ≤ Giá E, kết hợp P > Q > R, ta được: E ≥ P > Q > R. Vậy trong nhóm E, P, Q, R thì R là rẻ nhất.
Đối với laptop D, ta biết Giá E > Giá D. 
Nhưng ta không có bất kỳ thông tin nào so sánh giữa laptop D và các điện thoại P, Q, R. D có thể rẻ hơn R, hoặc nằm giữa Q và R, hoặc nằm giữa P và Q... (miễn là không có laptop nào chen giữa E và D).
Do đó, không đủ dữ kiện để xác định D hay R (hay thiết bị khác) là thiết bị rẻ nhất trong tất cả 8 thiết bị.

**Chọn D.**`,
    hint1: `Viết các chuỗi bất đẳng thức giá cả để xem có thiết bị nào có thể so sánh chéo giữa hai nhóm laptop và điện thoại.`,
    hint2: `E ≥ P > Q > R. Còn laptop D rẻ hơn E, nhưng không có thông tin so sánh D với P, Q, R. Do đó không thể biết D hay R ai rẻ hơn.`,
    estimatedSeconds: 45,
    tags: ["logic"]
  },
  {
    id: 'logic_157',
    exam: 'VACT',
    domain: 'Toán Logic',
    topic: `Bài tập rèn luyện tổng hợp`,
    competency: ["Suy luận logic"],
    difficulty: 3,
    cognitiveLevel: 'M3',
    type: 'single-choice',
    passageTitle: `Dữ liệu cho câu 46 đến 50:`,
    passageText: `Có 5 chiếc laptop (A, B, C, D, E) và 3 chiếc điện thoại (P, Q, R).
• A là chiếc laptop có tốc độ xử lý nhanh nhất và R là chiếc điện thoại có tốc độ xử lý
chậm nhất.
• Về giá cả, C đắt hơn D và Q nhưng rẻ hơn B.
• Trong số các laptop, A không phải là chiếc đắt nhất, D rẻ hơn E và không có chiếc laptop
nào có giá nằm giữa giá của hai chiếc này.
• Về tốc độ xử lý, E chạy nhanh hơn ba chiếc laptop còn lại và nhanh hơn tất cả các điện
thoại.
• Điện thoại Q đắt hơn R nhưng rẻ hơn P. Điện thoại P xử lý nhanh hơn Q.`,
    stem: `Trong số các laptop sau đây, laptop nào có tốc độ xử lý chậm nhất nếu B và C xử lý nhanh
hơn D?`,
    choices: [
      { id: 'A', text: `B.` },
      { id: 'B', text: `D.` },
      { id: 'C', text: `C.` },
      { id: 'D', text: `E.` },
    ],
    answer: 'B',
    solution: `Phân tích thứ tự tốc độ xử lý của laptop:
- A là laptop có tốc độ nhanh nhất (A đứng đầu).
- E chạy nhanh hơn 3 laptop còn lại -> E đứng thứ 2.
Ba laptop còn lại là B, C, D. 
Đề cho: B và C đều xử lý nhanh hơn D.
Nghĩa là trong 3 chiếc (B, C, D) thì D chậm hơn cả B và C.
Vậy D xếp cuối cùng về tốc độ trong nhóm laptop.
Laptop xử lý chậm nhất là D.

**Chọn B.**`,
    hint1: `Sắp xếp tốc độ laptop: A nhanh nhất, kế tiếp là E (vì E nhanh hơn 3 chiếc kia). Còn lại B, C, D thì chiếc nào chậm hơn?`,
    hint2: `A > E > {B, C, D}. Vì B và C cùng nhanh hơn D nên D là chiếc chậm nhất.`,
    estimatedSeconds: 30,
    tags: ["logic"]
  },
]
